if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
window.scrollTo(0, 0);
// No beforeunload scrollTo(0,0): with scrollRestoration='manual' the page
// already loads at the top, and the bfcache/back case is handled by the
// pageshow(persisted) handler below. Resetting scroll on the way OUT only
// made ScrollSmoother render a visible jump toward the top (its content
// transform lags the native scroll) right before navigating away.
// Only reset to top on load if the user hasn't scrolled yet. `load` fires late
// on mobile (after the intro videos), so an unconditional scrollTo would yank a
// user who already started scrolling back to the top.
window.addEventListener('load', () => { if (window.scrollY < 2) window.scrollTo(0, 0); });
window.addEventListener('pageshow', (e) => {
  if (!e.persisted) return;
  window.scrollTo(0, 0);
  if (smoother) smoother.scrollTop(0);
});

const isDesktop = () => window.innerWidth > 568;

// ScrollSmoother instance (desktop only — created in ready() below). Mobile
// stays on native scroll: the mobile animations are built around native
// position:sticky and the iOS URL-bar behaviour, which the smoother's
// transformed content would break.
let smoother = null;

// Current visual scroll position. Under ScrollSmoother the content lags behind
// window.scrollY (the target), so anything that mixes getBoundingClientRect()
// with a scroll offset must use the SMOOTHED position or it drifts by the lag.
const pageScrollY = () => (smoother ? smoother.scrollTop() : window.scrollY);

// Document offset of an element, walking the offsetParent chain. Unlike
// getBoundingClientRect it ignores transforms, so it stays right for elements
// we're animating with GSAP (and doesn't need the scroll position at all).
const docOffsetTop = (el) => {
  let y = 0;
  for (let node = el; node; node = node.offsetParent) y += node.offsetTop;
  return y;
};

// Animated scroll that plays nice with the smoother: tween the smoother itself
// (one easing, no fight with the catch-up glide) instead of the native scroll.
// `target` is a number (px) or an element.
const scrollPageTo = (target, { duration = 1.2, ease = 'power3.inOut', onComplete } = {}) => {
  if (smoother) {
    const y = typeof target === 'number' ? target : smoother.offset(target, 'top top');
    gsap.to(smoother, { scrollTop: Math.max(0, y), duration, ease, onComplete });
    return;
  }
  gsap.to(window, {
    duration,
    scrollTo: { y: target, autoKill: false },
    ease,
    onComplete,
  });
};

// Page-level scroll lock (loader, video lightboxes, event detail). body.is-ovh
// alone isn't enough under ScrollSmoother: normalizeScroll intercepts
// wheel/touch and scrolls via JS, sidestepping overflow:hidden — pause the
// smoother too. Counted, so stacked overlays (a video lightbox opened on top
// of the event detail) don't unlock the page when only the inner one closes.
let pageScrollLocks = 0;
const lockPageScroll = (locked) => {
  pageScrollLocks = Math.max(0, pageScrollLocks + (locked ? 1 : -1));
  const on = pageScrollLocks > 0;
  document.body.classList.toggle('is-ovh', on);
  // html-level lock too — body overflow alone doesn't stop iOS Safari from
  // touch-scrolling the page underneath a fixed overlay.
  document.documentElement.classList.toggle('is-page-lock', on);
  if (smoother) smoother.paused(on);
};

$(document).ready(function () {
  window.scrollTo(0, 0);

  // Arriving straight into the events overlay (/#events or /#events/<slug>):
  // the events page is the preloader there, so the home curtain is dropped
  // before it starts — otherwise it would play under the overlay and fly its
  // logo onto the open event at the end.
  if (/^#events(\/|$)/.test(window.location.hash || '')) {
    const homeLoader = document.querySelector('.loader');
    if (homeLoader) homeLoader.remove();
  }

  // Don't refresh ScrollTrigger on resize (global). By default it refreshes on
  // every `resize`, and with all our invalidateOnRefresh triggers that re-runs
  // function-based values and snaps the layout — very janky, especially on
  // mobile where the Safari URL bar fires `resize` on almost every scroll.
  // Resize is rare here, so we just drop it from the auto-refresh events.
  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.config({
      ignoreMobileResize: true,
      autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load',
    });
  }

  // Smoothed scroll, desktop only. Must be created BEFORE any init below:
  // the html.has-smoother CSS (headline-pin absolute, sticky offs) has to be
  // in effect when the inits take their measurements, and the sticky→pin
  // stand-ins in initSmootherPins have to exist before dependent triggers.
  if (
    isDesktop() &&
    typeof gsap !== 'undefined' &&
    typeof ScrollSmoother !== 'undefined' &&
    document.querySelector('#smooth-wrapper #smooth-content')
  ) {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    document.documentElement.classList.add('has-smoother');
    smoother = ScrollSmoother.create({
      wrapper: '#smooth-wrapper',
      content: '#smooth-content',
      // Seconds the content takes to catch up to the native scroll — the whole
      // page's scroll tempo, and THE single global speed knob. Higher =
      // heavier/slower momentum (the premium agency glide); 1.0 read too
      // light/quick, so it's raised. Tune this one number up/down to taste.
      smooth: 1.6,
      smoothTouch: 0.6,
      ignoreMobileResize: true,
      normalizeScroll: true,
    });
    // The loader keeps body.is-ovh until it finishes — mirror the lock.
    if (document.body.classList.contains('is-ovh')) smoother.paused(true);
    initSmootherPins();
  }

  initLoader();
  initVideoExpand();
  initHeaderNav();
  initFooterButton();
  initMobileMenu();
  initAccessibleLabels();

  // Events page (events.html). All no-op on every other page.
  initEventsTitle();
  initEvents();
  initEventDetail();

  // The events page opens OVER the current page (an overlay with the events
  // page inside), and, when it is the one embedded, defers to its parent.
  initEventsOverlay();
  initEmbeddedPage();

  if (isDesktop()) {
    // Desktop: about is a pinned horizontal scroll (advances on vertical scroll).
    initAboutHorizontal();
    initDecSigns();
    initHeadlineScale();
    initLogoScale();
    initParallax();
    initReveal();
    initMalika();
    initSceneBg();
    initSupport();
    initInstagramFade();
    initYouCan();
    // Temporarily disabled together with the .what-we-do section.
    // initWhatWeDoTitle();
    // initWhatWeDo();
    initReviews();
    initReviewsHover();
  }

  if (!isDesktop()) {
    // Mobile: about is a native swipe slider (no pin, page scrolls past it).
    initAboutSliderMobile();
    initIntroMobile();
    // Pad .headline-1 so .intro + .headline-1 together fill one screen (100vh).
    initIntroHeadlineFill();
    // Header slides away on scroll down, comes back on scroll up.
    initHeaderHideMobile();
    initBeBestMobile();
    initMalikaMobile();
    initReviewsMobile();
    initSupportMobile();
    // Support items are a native swipe slider on mobile (about-style dots).
    initSupportSliderMobile();
    initInstagramFadeMobile();
    initYouCanMobile();
    // Malika beige is painted on a child of .scene-3 (radial reveal), never on
    // html/body — so the Safari bottom bar / safe-area stays white.
    initSceneBgMobile();
    // Radial black-background reveal between you-can and what-we-do (the same
    // expanding "dome" the desktop uses).
    // initWhatWeDoBgMobile();
    // Gentle internal parallax for the scattered collage (mirrors the desktop
    // divergence, smaller spread). Desktop uses initWhatWeDo.
    // initWhatWeDoMobile();
    // Hide the fixed corner signs (est.2017 / Fashion Media) while the depth
    // gallery fills the screen — they clash with the full-bleed photos.
    initGalleryDecSignsMobile();
    // Light staggered fade-in of the footer block (you-can-item style).
    initFooterMobile();
  }

  // Mobile uses a lightweight static CSS background without SVG filters.
  if (isDesktop()) initFooterShadow();

  // Awards slider runs on both desktop and mobile; the partners row follows it.
  initAwardsSlider();
  initPartners();

  // Instagram card 3D tilt (mouse-driven, desktop/hover-capable only).
  initInstagramTilt();

  // Horizontal "Де ми Були" scene runs on both desktop and mobile
  // (mobile uses a 6-column grid with slot-based block widths).
  initWhereWeWas();

  // "Що ми зробили" pinned accordion (desktop + mobile).
  initWhatWeDone();

  // Model Camp block after "Що ти можеш" (desktop + mobile).
  initModelCamp();

  // Reviews play buttons open a video lightbox (desktop + mobile).
  initReviewsVideo();

  // Re-measure after late layout growth (lazy images, gallery mount) — after
  // every trigger above exists, so nothing below it is left stale.
  initLayoutRefresh();

  if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
});

// Only under ScrollSmoother: the transformed #smooth-content kills native
// position:sticky, so the two live sticky blocks get ScrollTrigger pins as
// stand-ins (html.has-smoother CSS neutralises their sticky first). Both pins
// use pinSpacing:false — the sticky layouts already reserve the full height.
function initSmootherPins() {
  const remPx = () => parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;

  // Depth gallery: .bf-gallery-section is a 400vh track, the sticky child held
  // a 100vh viewport. Same window, pinned.
  const gallerySection = document.querySelector('.bf-gallery-section');
  const gallerySticky = gallerySection && gallerySection.querySelector('.bf-gallery-section__sticky');
  if (gallerySection && gallerySticky) {
    ScrollTrigger.create({
      trigger: gallerySection,
      start: 'top top',
      end: 'bottom bottom',
      pin: gallerySticky,
      pinSpacing: false,
      anticipatePin: 1,
    });
  }

  // Reviews head (title + rating): was sticky at top:8rem / bottom:16rem
  // inside the .reviews__in grid. The pin-spacer takes over its grid cell
  // (see _reviews.sass).
  const reviewsIn = document.querySelector('.reviews__in');
  const reviewsHead = reviewsIn && reviewsIn.querySelector('.reviews__head');
  if (reviewsIn && reviewsHead) {
    ScrollTrigger.create({
      trigger: reviewsHead,
      start: () => 'top ' + Math.round(8 * remPx()),
      endTrigger: reviewsIn,
      // Release when the grid bottom comes up to 16rem below the head — the
      // same travel the old `bottom: 16rem` sticky constraint allowed.
      end: () => 'bottom ' + Math.round(8 * remPx() + reviewsHead.offsetHeight + 16 * remPx()),
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true,
    });
  }
}

// Mobile-only: make .intro + .headline-1 together fill exactly one screen
// (100vh) by padding the bottom of .headline-1 with the leftover space. The
// gap is computed dynamically (measured), since intro height varies with the
// device. Recomputed once fonts load (Playfair changes the headline height)
// and on window load, when final sizes are known.
function initIntroHeadlineFill() {
  const intro = document.querySelector('.intro');
  const headline = document.querySelector('.headline-1');
  if (!intro || !headline) return;

  const fit = () => {
    headline.style.marginTop = '0px';
    headline.style.marginBottom = '0px';
    // Use offsetHeight (scroll-independent — unlike getBoundingClientRect, which
    // is viewport-relative and goes wrong once the user has scrolled) and
    // clientHeight (the stable layout viewport, which doesn't change as the
    // mobile URL bar shows/hides — so recomputing never makes the first screen
    // jump). intro.offsetHeight is also squash-proof: initIntroMobile keeps the
    // hero's footprint constant.
    const introH = intro.offsetHeight;
    const h = headline.offsetHeight;
    // Centre the headline in the white space left between the intro image and
    // the bottom of the screen; the equal margins also make .intro + .headline-1
    // add up to exactly one screen.
    const gap = document.documentElement.clientHeight - introH;
    const m = Math.max(0, Math.round((gap - h) / 2));
    headline.style.marginTop = m + 'px';
    headline.style.marginBottom = m + 'px';
  };

  fit();
  window.addEventListener('load', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
}

function initAccessibleLabels() {
  document.querySelectorAll('a[target="_blank"]').forEach((link) => {
    const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    rel.add('noopener');
    rel.add('noreferrer');
    link.setAttribute('rel', Array.from(rel).join(' '));
  });

  document.querySelectorAll('.reviews__name').forEach((item) => {
    const link = item.querySelector('.reviews__item-link');
    const name = item.querySelector('.reviews__name-text');
    const play = item.querySelector('.reviews__item-play');
    if (!name) return;

    const nameText = name.textContent.trim().replace(/\s+/g, ' ');
    if (link) link.setAttribute('aria-label', `Дивитись відгук: ${nameText}`);
    if (play) play.setAttribute('aria-label', `Відтворити відеовідгук: ${nameText}`);
  });

  document.querySelectorAll('.where-we-was__item').forEach((item) => {
    const name = item.querySelector('.where-we-was__name');
    const play = item.querySelector('.where-we-was__play');
    if (!name || !play) return;
    play.setAttribute('aria-label', `Відтворити відео: ${name.textContent.trim().replace(/\s+/g, ' ')}`);
  });
}

// Events page — the "Наші події" headline. Two jobs:
//
//   • the load fill: the words start grey (CSS holds that state, so there's no
//     flash of black before the scripts run) and the colour pours in from the
//     left while the page loads — one LINEAR wipe that runs word into word;
//     the `load` gate sits exactly on the word boundary, and a cap makes sure
//     one stalled asset can't leave the headline half-grey;
//
//   • the scroll shrink: the headline sits in NORMAL FLOW at the top of the
//     list and .events reserves the first screen above it (padding-top: 100vh),
//     so the tween runs BACKWARDS — from "big, centred on the first screen" to
//     y:0 / scale:1, its own layout spot. Because it lands exactly where the
//     element already lives, no pin and no fixed→absolute hand-off is needed:
//     past the range the headline simply scrolls away with the content (and it
//     behaves identically with and without ScrollSmoother).
function initEventsTitle() {
  const title = document.querySelector('.events__title');
  if (!title) return;

  const words = title.querySelectorAll('.events__word');

  if (typeof gsap === 'undefined') {
    words.forEach((word) => { word.style.backgroundPosition = '0% 0'; });
    return;
  }

  // One continuous linear wipe: the words fill strictly one after the other
  // (stagger === duration, no overlap) and everything is ease-free — here AND
  // in the playhead tweens below — so the fill front moves at ONE constant
  // speed from the first letter of "Наші" to the last of "Події".
  const fill = gsap.timeline({ paused: true }).fromTo(words,
    { backgroundPosition: '100% 0' },
    { backgroundPosition: '0% 0', duration: 1, ease: 'none', stagger: 1 }
  );

  const events = title.closest('.events');
  const pin = events && events.querySelector('.events__pin');
  const remPx = () => parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;

  // Once the headline is full, glide down to the first event — otherwise the
  // page just sits there looking finished. Skipped (and abandoned) the moment
  // the visitor takes the scroll into their own hands. `maxStart` widens the
  // "close enough to the top" gate for the scroll-back re-run below.
  const glideToFirstEvent = (maxStart) => {
    // A deep-linked event opens over the page the moment the pour ends — the
    // list underneath must not start travelling at the same time.
    if (document.querySelector('.event-detail[data-open="1"]')) return;
    if (!pin || pageScrollY() > (maxStart == null ? 2 * remPx() : maxStart)) return;

    const stop = () => {
      gsap.killTweensOf(smoother || window);
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchstart', stop);
      window.removeEventListener('keydown', stop);
    };

    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchstart', stop, { passive: true });
    window.addEventListener('keydown', stop);

    scrollPageTo(docOffsetTop(pin), { duration: 1.6, ease: 'power2.inOut', onComplete: stop });
  };

  // Same two-gate finish as the home page loader: the colour pours in over a
  // minimum time of its own AND waits for `load`, so a fast (cached) load can't
  // flash the headline black instantly and a slow one can't leave it grey.
  let poured = false;
  let loaded = document.readyState === 'complete';
  let filled = false;

  const finishFill = () => {
    if (filled || !poured || !loaded) return;
    filled = true;
    fill.tweenTo(fill.duration(), {
      duration: 0.8,
      ease: 'none',
      overwrite: true,
      onComplete: () => {
        document.dispatchEvent(new CustomEvent('bf:events-title-poured'));
        gsap.delayedCall(0.2, glideToFirstEvent);
      },
    });
  };

  // The `load` gate sits at 50% — exactly the boundary between the words. Both
  // playhead tweens cover one word in 0.8s with no ease, so on a normal load
  // they chain into a single constant-speed wipe; if `load` is late, the stall
  // lands on the word gap, where a held pause reads as intent, not a freeze.
  const startPour = () => {
    // Started after the page finished loading (the overlay reveals the
    // embedded page only then): nothing to wait for, or the pour would sit at
    // half until the safety timeout.
    if (document.readyState === 'complete') loaded = true;
    fill.tweenTo(fill.duration() * 0.5, {
      duration: 0.8,
      ease: 'none',
      onComplete: () => { poured = true; finishFill(); },
    });

    if (!loaded) {
      window.addEventListener('load', () => { loaded = true; finishFill(); }, { once: true });
    }

    // Hard cap: a stalled asset must never leave the headline half-grey.
    setTimeout(() => { poured = true; loaded = true; finishFill(); }, 3500);
  };

  // With the loader on the page the pour waits for its curtain (initLoader
  // runs first in ready, so the flag is already set) — otherwise the headline
  // would fill unseen and the glide below would fire under the overlay.
  if (document.documentElement.classList.contains('is-embedded')) {
    // Inside the events overlay there is no curtain: the parent reveals the
    // frame once it has loaded and says so — the pour is the entrance then.
    let started = false;
    const go = () => { if (!started) { started = true; startPour(); } };
    document.addEventListener('bf:overlay-shown', go, { once: true });
    setTimeout(go, 4000); // opened standalone with ?embed=1, or a parent that never speaks
  } else if (window.bfLoaderDone === false) {
    document.addEventListener('bf:loader-done', startPour, { once: true });
  } else {
    startPour();
  }

  if (!events || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // The tween ends exactly where .events__pin starts pinning — the moment the
  // pin's top reaches the top of the viewport. So the headline lands in its
  // parked spot (the pin's top padding, which clears the header logo) and the
  // pin immediately holds it there for the whole stack sequence.
  const pinTop = () => (pin ? docOffsetTop(pin) : window.innerHeight);
  // On desktop the headline's NATURAL size is the hero size (12rem in
  // _events.sass) and it only ever scales DOWN — to this, when it parks under
  // the logo. Scaling a rasterized layer UP was what read as blur on the first
  // screen. Mobile keeps the small natural size and the (minor) scale-up.
  const restScale = () => (isDesktop() ? 5.6 / 12 : 1);
  // Mobile's natural size is the parked size from the design (4.2rem), so the
  // hero scale-up brings it to roughly the same on-screen size as before.
  const heroScale = () => (isDesktop() ? 1 : 1.45);
  // Where its middle sits on the first screen, as a fraction of the viewport
  // height (just under centre, per design).
  const HERO_CENTER = 0.56;
  // The reserved first screen — .events pads its top by 100vh, so this IS the
  // headline's own document offset. Measuring it (rather than assuming
  // window.innerHeight) keeps the landing exact on mobile, where CSS 100vh and
  // the visual viewport disagree while the URL bar is showing.
  const heroSpace = () => docOffsetTop(title);

  const introTrigger = {
    trigger: events,
    start: 'top top',
    end: () => '+=' + Math.max(1, pinTop()),
    scrub: true,
    invalidateOnRefresh: true,
  };

  // Resting mid-flight would hang the headline half-scaled between the hero
  // screen and its parked spot. Once the user goes idle, finish the flight to
  // whichever end they were headed — a barely-started nudge (under 8%) settles
  // back instead of yanking a whole screen. Desktop only: mobile stays on
  // native touch momentum.
  if (isDesktop()) {
    introTrigger.snap = {
      snapTo: (value, self) =>
        (self && self.direction < 0 ? Math.floor(value + 0.08) : Math.ceil(value - 0.08)),
      delay: 0.15,
      duration: { min: 0.5, max: 1 },
      ease: 'power3.inOut',
    };
  }

  gsap.fromTo(title,
    {
      // Lift it from its layout spot (one screen plus its own half height below
      // the fold) up to HERO_CENTER of the first screen.
      y: () => window.innerHeight * HERO_CENTER - (heroSpace() + title.offsetHeight / 2),
      scale: heroScale,
    },
    {
      y: 0,
      scale: restScale,
      ease: 'none',
      scrollTrigger: introTrigger,
    }
  );

  // Scrolling BACK up to the headline screen re-arms the welcome: half a
  // second at rest there and the page glides down to the first event again,
  // exactly like after loading. The smoothed position is POLLED (gsap ticker)
  // rather than listened for — under normalizeScroll the window sees almost
  // no scroll events, and the last one lands before the smoother has coasted
  // into the top zone. One shot per visit: re-armed only after the visitor
  // drops back below the zone, so a glide THEY cancelled (any input aborts
  // it, see stop above) doesn't keep re-firing while they sit at the top.
  // Skipped while an overlay owns the page (body.is-ovh — loader, detail).
  const returnZone = () => pinTop() * 0.4;
  let restMs = 0;
  let lastY = -1;
  let returnArmed = false;
  gsap.ticker.add((time, deltaMS) => {
    const y = pageScrollY();
    if (Math.abs(y - lastY) > 0.5) {
      restMs = 0;
      lastY = y;
    } else {
      restMs += deltaMS;
    }
    if (y > returnZone()) {
      returnArmed = true;
      return;
    }
    if (!returnArmed || restMs < 500) return;
    if (!filled || document.body.classList.contains('is-ovh')) return;
    returnArmed = false;
    glideToFirstEvent(returnZone());
  });
}

// Events page — the list. On desktop it is a STAGE: .events__pin is pinned for
// the whole sequence and the events are stacked on top of each other inside it
// (see _events.sass). One scrubbed handler renders every event from a single
// float "playhead" p — the index of the event currently on stage — so each
// event's state is a pure function of its distance from p:
//
//     d < 0   still to come  — parked below, invisible
//     d = 0   on stage       — full title, date, copy, arrow, photo
//     0→1     collapsing     — title shrinks up into the stack, photo folds
//                              into a thin strip above the next photo
//     d ≥ 1   collapsed      — one row per step up the stack, oldest fades out
//
// Everything is one continuous function of the scroll, which is what makes the
// collapse read as a single motion rather than a chain of separate tweens.
//
// Mobile keeps the plain document list with light per-item reveals.
function initEvents() {
  const events = document.querySelector('.events');
  const pin = events && events.querySelector('.events__pin');
  const list = pin && pin.querySelector('.events__list');
  if (!events || !pin || !list) return;

  const items = Array.prototype.slice.call(list.querySelectorAll('.events-item'));
  if (!items.length) return;

  items.forEach(watchEventFormat);

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    // No stage without ScrollTrigger — restore the plain visible list that
    // the pre-JS CSS keeps hidden past the first item.
    events.classList.add('is-plain');
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  if (!isDesktop()) {
    initEventsListMobile(items);
    return;
  }

  buildEventsStage(events, {
    counter: document.querySelector('.events-counter'),
    fadeHeadline: true,
  });
}

// The photos are deliberately of different formats. Read the real proportion
// — the width/height attributes give it to us before the file loads — and put
// the item in a width bucket: a portrait shot stands narrow, a landscape one
// stretches across the grid, all of them right-aligned to the last column.
function applyEventFormat(item) {
  const img = item.querySelector('.events-item__photo');
  if (!img) return;

  const w = img.naturalWidth || parseFloat(img.getAttribute('width')) || 0;
  const h = img.naturalHeight || parseFloat(img.getAttribute('height')) || 0;
  if (!w || !h) return;

  const ratio = w / h;
  const format = ratio >= 1.15 ? 'wide' : ratio >= 0.85 ? 'square' : 'tall';
  item.classList.remove('events-item--wide', 'events-item--square', 'events-item--tall');
  item.classList.add('events-item--' + format);
}

function watchEventFormat(item) {
  applyEventFormat(item);
  const img = item.querySelector('.events-item__photo');
  // No intrinsic size in the markup? Then the bucket has to wait for the file.
  if (img && !img.complete) img.addEventListener('load', () => applyEventFormat(item), { once: true });
}

// The stage itself, reusable: the main page runs it against the window scroll
// (with the fixed margin counter and the headline fade-out); the event detail
// builds a SECOND one from cloned items against its own overlay scroller
// (opts.scroller), where neither of those page fixtures exists.
// Snap ease shared by the events stage on the page and the "інші івенти"
// stage inside the detail: the cubic with h(0)=0, h(1)=1, h'(1)=0 and
// h'(0)=c, where c is the current velocity measured in "distance per
// duration" — it leaves at the speed the scroll is ALREADY moving and arrives
// at a standstill. Clamped to [0.9, 3]: never lazier than a soft pull-in,
// never fast enough to overshoot and walk back.
function makePickupEase(velocity, distance, duration) {
  const ratio = distance ? (velocity * duration) / distance : 0;
  const c = gsap.utils.clamp(0.9, 3, ratio || 0);
  return (t) => ((c - 2) * t + (3 - 2 * c)) * t * t + c * t;
}

function buildEventsStage(events, opts) {
  const options = opts || {};
  const scroller = options.scroller;
  const pin = events.querySelector('.events__pin');
  const list = pin && pin.querySelector('.events__list');
  const items = list ? Array.prototype.slice.call(list.querySelectorAll('.events-item')) : [];
  if (!pin || !items.length) return;

  const counter = options.counter || null;
  const counterNext = counter && counter.querySelector('.events-counter__next');
  const counterTotal = counter && counter.querySelector('.events-counter__total');
  const pad = (n) => String(n).padStart(2, '0');

  if (counterTotal) counterTotal.textContent = pad(items.length);

  // The counter reads "what's next … how many there are", so on the last event
  // it has nothing left to say and drops out.
  let current = -1;
  const setCurrent = (index) => {
    if (!counter || index === current) return;
    current = index;
    counter.classList.toggle('is-last', index >= items.length - 1);
    if (counterNext) counterNext.textContent = pad(Math.min(index + 2, items.length));
  };

  events.classList.add('is-stage');

  const remPx = () => parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
  // Stage geometry — the rem numbers are declared as custom properties in
  // _events.sass so the CSS layout and this animation can't drift apart.
  const cssRem = (name, fallback) => {
    const value = parseFloat(getComputedStyle(events).getPropertyValue(name));
    return (Number.isFinite(value) ? value : fallback) * remPx();
  };

  const clamp01 = gsap.utils.clamp(0, 1);
  const ease = gsap.parseEase('power2.inOut');
  // The photo folds early in its step, so it is already a strip by the time the
  // next photo slides up into the space.
  const foldEase = gsap.parseEase('power2.out');
  // The arrow button lands with a slight overshoot — a pop, not a fade.
  const popEase = gsap.parseEase('back.out(1.6)');
  // The copy's TRAVEL — deliberately not the same curve as its fade (see the
  // copyEach branches). It leaves accelerating, as if the scroll carried it
  // off, and arrives decelerating, so the line settles rather than lands.
  const copyOutEase = gsap.parseEase('power2.in');
  const copyInEase = gsap.parseEase('power2.out');
  const lerp = (from, to, t) => from + (to - from) * t;
  // Re-maps t onto a sub-window of the step — the whole handoff is choreographed
  // as windows so the outgoing copy is gone BEFORE the incoming copy arrives,
  // instead of two half-transparent layers crossing on top of each other.
  const win = (t, from, to) => clamp01((t - from) / (to - from));
  // How many collapsed rows stay on the stack before the oldest fades away.
  const STACK_MAX = 3;

  // Design values, pulled back when a short viewport can't fit them (an
  // ultrawide screen is the same problem, since rem scales with vw): the arrow
  // button has to stay on screen and the photo must not run off the bottom.
  // Both are written back to the custom properties, so the CSS follows.
  const geometry = () => {
    const R = remPx();
    const vh = window.innerHeight;

    const mediaTop = cssRem('--ev-media-top', 20);
    const restTop = cssRem('--ev-rest-top', 19);
    let titleTop = cssRem('--ev-title-top', 46);

    const contentBottom = titleTop + 28 * R;
    if (contentBottom > vh) titleTop = Math.max(restTop + 12 * R, titleTop - (contentBottom - vh));
    events.style.setProperty('--ev-title-top', String(titleTop / R));

    const mediaHeight = Math.min(cssRem('--ev-media-h', 56), vh - mediaTop - 4 * R);
    events.style.setProperty('--ev-media-h', String(mediaHeight / R));

    return {
      titleTop,
      mediaTop,
      mediaHeight,
      // Natural (unscaled) item-title heights — the strip parks bottom-aligned
      // with its own collapsed title, so the row height matters.
      titleHs: items.map((it) => {
        const t = it.querySelector('.events-item__title');
        return t ? t.offsetHeight : 0;
      }),
      stackGap: cssRem('--ev-stack-gap', 8),
      stackRow: cssRem('--ev-stack-row', 4.4),
      // How far below its slot each piece waits: the copy just a nudge, the
      // photo past the pin's bottom edge, where the list clips it.
      enter: 10 * R,
      // The outgoing copy doesn't die in place — it keeps moving up as it
      // fades, in the same direction the scroll is going.
      copyExit: 6 * R,
      // Parked = the photo's TOP sits below the 100vh clip line. Measured from
      // the viewport, not the photo height: when the slot (--ev-media-top)
      // rides high, slot + height + margin lands INSIDE the viewport and a
      // strip of the next photo would peek out at the bottom of the stage.
      mediaEnter: Math.max(mediaHeight, vh - mediaTop) + 4 * R,
      collapsedScale: 0.55,
    };
  };

  let geo = geometry();

  // One writer per event, straight to the DOM. These elements belong to this
  // handler alone — nothing else tweens them — so plain style writes are both
  // the fastest path and the easiest to follow.
  const parts = items.map((item) => ({
    item,
    isActive: null,
    title: item.querySelector('.events-item__title'),
    num: item.querySelector('.events-item__num'),
    media: item.querySelector('.events-item__media'),
    copy: Array.prototype.slice.call(item.querySelectorAll(
      '.events-item__date, .events-item__text'
    )),
    // The arrow button gets its own channel: it pops in scaling up (the copy
    // slides), so even a brief appearance mid-scroll reads as designed.
    link: item.querySelector('.events-item__link'),
  }));

  const place = (part, v) => {
    part.item.style.opacity = v.opacity;
    if (part.title) {
      part.title.style.transform = 'translate3d(0,' + v.titleY + 'px,0) scale(' + v.titleScale + ')';
      part.title.style.opacity = v.titleOpacity;
    }
    if (part.num) {
      part.num.style.transform = 'translate3d(0,' + v.titleY + 'px,0)';
      part.num.style.opacity = v.titleOpacity;
    }
    part.copy.forEach((el, i) => {
      // copyEach lets a branch stagger the copy lines individually; the uniform
      // copyY/copyOpacity pair still serves the static states.
      const c = v.copyEach ? v.copyEach(i) : v;
      el.style.transform = 'translate3d(0,' + c.copyY + 'px,0)';
      el.style.opacity = c.copyOpacity;
    });
    if (part.link) {
      part.link.style.transform =
        'translate3d(0,' + v.linkY + 'px,0) scale(' + v.linkScale + ')';
      part.link.style.opacity = v.linkOpacity;
      // The arrow inside is a :before — it turns via a custom property the
      // stage CSS folds into the pseudo-element's transform.
      part.link.style.setProperty('--ev-arrow', v.arrowTurn + 'deg');
    }
    if (part.media) {
      part.media.style.transform = 'translate3d(0,' + v.mediaY + 'px,0)';
      part.media.style.height = v.mediaHeight + 'px';
      part.media.style.opacity = v.mediaOpacity;
    }
  };

  const render = (p) => {
    parts.forEach((part, index) => {
      const d = p - index;

      if (d <= -1) {
        // Still to come: parked below the stage, out of sight.
        place(part, {
          opacity: 0, titleOpacity: 1, titleY: geo.enter, titleScale: 1,
          copyY: geo.enter, copyOpacity: 1,
          linkY: geo.enter * 0.5, linkScale: 0.4, linkOpacity: 0, arrowTurn: -45,
          mediaY: geo.mediaEnter, mediaHeight: geo.mediaHeight, mediaOpacity: 1,
        });
        setActive(part, false);
        return;
      }

      if (d < 0) {
        // Rising into place as the event before it folds out of the way — but
        // only AFTER it has cleared the floor: the previous event's copy is
        // gone by ~0.45 of the step (see the collapse branch), so everything
        // here waits for its window instead of ghosting over the old text.
        // The photo starts late and slides (never fades) up from below the
        // pin's clipped edge — cross-fading it would ghost over the one still
        // folding, which reads as a mistake rather than a transition.
        const t = clamp01(d + 1);
        const soft = ease(win(t, 0.3, 0.9));
        const lift = ease(win(t, 0.35, 1));
        // The button pops in a touch after the copy starts and is fully landed
        // by 0.85 — together with a late exit (0.12 into the collapse) that
        // gives it a solid plateau across the step boundary, so a continuous
        // scroll shows a settled button instead of a flicker.
        const popT = win(t, 0.55, 0.85);
        const pop = popEase(popT);

        place(part, {
          opacity: 1,
          titleOpacity: soft,
          titleY: lerp(geo.enter, 0, soft),
          titleScale: 1,
          // The copy follows the title in, line by line — date, then text —
          // each on its own slightly later window. Mirror of the exit: the ink
          // holds back for the first third of the ride, which is the stretch
          // that passes over the arrow button's slot, and only shows for the
          // last few rem, where the travel is already easing out. The line
          // settles into place instead of flying up through the button.
          copyEach: (i) => {
            const from = 0.45 + i * 0.08;
            const k = win(t, from, Math.min(from + 0.4, 1));
            return {
              copyY: lerp(geo.enter, 0, copyInEase(k)),
              copyOpacity: ease(clamp01((k - 0.3) / 0.7)),
            };
          },
          linkY: lerp(geo.enter * 0.5, 0, pop),
          linkScale: lerp(0.4, 1, pop),
          // Faster than the scale, so the circle is solid while it still grows.
          linkOpacity: ease(win(t, 0.55, 0.75)),
          arrowTurn: lerp(-45, 0, pop),
          mediaY: lerp(geo.mediaEnter, 0, lift),
          mediaHeight: geo.mediaHeight,
          mediaOpacity: 1,
        });
        setActive(part, t > 0.5);
        return;
      }

      // On stage (d = 0) and collapsing upward from there. `step` eases the
      // first stride so the fold reads as one motion; `rows` is the whole
      // steps above it, which stack at a constant pitch.
      const depth = Math.min(d, STACK_MAX + 1.5);
      const step = ease(clamp01(depth));
      const fold = foldEase(clamp01(depth));
      const rows = Math.max(0, depth - 1);
      const rowOffset = geo.stackGap * step + geo.stackRow * rows;

      // The photo folds into a strip that parks BOTTOM-ALIGNED with its own
      // collapsed title (the red line in the design) and rides up the stack
      // with it. Only the freshest strip stays — the older ones bow out as the
      // next event starts folding.
      const rowBottom = geo.titleTop - rowOffset + geo.titleHs[index] * geo.collapsedScale;
      // The strip stands exactly TWO collapsed rows tall: from the previous
      // row's top down to its own title's baseline (one stack pitch plus the
      // collapsed title's own height), bottom-aligned with the text stack.
      const stripH = geo.stackRow + geo.titleHs[index] * geo.collapsedScale;

      place(part, {
        // The oldest row dims as it goes, then leaves the stack.
        opacity: 1 - clamp01((depth - 1.8) / 1.8),
        titleOpacity: 1,
        titleY: -rowOffset,
        titleScale: lerp(1, geo.collapsedScale, step),
        // The copy goes first — it would only crowd the shrinking title. It
        // exits upward (with the scroll) line by line, and is fully out by
        // ~0.45 of the step, before the next event's copy enters that space.
        //
        // The ink and the movement run on DIFFERENT curves, and that split is
        // the whole point: the ride is 6rem but the gap to the title above is
        // barely 3, so a line that stayed visible for the whole trip spent its
        // last third crossing the big title's glyphs. Fading it out over the
        // first 70% of the window, against an accelerating travel, keeps every
        // visible frame inside the gap — it is already gone by the time it
        // reaches the title.
        copyEach: (i) => {
          const from = i * 0.05;
          const t = win(d, from, from + 0.3);
          return {
            copyY: -geo.copyExit * copyOutEase(t),
            copyOpacity: 1 - ease(clamp01(t / 0.7)),
          };
        },
        // The button holds its plateau past the boundary, then shrinks away —
        // the reverse of its entrance pop, arrow turning back out.
        linkY: -geo.copyExit * 0.5 * ease(win(d, 0.12, 0.4)),
        linkScale: lerp(1, 0.5, ease(win(d, 0.12, 0.4))),
        linkOpacity: 1 - ease(win(d, 0.12, 0.38)),
        arrowTurn: lerp(0, 45, ease(win(d, 0.12, 0.4))),
        mediaY: lerp(0, rowBottom - stripH - geo.mediaTop, fold),
        mediaHeight: lerp(geo.mediaHeight, stripH, fold),
        mediaOpacity: 1 - clamp01((depth - 1) / 0.7),
      });
      setActive(part, d < 0.5);
    });
  };

  function setActive(part, active) {
    if (part.isActive === active) return;
    part.isActive = active;
    part.item.classList.toggle('is-active', active);
  }

  // One screen of scroll per event, plus a last screen that holds the final one
  // on stage before the pin lets go.
  const step = () => Math.max(1, Math.round(window.innerHeight * 0.85));

  const update = (self) => {
    const p = gsap.utils.clamp(0, items.length - 1, self.progress * items.length);
    render(p);
    setCurrent(Math.round(p));
  };

  // The counter fades in with the stage and out when the sequence lets go. It
  // gets its own trigger rather than riding on the pin's callbacks: those only
  // fire once the pin is genuinely under way, and the intro glide parks the
  // page exactly ON that boundary — where the counter would still be hidden.
  // The counter only exists on the page stage, which scrolls with the window.
  if (counter) {
    ScrollTrigger.create({
      trigger: pin,
      start: 'top 80%',
      end: () => '+=' + (window.innerHeight * 0.8 + step() * items.length),
      toggleClass: { targets: counter, className: 'is-visible' },
      invalidateOnRefresh: true,
    });
  }

  const pinConfig = {
    trigger: pin,
    start: 'top top',
    end: () => '+=' + step() * items.length,
    pin: true,
    pinSpacing: true,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    // A rest between two events would freeze the stage mid-fold — half-shrunk
    // title, half-strip photo. Once the user goes idle, gently finish the
    // stride to a whole event, continuing in the direction they were headed:
    // a started stride (past 15%) completes, a barely-touched one settles
    // back. The last segment is the hold screen — the final event is fully
    // parked anywhere in it, so those resting spots are left alone.
    snap: {
      snapTo: (value, self) => {
        const n = items.length;
        if (n < 2 || value >= (n - 1) / n - 1e-4) return value;
        // Only genuinely fast motion defers the snap (a mid-gesture trackpad
        // burst) — the smoother's long soft tail does NOT: the target below
        // is picked in the direction of travel, so cutting in early rides the
        // motion to the boundary instead of fighting it. That's what makes
        // the pull-to-place kick in early rather than after a full stop.
        if (self && Math.abs(self.getVelocity()) > 900) return value;
        const seg = value * n;
        // Downhill keeps the design intent: a stride past 15% completes.
        // Uphill settles back only from the last 8% of a stride — any deeper
        // and it finishes where the user is headed, never against them.
        const target = self && self.direction < 0 ? Math.floor(seg + 0.08) : Math.ceil(seg - 0.15);
        return Math.max(0, target) / n;
      },
      delay: 0.05,
      // Starts fast and settles (power2.out): the snap picks up whatever
      // momentum is left and finishes the stride briskly.
      duration: { min: 0.3, max: 0.6 },
      ease: 'power2.out',
    },
    onRefresh: (self) => {
      geo = geometry();
      update(self);
    },
    onUpdate: update,
    onToggle: update,
  };

  // The scroller key must only EXIST when a custom scroller is given:
  // ScrollSmoother sets a default scroller for every trigger, and a present-
  // but-undefined key would override that default with the window — un-pinning
  // the page stage from the smoothed content. The custom scroller keeps the
  // default TRANSFORM pinning; its owner must drive the scroll from JS (see
  // initEventDetail's wheel driver) so the pin updates in the same frame —
  // native threaded scrolling would put the transform a frame behind (jitter),
  // and position:fixed pinning breaks wheel scroll-chaining entirely.
  if (scroller) pinConfig.scroller = scroller;
  // The owner of a custom scroller may run its own snap (the event detail
  // does, inside its wheel glide — one driver for the scroll, no tween fights).
  if (scroller && options.snap === false) delete pinConfig.snap;
  // The page stage replaces ScrollTrigger's snap with its own (below): under
  // ScrollSmoother the built-in snap only retargets the native scroll and the
  // visual position keeps trailing on the 1.6s glide — the pull always reads
  // late, no matter how early it starts.
  else delete pinConfig.snap;

  const stageTrigger = ScrollTrigger.create(pinConfig);

  if (!scroller) {
    // Hand-rolled snap for the smoothed page: the moment the (smoothed)
    // motion calms inside the stage, tween the smoother straight to the
    // nearest stride boundary — tightening the smoothing for the ride so the
    // pull is FELT immediately, and restoring it right after. Any user input
    // abandons the snap on the spot.
    const SNAP_CALM = 500;
    // How tight the smoothing gets for the ride — and, just as importantly,
    // how long that change itself takes. Stepping the smoother's damping in a
    // single frame multiplies the content's catch-up speed on the spot, and
    // THAT reads as the jolt (the tween underneath was never the problem).
    // Ramped over a few frames the pull swells in instead of snapping on.
    const SNAP_SMOOTH = 0.35;
    const SNAP_DURATION = 0.55;
    // Held tight a beat past the tween: the content trails the scroll by about
    // SNAP_SMOOTH, so at onComplete it is still gliding the last few pixels in.
    // Releasing the damping right there hands that tail back to the 1.6s glide
    // mid-flight — a visible sag at the very end of every stride.
    const SNAP_SETTLE = 0.3;
    let rest = 0;
    let snapping = false;
    let cooldown = 0;
    // The page's own smoothing, read ONCE. Re-reading it per snap would catch
    // the tightened value whenever the release ramp is still pending and pin
    // the page at SNAP_SMOOTH for good.
    let baseSmooth = null;
    let tightened = false;

    // The smoothing is tweened through its own proxy so stopSnap can kill the
    // ramp and the scroll tween independently.
    const smoothRamp = { value: 0 };
    const rampSmooth = (to, duration, delay) => {
      if (!smoother) return;
      gsap.killTweensOf(smoothRamp);
      smoothRamp.value = smoother.smooth();
      gsap.to(smoothRamp, {
        value: to,
        duration,
        delay: delay || 0,
        ease: 'power1.inOut',
        onUpdate: () => smoother.smooth(smoothRamp.value),
      });
    };

    const restoreSmooth = (delay) => {
      if (smoother && tightened) {
        rampSmooth(baseSmooth, 0.3, delay);
        tightened = false;
      }
    };

    // Ease that leaves at the speed the page is ALREADY moving and arrives at
    // a standstill: the cubic with h(0)=0, h(1)=1, h'(1)=0 and h'(0)=c, where c
    // is the current velocity measured in "distance per duration". power2.out
    // always leaves at 2 — a fixed speed the snap imposed on whatever the page
    // was doing, in one frame. Clamped to [0.9, 3]: never lazier than a soft
    // pull-in, never fast enough to overshoot and walk back.
    const pickupEase = (velocity, distance) => makePickupEase(velocity, distance, SNAP_DURATION);

    const stopSnap = () => {
      rest = 0;
      cooldown = 0;
      if (!snapping) return;
      snapping = false;
      gsap.killTweensOf(smoother || window);
      restoreSmooth();
    };

    window.addEventListener('wheel', stopSnap, { passive: true });
    window.addEventListener('touchstart', stopSnap, { passive: true });
    window.addEventListener('keydown', stopSnap);

    gsap.ticker.add((time, deltaMS) => {
      if (snapping || !stageTrigger.isActive) return;
      if (document.body.classList.contains('is-ovh')) return;
      // Just landed: the trigger reads the SMOOTHED position, which is still
      // coasting the last pixels in. Left alone, that tail looks like a stride
      // that stopped short and fires a second snap onto the same boundary — a
      // small tug right after the first one settled.
      if (cooldown > 0) {
        cooldown -= deltaMS;
        rest = 0;
        return;
      }
      if (Math.abs(stageTrigger.getVelocity()) > SNAP_CALM) {
        rest = 0;
        return;
      }
      rest += deltaMS;
      if (rest < 80) return;
      rest = 0;

      const n = items.length;
      const value = stageTrigger.progress;
      // The last segment is the hold screen — its resting spots are fine.
      if (n < 2 || value >= (n - 1) / n - 1e-4) return;
      const seg = value * n;
      // Downhill a stride past 15% completes; uphill it settles back only
      // from the last 8% — never against the direction the user was headed.
      const target = Math.max(0,
        stageTrigger.direction < 0 ? Math.floor(seg + 0.08) : Math.ceil(seg - 0.15));
      if (Math.abs(seg - target) < 0.002) return;

      snapping = true;
      if (smoother && !tightened) {
        if (baseSmooth == null) baseSmooth = smoother.smooth();
        tightened = true;
        rampSmooth(SNAP_SMOOTH, 0.18);
      }
      const y = stageTrigger.start +
        (stageTrigger.end - stageTrigger.start) * (target / n);
      const from = smoother ? smoother.scrollTop() : window.scrollY;
      scrollPageTo(y, {
        duration: SNAP_DURATION,
        ease: pickupEase(stageTrigger.getVelocity(), y - from),
        onComplete: () => {
          snapping = false;
          cooldown = SNAP_SETTLE * 1000;
          restoreSmooth(SNAP_SETTLE);
        },
      });
    });
  }

  // Once the pin lets go the whole stage rides up — fade the parked headline
  // out before it collides with the fixed header logo (two black wordmarks
  // crossing under mix-blend-mode read as a glitch). Page stage only: the
  // detail's "інші івенти" headline has no fixed logo to collide with.
  const headline = options.fadeHeadline ? events.querySelector('.events__title') : null;
  if (headline) {
    gsap.to(headline, {
      opacity: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: pin,
        start: 'bottom 99%',
        end: 'bottom 72%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }

  render(0);
  setCurrent(0);

  return { trigger: stageTrigger, count: items.length };
}

// Mobile events list: no stage, no pin — the events stay a plain document list,
// each photo drawing in from the bottom as it rides up the viewport with its
// copy rising alongside.
function initEventsListMobile(items) {
  // The dashed rail spans the WHOLE list and every card keeps its own number
  // on it. The status is the rail itself: a solid line (the list's :after,
  // fed --rail-fill here) fills the rail down to the point the reader has
  // reached and stays full at the end.
  const list = items[0].closest('.events__list');
  if (list && typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.create({
      trigger: list,
      start: 'top 60%',
      end: 'bottom 60%',
      onUpdate: (self) => {
        list.style.setProperty('--rail-fill', (self.progress * 100).toFixed(2) + '%');
      },
    });
  }

  items.forEach((item) => {
    const media = item.querySelector('.events-item__media');
    const copy = item.querySelectorAll(
      '.events-item__num, .events-item__title, .events-item__date, .events-item__text, .events-item__link'
    );

    if (media) {
      gsap.fromTo(media,
        { clipPath: 'inset(100% 0% 0% 0%)' },
        {
          clipPath: 'inset(0% 0% 0% 0%)',
          ease: 'none',
          scrollTrigger: {
            trigger: item,
            start: 'top 85%',
            end: 'top 35%',
            scrub: true,
            invalidateOnRefresh: true,
          },
        }
      );
    }

    if (copy.length) {
      gsap.fromTo(copy,
        { y: 40, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1.1,
          ease: 'power3.out',
          stagger: 0.09,
          scrollTrigger: {
            trigger: item,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      );
    }
  });
}

// Mouse-drag scrolling for the detail filmstrips — touch already swipes them
// natively (they are overflow scrollers), this hands the mouse the same
// gesture. A real drag suppresses the click that fires on release, so a swipe
// across a play button doesn't open the lightbox. The is-dragging class also
// switches scroll-snap off for the duration (CSS) — snap fights direct
// scrollLeft writes.
function makeDragScroll(track) {
  if (!track) return;

  let startX = 0;
  let startLeft = 0;
  let dragging = false;
  let moved = false;

  track.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    dragging = true;
    moved = false;
    startX = e.clientX;
    startLeft = track.scrollLeft;
    track.classList.add('is-dragging');
  });

  track.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 3 && !moved) {
      moved = true;
      // Capture only once this is a real drag. Capturing on pointerdown would
      // make the browser dispatch the following click to the track instead of
      // the element under the mouse — the play buttons in the strip would
      // never receive it.
      try { track.setPointerCapture(e.pointerId); } catch (err) { /* already released */ }
    }
    track.scrollLeft = startLeft - dx;
  });

  const release = () => {
    if (!dragging) return;
    dragging = false;
    track.classList.remove('is-dragging');
  };
  track.addEventListener('pointerup', release);
  track.addEventListener('pointercancel', release);

  // The click right after a real drag is the tail of the gesture, not a click.
  track.addEventListener('click', (e) => {
    if (!moved) return;
    moved = false;
    e.preventDefault();
    e.stopPropagation();
  }, true);
}

// Events page — the event detail "page". A click on an event's arrow opens a
// fixed overlay that is deliberately styled as a standalone page: the site
// header stays above it, it scrolls on its own, and browser Back closes it.
// The open is a three-act morph on a fixed ghost photo:
//
//   act 1 — the clicked item's photo grows to the full screen while the white
//           page fades in underneath (the list disappears behind it);
//   act 2 — it settles into the FIRST slot of the detail's hero filmstrip, so
//           the photo the visitor clicked IS the first photo of the page;
//   act 3 — the rest arrives: the headline rises, the other photos stream in
//           from the right ("the others load"), logo and dots fade last.
//
// Close plays the morph backwards onto the list item (or a plain fade when
// the visitor has scrolled the detail too far for the reverse to read).
//
// One shared layout serves every event — the headline and the lead photo are
// injected from the clicked item; the deeper content is common.
function initEventDetail() {
  const detail = document.querySelector('.event-detail');
  // The page's own list only — the detail clones more .events-item later.
  const items = Array.prototype.slice.call(document.querySelectorAll('#smooth-content .events-item'));
  if (!detail || !items.length) return;

  const scrollBox = detail.querySelector('.event-detail__scroll');
  const closeBtn = detail.querySelector('.event-detail__close');
  const titleEl = detail.querySelector('.event-detail__title');
  const heroTrack = detail.querySelector('.event-detail__gallery-track');
  const contentBox = detail.querySelector('.event-detail__content');
  const mainShot = detail.querySelector('.event-detail__hero .event-detail__shot--main');
  const mainImg = mainShot && mainShot.querySelector('img');
  if (!scrollBox || !heroTrack || !contentBox || !mainShot || !mainImg) return;

  const hasGsap = typeof gsap !== 'undefined';
  const revealsEnabled = hasGsap && typeof ScrollTrigger !== 'undefined' && isDesktop();
  // Inside the events overlay the PARENT page owns the browser history (its
  // #events/<slug> entries); the detail must not push or pop entries of its
  // own, or Back/close counting across the two documents falls apart.
  const embedded = document.documentElement.classList.contains('is-embedded');

  // The strip's other slots and the whole content run are PER EVENT, rendered
  // by inc/events.php: the page ships with one event's (data-slug), the others
  // arrive from event.php when opened (loadDetail). Always re-query them.
  const getExtraShots = () => Array.prototype.slice.call(
    heroTrack.querySelectorAll('.event-detail__shot:not(.event-detail__shot--main)')
  );
  const eventUrl = (item) => {
    const slug = item.getAttribute('data-slug');
    return slug ? '?event=' + encodeURIComponent(slug) : '';
  };

  // The filmstrips swipe natively on touch; the mouse gets the same gesture.
  makeDragScroll(heroTrack);

  // Per-event content bindings (band/video drag, dot pagination) — redone
  // every time the content run is swapped; the old dots release their window
  // listeners through the destroy handles bindSliderDots returns.
  let contentDots = [];
  const bindContent = () => {
    contentDots.forEach((d) => { if (d && d.destroy) d.destroy(); });
    contentDots = [];
    makeDragScroll(contentBox.querySelector('.event-detail__band-track'));
    makeDragScroll(contentBox.querySelector('.event-detail__media-track'));
    contentDots.push(bindSliderDots(
      contentBox.querySelector('.event-detail__band-track'),
      Array.prototype.slice.call(contentBox.querySelectorAll('.event-detail__band-track .event-detail__shot')),
      contentBox.querySelector('.event-detail__band-dots'),
      'event-detail__dot',
      (i) => 'Фото ' + (i + 1)
    ));
    contentDots.push(bindSliderDots(
      contentBox.querySelector('.event-detail__media-track'),
      Array.prototype.slice.call(contentBox.querySelectorAll('.event-detail__media-item')),
      contentBox.querySelector('.event-detail__media-dots'),
      'event-detail__dot',
      (i) => 'Відео ' + (i + 1)
    ));
  };
  bindContent();

  // Section choreography (desktop): ENTER — the block's pieces rise in a quick
  // stagger when it scrolls into view and re-play when it comes back; EXIT —
  // the whole block lifts and fades, scrubbed to the scroll. The hero only
  // ever exits (the open morph is its entrance) and is bound once; the content
  // sections are rebound with every event.
  const REVEAL_PARTS =
    '.event-detail__intro-photo, .event-detail__label, ' +
    '.event-detail__heading, .event-detail__lead p, ' +
    '.event-detail__founder-lead p, .event-detail__year, ' +
    '.event-detail__shot, .event-detail__media-item, ' +
    '.event-detail__dots, .event-detail__figure-main, ' +
    '.event-detail__figure-row div, .event-detail__copy-title, ' +
    '.event-detail__copy p, .event-detail__subhead';
  const sectionExit = (section) => gsap.fromTo(section,
    { opacity: 1, y: 0 },
    {
      opacity: 0,
      y: -70,
      ease: 'none',
      immediateRender: false,
      scrollTrigger: {
        scroller: scrollBox,
        trigger: section,
        start: 'bottom 30%',
        end: 'bottom 4%',
        scrub: true,
      },
    }
  );
  let revealTweens = [];
  const bindReveals = () => {
    if (!revealsEnabled) return;
    revealTweens.forEach((t) => {
      if (t.scrollTrigger) t.scrollTrigger.kill();
      t.kill();
    });
    revealTweens = [];
    Array.prototype.forEach.call(contentBox.querySelectorAll('[data-reveal]'), (section) => {
      let parts = section.querySelectorAll(REVEAL_PARTS);
      if (!parts.length) parts = [section];
      revealTweens.push(gsap.fromTo(parts,
        { opacity: 0, y: 70 },
        {
          opacity: 1,
          y: 0,
          duration: 1.05,
          ease: 'power3.out',
          stagger: 0.07,
          scrollTrigger: {
            scroller: scrollBox,
            trigger: section,
            start: 'top 85%',
            toggleActions: 'play none none reverse',
          },
        }
      ));
      revealTweens.push(sectionExit(section));
    });
  };
  if (revealsEnabled) sectionExit(detail.querySelector('.event-detail__hero'));
  bindReveals();

  // While the detail is open the page behind must not move. Pausing the
  // smoother (lockPageScroll) is not enough: its normalizeScroll observer
  // intercepts wheel/touch globally and would starve the overlay's own native
  // scroll — so the normalizer is switched off for the overlay's lifetime.
  const setPageFrozen = (frozen) => {
    lockPageScroll(frozen);
    if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.normalizeScroll) {
      const normalizer = ScrollTrigger.normalizeScroll();
      if (normalizer) {
        if (frozen) normalizer.disable();
        else normalizer.enable();
      }
    }
  };

  let isOpen = false;
  let isAnimating = false;
  // The page item the detail was originally opened from — the close morph can
  // only land there. Switching events INSIDE the detail clears the morph-back
  // route (the page behind still shows the first event), so close falls back
  // to a fade.
  let pageItem = null;
  let canMorphBack = false;
  let ghost = null;
  let pushedState = false;
  // Browser Back pressed during the open animation: the history entry is
  // already gone, so the close is queued for the moment the morph finishes.
  let pendingPopClose = false;

  // Every photo in the detail is lazy — invisible until the overlay opens, so
  // nothing has loaded by then. Kick ALL of them off the moment the first
  // open starts: by the time the scroll unlocks the layout has its real
  // heights, and a quick swipe can't outrun half-loaded sections (which read
  // as the event being "cut off").
  let imagesPrimed = false;
  const primeNewImages = (root) => {
    Array.prototype.forEach.call(root.querySelectorAll('img[loading="lazy"]'), (img) => {
      img.removeAttribute('loading');
    });
  };
  const primeImages = () => {
    if (imagesPrimed) return;
    imagesPrimed = true;
    primeNewImages(detail);
  };

  const makeGhost = (src, rect) => {
    const g = document.createElement('div');
    g.className = 'event-detail-ghost';
    const img = document.createElement('img');
    img.src = src;
    img.alt = '';
    g.appendChild(img);
    g.style.top = rect.top + 'px';
    g.style.left = rect.left + 'px';
    g.style.width = rect.width + 'px';
    g.style.height = rect.height + 'px';
    document.body.appendChild(g);
    return g;
  };

  // Point the shared layout at a given event: its headline, its lead photo.
  // The width/height attributes keep the first slot's aspect (and so the
  // morph's landing rect) right even before the swapped file paints.
  const swapEvent = (item) => {
    const itemTitle = item.querySelector('.events-item__title');
    const photo = item.querySelector('.events-item__photo');
    const name = itemTitle ? itemTitle.textContent.trim().replace(/\s+/g, ' ') : '';
    if (name) {
      titleEl.textContent = name;
      detail.setAttribute('aria-label', 'Подія: ' + name);
    }
    mainImg.src = photo.currentSrc || photo.src;
    if (photo.naturalWidth && photo.naturalHeight) {
      mainImg.width = photo.naturalWidth;
      mainImg.height = photo.naturalHeight;
    }
    loadDetail(item.getAttribute('data-slug') || '');
  };

  // The event's own filmstrip slots + content run. The page came with one
  // event's already in place (detail[data-slug]); any other is fetched from
  // event.php once and cached. A slower response than the visitor's next
  // click is simply dropped (currentSlug guard).
  const fragmentCache = {};
  let currentSlug = detail.getAttribute('data-slug') || '';
  // Whether the open morph has already revealed the strip's other slots —
  // slots that land after that animate in on their own (applyDetail).
  let heroShotsRevealed = true;
  const applyDetail = (data) => {
    getExtraShots().forEach((el) => { el.parentNode.removeChild(el); });
    heroTrack.insertAdjacentHTML('beforeend', data.hero || '');
    contentBox.innerHTML = data.content || '';
    detail.setAttribute('data-slug', data.slug || '');
    if (imagesPrimed) primeNewImages(detail);
    const fresh = getExtraShots();
    if (hasGsap && fresh.length) {
      if (heroShotsRevealed) {
        gsap.fromTo(fresh, { opacity: 0, x: 90 }, { opacity: 1, x: 0, duration: 0.9, ease: 'power3.out', stagger: 0.07 });
      } else {
        gsap.set(fresh, { opacity: 0, x: 90 });
      }
    }
    bindContent();
    bindReveals();
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  };
  const loadDetail = (slug) => {
    currentSlug = slug;
    if (!slug || slug === detail.getAttribute('data-slug')) return;
    const apply = (data) => { if (currentSlug === slug) applyDetail(data); };
    if (fragmentCache[slug]) { apply(fragmentCache[slug]); return; }
    const preview = /[?&]preview=1/.test(location.search) ? '&preview=1' : '';
    fetch('event.php?slug=' + encodeURIComponent(slug) + preview, { credentials: 'same-origin' })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('HTTP ' + res.status))))
      .then((data) => {
        fragmentCache[slug] = data;
        apply(data);
      })
      .catch((err) => { console.error('Event detail failed to load', err); });
  };

  // Rewind the detail to its pre-entrance state: scroll at the top, hero
  // pieces hidden, and the WHOLE content plane (plus the back button) blank —
  // during the morph only the white ground, the grid rails and the travelling
  // photo may show; everything else arrives after the photo has parked.
  // Stops the wheel glide (defined with the others stage below) so a target
  // set before a reset can't pull the scroller back afterwards.
  let resetGlide = () => {};

  const prepareHero = () => {
    resetGlide();
    scrollBox.scrollTop = 0;
    gsap.set(titleEl, { opacity: 0, y: 40 });
    heroShotsRevealed = false;
    gsap.set(getExtraShots(), { opacity: 0, x: 90 });
    gsap.set([scrollBox, closeBtn], { opacity: 0 });
    // The first slot holds the same photo the ghost is carrying — keep it
    // blank until the ghost lands, or both show at once mid-flight.
    gsap.set(mainImg, { opacity: 0 });
  };

  // `fromWithin` — an event clicked in the detail's own "інші івенти" stage:
  // the overlay is already up, so no page freeze, no history entry, no fade —
  // just the photo morph, with the event swap hidden behind the moment the
  // ghost covers the whole screen.
  const open = (item, fromWithin) => {
    if (isAnimating) return;
    if (fromWithin ? !isOpen : isOpen) return;
    const media = item.querySelector('.events-item__media');
    const photo = item.querySelector('.events-item__photo');
    if (!media || !photo) return;

    primeImages();

    if (!fromWithin) {
      isOpen = true;
      pageItem = item;
      canMorphBack = true;

      setPageFrozen(true);
      detail.classList.add('is-open');

      // The detail opens at its own scroll top — the header must be back on
      // show, whatever the page's scroll depth had done to it.
      const header = document.querySelector('.header');
      if (header) header.classList.remove('is-scroll-hidden');

      // Its own history entry, so browser Back closes the detail instead of
      // leaving the page — the "standalone page" illusion held up.
      if (!embedded) {
        history.pushState({ bfEventDetail: true }, '', eventUrl(item));
        pushedState = true;
      }

      if (!hasGsap) {
        swapEvent(item);
        scrollBox.scrollTop = 0;
        detail.style.opacity = '1';
        closeBtn.focus({ preventScroll: true });
        return;
      }
    } else {
      // The page behind still shows the ORIGINAL event — after a switch the
      // close morph has nowhere true to land, so it will fade instead.
      canMorphBack = false;
      if (pushedState && !embedded) history.replaceState({ bfEventDetail: true }, '', eventUrl(item));
      if (!hasGsap) {
        swapEvent(item);
        scrollBox.scrollTop = 0;
        return;
      }
    }

    isAnimating = true;
    // The inner page must not scroll while the morph plays — a swipe
    // mid-flight moves the hero slot the ghost is aiming for and reads as a
    // glitch. is-opening switches .event-detail__scroll to overflow: hidden.
    detail.classList.add('is-opening');

    ghost = makeGhost(photo.currentSrc || photo.src, media.getBoundingClientRect());
    // The item's own photo would keep standing under the take-off — blank it
    // for the flight. By the time the timeline ends the overlay has covered
    // the page completely, so it comes back unseen (and is in place again for
    // the close morph to land on).
    gsap.set(photo, { opacity: 0 });

    if (!fromWithin) {
      // The overlay is still invisible — swap and stage everything now.
      swapEvent(item);
      prepareHero();
    }

    const tl = gsap.timeline({
      onComplete: () => {
        isAnimating = false;
        detail.classList.remove('is-opening');
        photo.style.opacity = '';
        if (ghost) { ghost.remove(); ghost = null; }
        if (pendingPopClose) {
          pendingPopClose = false;
          close(true);
          return;
        }
        closeBtn.focus({ preventScroll: true });
      },
    });

    // The morph's mid-frame, per the design: not the full screen but a
    // centred stage of ~eight columns (1246×665 proportions), the white page
    // showing around it. Short viewports cap the height and keep the ratio.
    const frame = () => {
      let w = window.innerWidth * 0.65;
      let h = w * 665 / 1246;
      if (h > window.innerHeight * 0.78) {
        h = window.innerHeight * 0.78;
        w = h * 1246 / 665;
      }
      return { w, h };
    };

    // Act 1 — the photo grows into the centred frame; opening from the page,
    // the white overlay fades in underneath it at the same time.
    tl.to(ghost, {
      top: () => (window.innerHeight - frame().h) / 2,
      left: () => (window.innerWidth - frame().w) / 2,
      width: () => frame().w,
      height: () => frame().h,
      duration: 0.9,
      ease: 'power3.inOut',
    });
    if (!fromWithin) {
      tl.to(detail, { opacity: 1, duration: 0.45, ease: 'none' }, 0.3);
    } else {
      // The frame no longer covers the screen, so the swap can't hide behind
      // it — fade the overlay's content away instead (the white ground and
      // the travelling photo stay), then swap; prepareHero keeps the plane
      // blank until the shared reveal after act 2.
      tl.to([scrollBox, closeBtn], { opacity: 0, duration: 0.35, ease: 'power2.out' }, 0.25);
      tl.add(() => {
        swapEvent(item);
        prepareHero();
      });
    }

    // Act 2 — it settles into the head of the filmstrip. Function-based
    // values: measured when the tween starts, with the final overlay layout.
    tl.to(ghost, {
      top: () => mainShot.getBoundingClientRect().top,
      left: () => mainShot.getBoundingClientRect().left,
      width: () => mainShot.getBoundingClientRect().width,
      height: () => mainShot.getBoundingClientRect().height,
      duration: 0.9,
      ease: 'power3.inOut',
    }, '+=0.15');
    tl.addLabel('docked');

    // The instant the ghost lands, the slot photo takes over and the ghost
    // leaves — a seamless swap, never both at once.
    tl.add(() => {
      gsap.set(mainImg, { opacity: 1 });
      if (ghost) { ghost.remove(); ghost = null; }
    }, 'docked');

    // Act 3 — the content plane and the neighbouring photos start while the
    // photo is still SETTLING into its slot (halfway through the dock), so
    // the strip assembles around it without a dead beat.
    tl.to([scrollBox, closeBtn], { opacity: 1, duration: 0.5, ease: 'power2.out' }, 'docked-=0.45');
    tl.to(titleEl, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, '<0.05');
    // The other slots may still be on their way from event.php — resolve the
    // list the moment the reveal fires; slots landing later animate in from
    // applyDetail (heroShotsRevealed).
    tl.add(() => {
      heroShotsRevealed = true;
      gsap.to(getExtraShots(), {
        opacity: 1,
        x: 0,
        duration: 0.9,
        ease: 'power3.out',
        stagger: 0.07,
      });
    }, '<0.1');
  };

  // Landed on ?event=<slug> (a shared link, or the no-JS navigation): the page
  // came with that event's detail rendered — show it at once, no morph. Back
  // closes it and returns to the plain list URL.
  const openDirect = (item) => {
    if (isOpen) return;
    isOpen = true;
    pageItem = item;
    canMorphBack = false;
    primeImages();
    setPageFrozen(true);
    swapEvent(item);
    detail.classList.add('is-open');
    if (hasGsap) {
      gsap.fromTo(detail, { opacity: 0 }, { opacity: 1, duration: 0.7, ease: 'power2.out' });
    } else {
      detail.style.opacity = '1';
    }
    resetGlide();
    scrollBox.scrollTop = 0;
    if (!embedded) {
      history.replaceState(null, '', location.pathname);
      history.pushState({ bfEventDetail: true }, '', eventUrl(item));
      pushedState = true;
    }
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    closeBtn.focus({ preventScroll: true });
  };

  const close = (viaHistory) => {
    if (!isOpen || isAnimating) return;

    // Retire the history entry the open pushed. The popstate this triggers
    // finds isOpen already false and does nothing.
    if (pushedState && !viaHistory && !embedded) history.back();
    pushedState = false;

    isOpen = false;

    // The photo the morph lands ON — hidden for the flight (below), or the
    // standing copy under the fading overlay doubles the flying one.
    const itemImg = pageItem && pageItem.querySelector('.events-item__photo');

    const finish = () => {
      detail.classList.remove('is-open');
      detail.classList.remove('is-opening');
      detail.style.opacity = '';
      // Both stand-ins were blanked when the close morph took off — the slot
      // photo in the strip and the landing photo on the page.
      mainImg.style.opacity = '';
      if (itemImg) itemImg.style.opacity = '';
      setPageFrozen(false);
      if (ghost) { ghost.remove(); ghost = null; }
      const link = pageItem && pageItem.querySelector('.events-item__link');
      if (link) link.focus({ preventScroll: true });
      pageItem = null;
      isAnimating = false;
    };

    if (!hasGsap) { finish(); return; }

    isAnimating = true;

    const media = pageItem && pageItem.querySelector('.events-item__media');
    const target = media && media.getBoundingClientRect();
    const slot = mainShot.getBoundingClientRect();

    // The reverse morph only reads while the hero strip is still around, the
    // detail still shows the event it was opened from (canMorphBack), and the
    // item still holds a real place on the stage; otherwise a plain fade.
    const canMorph = canMorphBack && target && target.width > 4 &&
      scrollBox.scrollTop < window.innerHeight * 0.7 && slot.bottom > 0;

    if (!canMorph) {
      gsap.to(detail, { opacity: 0, duration: 0.45, ease: 'power2.in', onComplete: finish });
      return;
    }

    ghost = makeGhost(mainImg.currentSrc || mainImg.src, slot);
    // ONE photo in the air: the slot it takes off from and the page photo it
    // lands on both stay blank until the flight is over (finish restores
    // them — the ghost is gone the same instant, a seamless swap).
    gsap.set(mainImg, { opacity: 0 });
    if (itemImg) gsap.set(itemImg, { opacity: 0 });
    const tl = gsap.timeline({ onComplete: finish });
    tl.to(detail, { opacity: 0, duration: 0.5, ease: 'power2.in' }, 0);
    tl.to(ghost, {
      top: target.top,
      left: target.left,
      width: target.width,
      height: target.height,
      duration: 0.8,
      ease: 'power3.inOut',
    }, 0);
  };

  // "Інші івенти" at the detail's end: the page's items cloned into the
  // overlay, running the SAME stacked stage as the main list — just against
  // the overlay's own scroller. A click morphs the detail over to that event.
  const others = detail.querySelector('.events');
  const othersList = others && others.querySelector('.events__list');
  if (others && othersList) {
    items.forEach((item) => {
      const clone = item.cloneNode(true);
      // The originals already carry the main stage's inline styles and
      // is-active state — the clones must start clean.
      clone.classList.remove('is-active');
      clone.removeAttribute('style');
      Array.prototype.forEach.call(clone.querySelectorAll('[style]'), (el) => {
        el.removeAttribute('style');
      });
      othersList.appendChild(clone);
    });

    if (hasGsap && typeof ScrollTrigger !== 'undefined' && isDesktop()) {
      const stage = buildEventsStage(others, { scroller: scrollBox, snap: false });

      // Drive ALL wheel scrolling of the open overlay from JS. Two reasons:
      //   • the stage pins by transform, and a natively-scrolled (compositor-
      //     threaded) scroller updates that transform a frame late — jitter;
      //     JS-written scrollTop repositions the pin in the same frame;
      //   • raw deltas land as hard steps — the wheel feeds a TARGET and a
      //     rAF loop glides the scroller toward it, the same eased tempo the
      //     smoother gives the page behind.
      // The listener sits on the DOCUMENT in the capture phase: the GSAP
      // machinery left active under the overlay stops wheel propagation below
      // the document, so a listener down on the scroller never hears real
      // wheels — up here we are ahead of that. Touch is not affected (the
      // stage is desktop-only).
      // Tempo mirrors the page's stage: the page rides the 1.6s smoother and
      // snaps with a 0.55s tween that leaves at the speed it is already
      // moving. Here the wheel feeds a slow lerp (the momentum) and the
      // stride snap is handed to the same pickup-ease tween — the earlier
      // 0.14 lerp plus a lerp-driven snap read as "докрутка різко і швидко".
      const GLIDE = 0.08;
      const SNAP_DURATION = 0.55;
      let glideTarget = 0;
      let glideRaf = 0;
      let snapTimer = 0;
      let snapTween = null;
      let wheelDir = 1;
      let velocity = 0; // px/s the glide is moving at — the snap picks up from it
      resetGlide = () => {
        if (glideRaf) cancelAnimationFrame(glideRaf);
        if (snapTween) snapTween.kill();
        window.clearTimeout(snapTimer);
        snapTween = null;
        snapTimer = 0;
        glideRaf = 0;
        glideTarget = 0;
        velocity = 0;
      };
      // Write the scroll AND update ScrollTrigger in the same frame — the
      // pinned stage moves by transform, and left to its own ticker the pin
      // would follow the scroll one frame late (a visible wobble).
      const setScroll = (value) => {
        scrollBox.scrollTop = value;
        ScrollTrigger.update();
      };
      const glide = () => {
        const current = scrollBox.scrollTop;
        const next = current + (glideTarget - current) * GLIDE;
        velocity = (next - current) * 60;
        if (Math.abs(glideTarget - next) < 0.5) {
          setScroll(glideTarget);
          glideRaf = 0;
          velocity = 0;
          return;
        }
        setScroll(next);
        glideRaf = requestAnimationFrame(glide);
      };
      // The stage's snap, once the wheel goes quiet: the nearest event
      // boundary (biased the way the visitor was going) becomes the target,
      // and ONE tween takes over from the lerp — leaving at the glide's
      // current speed, arriving at rest. Past the last event the scroll is
      // free, so the stage can hand off to whatever follows. Same rules as
      // the stage's own snapTo, minus the second scroll driver.
      const snapToStage = () => {
        snapTimer = 0;
        if (!isOpen || isAnimating || !stage || !stage.trigger) return;
        const start = stage.trigger.start;
        const end = stage.trigger.end;
        const n = stage.count;
        if (!(end > start) || n < 2) return;
        const step = (end - start) / n;
        const pos = glideRaf ? glideTarget : scrollBox.scrollTop;
        const seg = (pos - start) / step;
        if (seg < -0.5 || seg >= n - 1 - 1e-4) return;
        const index = wheelDir < 0 ? Math.floor(seg + 0.08) : Math.ceil(seg - 0.15);
        const target = start + Math.max(0, Math.min(n - 1, index)) * step;
        const from = scrollBox.scrollTop;
        if (Math.abs(target - from) < 0.5) return;
        if (glideRaf) cancelAnimationFrame(glideRaf);
        glideRaf = 0;
        glideTarget = target;
        const proxy = { y: from };
        snapTween = gsap.to(proxy, {
          y: target,
          duration: SNAP_DURATION,
          ease: makePickupEase(velocity, target - from, SNAP_DURATION),
          onUpdate: () => setScroll(proxy.y),
          onComplete: () => {
            snapTween = null;
            velocity = 0;
          },
        });
      };
      document.addEventListener('wheel', (e) => {
        if (!isOpen) return;
        e.preventDefault();
        // Trackpad momentum keeps sending wheel events for a second after the
        // click that switches events. Swallow them while the morph plays —
        // otherwise they'd re-target the glide to where the visitor WAS and
        // drag the freshly reset scroller back down to the "інші івенти".
        if (isAnimating) return;
        // deltaMode 1 = lines (Firefox mouse wheels) — normalize to pixels.
        const dy = e.deltaMode === 1 ? e.deltaY * 40 : e.deltaY;
        if (dy) wheelDir = dy < 0 ? -1 : 1;
        // Any input abandons a running snap on the spot (as on the page).
        if (snapTween) {
          snapTween.kill();
          snapTween = null;
        }
        // While the glide is idle anything may have moved the scroll (an open
        // reset, a refresh, the snap) — restart from where it actually is.
        if (!glideRaf) glideTarget = scrollBox.scrollTop;
        glideTarget = Math.max(0, Math.min(
          scrollBox.scrollHeight - scrollBox.clientHeight,
          glideTarget + dy
        ));
        if (!glideRaf) glideRaf = requestAnimationFrame(glide);
        window.clearTimeout(snapTimer);
        snapTimer = window.setTimeout(snapToStage, 140);
      }, { passive: false, capture: true });
    } else {
      others.classList.add('is-plain');
    }

    Array.prototype.forEach.call(othersList.querySelectorAll('.events-item'), (item) => {
      const link = item.querySelector('.events-item__link');
      if (!link) return;
      link.addEventListener('click', (e) => {
        e.preventDefault();
        open(item, true);
      });
    });
  }

  items.forEach((item) => {
    const link = item.querySelector('.events-item__link');
    if (!link) return;
    link.addEventListener('click', (e) => {
      e.preventDefault();
      open(item, false);
    });
  });

  closeBtn.addEventListener('click', () => close(false));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen && !isAnimating) close(false);
  });
  window.addEventListener('popstate', () => {
    if (embedded || !isOpen) return;
    if (isAnimating) {
      // The entry is popped either way — remember that, close when possible.
      pushedState = false;
      pendingPopClose = true;
      return;
    }
    close(true);
  });
  // The parent's Back button, relayed by initEmbeddedPage.
  document.addEventListener('bf:close-detail', () => {
    if (!isOpen) return;
    if (isAnimating) { pendingPopClose = true; return; }
    close(true);
  });

  if (detail.getAttribute('data-open') === '1') {
    const wanted = detail.getAttribute('data-slug');
    const initial = items.filter((it) => it.getAttribute('data-slug') === wanted)[0];
    if (initial) {
      // The "Наші події" headline pour is the preloader of a deep-linked
      // event: the detail fades in once it has finished (or after a safety
      // timeout, should the pour never report).
      let opened = false;
      const go = () => { if (!opened) { opened = true; openDirect(initial); } };
      if (hasGsap && document.querySelector('.events__title')) {
        document.addEventListener('bf:events-title-poured', go, { once: true });
        window.setTimeout(go, 8000);
      } else {
        go();
      }
    }
  }
}

// Mobile-only: squash the hero video by height as the user scrolls. (Desktop
// does this in initParallax; on mobile it doesn't run.)
function initIntroMobile() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const hero = document.querySelector('.intro__visual--1');
  const scene = document.querySelector('.scene-1');
  if (!hero || !scene) return;

  const video = hero.querySelector('.intro__video');

  // Mobile hero aspect-ratio is 355 / 228 (_intro.sass).
  const fullHeight = () => hero.getBoundingClientRect().width * 228 / 355;
  const minScale = () => Math.max(0.12, 40 / Math.max(fullHeight(), 1));

  // Squash via scaleY, NOT height: height/margin are layout properties, and
  // scrubbing them reflowed the whole document on every scroll frame — on
  // phones that's heavy enough (with three videos playing) to visibly hitch
  // the scroll right at this spot. Transforms never touch layout, so the
  // hero's footprint stays constant for free (which is what the old
  // margin-bottom compensation existed for) and the .about pin start stays
  // correct. The video gets the inverse scale so it crops instead of
  // squashing — no distortion, same collapsing look as before.
  //
  // The squash is mapped over SQUASH_SCROLL of the viewport height: smaller =
  // faster/sharper squash. Kept short on purpose so it reads as the video
  // collapsing rather than just scrolling up past the viewport.
  const SQUASH_SCROLL = 0.22;
  const squash = { k: 1 };

  gsap.set(hero, { transformOrigin: '50% 0' });
  if (video) gsap.set(video, { transformOrigin: '50% 0' });

  gsap.fromTo(squash,
    { k: 1 },
    {
      k: () => minScale(),
      ease: 'none',
      scrollTrigger: {
        trigger: scene,
        start: 'top top',
        end: () => '+=' + window.innerHeight * SQUASH_SCROLL,
        scrub: true,
        invalidateOnRefresh: true,
      },
      onUpdate: () => {
        gsap.set(hero, { scaleY: squash.k });
        if (video) gsap.set(video, { scaleY: 1 / squash.k });
      },
    }
  );
}

// Mobile-only: gentle scroll parallax for the be-best videos + photos. (On
// desktop initParallax handles this; on mobile it doesn't run.)
function initBeBestMobile() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.be-best');
  if (!section) return;

  // [selector, travel] — bigger travel = appears to move faster (further back/front).
  // The whole item--1 (photo + "Paris" text) moves together; photo amplitudes
  // are spread far apart so the two columns don't feel synchronised.
  const layers = [
    ['.be-best__videos .intro__visual--2', 30],
    ['.be-best__videos .intro__visual--3', 92],
    ['.be-best__item--1', 16],
    ['.be-best__item--2', 54],
  ];

  layers.forEach(([selector, amount]) => {
    const el = section.querySelector(selector);
    if (!el) return;
    gsap.fromTo(el,
      { yPercent: amount / 2 },
      {
        yPercent: -amount / 2,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  });
}

// Mobile-only: scroll parallax for the what-we-do collage. Mirrors the desktop
// divergence (initWhatWeDo) — photos lead, the blurred decoratives drift the most
// for depth, the number/text groups move least so the copy stays legible, and
// each photo's own caption rides with it so an item travels as one layer instead
// of splitting apart. Travel is a fraction of the viewport HEIGHT (not yPercent),
// so every element shifts a visible, consistent amount regardless of its own
// small size — yPercent on the tiny mobile photos/numbers was barely perceptible.
function initWhatWeDoMobile() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.what-we-do');
  if (!section) return;

  // amount is a depth weight; peak-to-peak travel in px = amount * UNIT * vh.
  // Bigger amount = moves faster/further (reads as nearer/quicker), except the
  // blurred decoratives which drift furthest to sit "behind" everything. UNIT is
  // tuned for a clearly visible spread over the long (~section + 1 screen) scroll.
  const UNIT = 0.021; // amount 30 -> ~0.63vh peak-to-peak; amount 56 -> ~1.18vh
  // [selector, amount]. item-2/4/8/9 are display:contents on mobile, so we drive
  // their child photos + captions directly, not the (box-less) wrappers.
  const layers = [
    // Main photos + their captions ride together as one depth layer. Amplitudes
    // are deliberately spread so each item travels at a different speed (no two
    // close) instead of the whole collage moving at one tempo.
    ['.what-we-do__photo-2', 22],
    ['.what-we-do__item-2 .what-we-do__subtitle', 22],
    ['.what-we-do__photo-4', 34],
    ['.what-we-do__item-4 .what-we-do__subtitle', 34],
    ['.what-we-do__photo-8', 38],
    ['.what-we-do__item-8 .what-we-do__subtitle', 38],
    ['.what-we-do__photo-9', 16],
    ['.what-we-do__item-9 .what-we-do__subtitle', 16],
    // Blurred decoratives — drift the most (background accents, like desktop's fly-up)
    ['.what-we-do__item-1', 46],
    ['.what-we-do__photo-2-1', 62],
    ['.what-we-do__item-8 .what-we-do__photo-8-1', 52],
    ['.what-we-do__item-4 .what-we-do__photo-4-1', 58],
    // Number + footnote groups — move least so the numerals/copy stay legible
    ['.what-we-do__item-3', 10],
    ['.what-we-do__item-6', 24],
    ['.what-we-do__item-7', 14],
    ['.what-we-do__item-10', 20],
  ];

  layers.forEach(([selector, amount]) => {
    const el = section.querySelector(selector);
    if (!el) return;
    // Function-based travel so it recomputes on ScrollTrigger refresh (the mobile
    // viewport height changes as the Safari URL bar shows/hides).
    const travel = () => amount * UNIT * window.innerHeight;
    gsap.fromTo(el,
      { y: () => travel() / 2 },
      {
        y: () => -travel() / 2,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  });
}

// Mobile-only: hide the fixed corner signs (est.2017 / Fashion Media) while the
// bf-gallery-section is the active sticky view, so they don't sit on top of the
// full-bleed depth-gallery photos. Reuses the .is-hidden class (opacity:0).
function initGalleryDecSignsMobile() {
  if (typeof ScrollTrigger === 'undefined') return;
  const section = document.querySelector('.bf-gallery-section');
  const decSigns = document.querySelectorAll('.dec-sign');
  if (!section || !decSigns.length) return;

  ScrollTrigger.create({
    trigger: section,
    start: 'top top',
    end: 'bottom bottom',
    onToggle: (self) => {
      decSigns.forEach((s) => s.classList.toggle('is-hidden', self.isActive));
    },
  });
}

function initMobileMenu() {
  const menu = document.querySelector('.header-mobile-menu');
  const header = document.querySelector('.header');
  const burger = document.querySelector('.header-burger');
  if (!menu || !burger) return;

  const burgerText = burger.querySelector('.header-burger__text');
  const navItems = menu.querySelectorAll('.header-nav__item, .header-social');
  const hasGsap = typeof gsap !== 'undefined';

  // Swap the burger label letter-by-letter (Menu <-> Close) with GSAP.
  const setLabel = (word) => {
    if (!burgerText) return;
    if (!hasGsap) {
      burgerText.textContent = word;
      return;
    }
    burgerText.innerHTML = word
      .split('')
      .map((ch) => `<span class="header-burger__char">${ch}</span>`)
      .join('');
    gsap.from(burgerText.querySelectorAll('.header-burger__char'), {
      yPercent: 70,
      autoAlpha: 0,
      stagger: 0.035,
      duration: 0.28,
      ease: 'power2.out',
    });
  };

  // The burger toggles: hamburger + "Menu" <-> X + "Close". Opening adds
  // .is-menu-open to the header (burger -> X, instagram -> language switcher)
  // and slides the menu up; the header bar stays put on top.
  const setOpen = (open) => {
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (header) header.classList.toggle('is-menu-open', open);
    // Lock scroll without a layout jump (reserves the scrollbar gutter).
    document.documentElement.classList.toggle('is-menu-lock', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Закрити меню' : 'Відкрити меню');
    setLabel(open ? 'Close' : 'Menu');

    // Gentle staggered entrance of the nav items. The delay lets the panel
    // finish rising first (~0.45s), then items ride in slowly so it's visible.
    if (open && hasGsap && navItems.length) {
      gsap.fromTo(navItems,
        { y: 40, autoAlpha: 0 },
        {
          y: 0,
          autoAlpha: 1,
          stagger: 0.12,
          duration: 0.7,
          ease: 'power3.out',
          delay: 0.45,
          overwrite: true,
        }
      );
    }
  };

  burger.addEventListener('click', () => {
    setOpen(!menu.classList.contains('is-open'));
  });

  // Close when a nav link is tapped (nav links also scroll via initHeaderNav).
  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setOpen(false));
  });
}

// Mobile-only: hide the fixed header while scrolling down, bring it back on
// scroll up (and always near the very top). The DELTA dead-zone filters the
// 1–2px jitter iOS fires around the URL-bar collapse, and scrollY is clamped
// to 0 so the rubber-band bounce doesn't read as a direction change.
function initHeaderHideMobile() {
  const header = document.querySelector('.header');
  if (!header) return;

  const DELTA = 8;
  let lastY = Math.max(0, window.scrollY);

  window.addEventListener('scroll', () => {
    const y = Math.max(0, window.scrollY);

    // While the menu is open the page is scroll-locked; ignore stray events
    // so the bar (with the Close button) can never slide away.
    if (header.classList.contains('is-menu-open')) {
      lastY = y;
      return;
    }

    if (y <= header.offsetHeight) {
      header.classList.remove('is-scroll-hidden');
    } else if (y > lastY + DELTA) {
      header.classList.add('is-scroll-hidden');
    } else if (y < lastY - DELTA) {
      header.classList.remove('is-scroll-hidden');
    } else {
      return; // inside the dead-zone — keep lastY anchored
    }
    lastY = y;
  }, { passive: true });

  // The event detail overlay scrolls its own box, not the window — mirror the
  // same hide/show against that scroller, or the header would keep whatever
  // state the page's scroll left it in for the whole overlay visit.
  const detailScroll = document.querySelector('.event-detail__scroll');
  if (detailScroll) {
    let lastBoxY = 0;
    detailScroll.addEventListener('scroll', () => {
      const y = Math.max(0, detailScroll.scrollTop);

      if (header.classList.contains('is-menu-open')) {
        lastBoxY = y;
        return;
      }

      if (y <= header.offsetHeight) {
        header.classList.remove('is-scroll-hidden');
      } else if (y > lastBoxY + DELTA) {
        header.classList.add('is-scroll-hidden');
      } else if (y < lastBoxY - DELTA) {
        header.classList.remove('is-scroll-hidden');
      } else {
        return;
      }
      lastBoxY = y;
    }, { passive: true });
  }
}

// Mobile-only: turn the reviews list into a tap-to-open accordion. Tapping a
// name reveals its review video (from data-img) below it, with the Google
// rating + "Дивитись відгук" button overlaid on the bottom-left.
function initReviewsMobile() {
  const section = document.querySelector('.reviews');
  if (!section) return;

  const items = section.querySelectorAll('.reviews__name');
  if (!items.length) return;

  const header = document.querySelector('.header');
  const canScroll = typeof gsap !== 'undefined' && typeof ScrollToPlugin !== 'undefined';
  if (canScroll) gsap.registerPlugin(ScrollToPlugin);

  items.forEach((item) => {
    const src = item.getAttribute('data-img');
    const link = item.querySelector('.reviews__item-link');

    const media = document.createElement('div');
    media.className = 'reviews__media';

    if (src) {
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      img.className = 'reviews__media-img';
      media.appendChild(img);
    }

    // Move the play button into the media panel — it becomes the top-right
    // "watch video" control over the opened photo (positioned in _reviews.sass;
    // its .reviews__item-media parent is display:none on mobile, so the button
    // is only visible once moved here). initReviewsVideo runs AFTER this, wires
    // every .reviews__item-play to the lightbox and resolves the source via
    // closest('.reviews__name'), so the button keeps working after the move.
    const play = item.querySelector('.reviews__item-play');
    if (play) media.appendChild(play);

    // Move the existing Google link into the media panel as an overlay pill.
    if (link) media.appendChild(link);

    item.appendChild(media);

    // ResizeObserver below handles this in modern browsers. Keep a
    // transition-end fallback for older ones.
    if (typeof ResizeObserver === 'undefined') {
      media.addEventListener('transitionend', (e) => {
        if (e.propertyName === 'max-height' && typeof ScrollTrigger !== 'undefined') {
          ScrollTrigger.refresh();
        }
      });
    }

    const trigger = item.querySelector('.reviews__name-text') || item;
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const willOpen = !item.classList.contains('is-open');

      // Any review currently open ABOVE this one is about to collapse, which
      // shifts this item up. Measure how much before changing classes, so we
      // scroll to the item's FINAL position (else the page slides out from
      // under the scroll and lands way off).
      const itemTop = item.getBoundingClientRect().top;
      let shrinkAbove = 0;
      items.forEach((other) => {
        if (other === item || !other.classList.contains('is-open')) return;
        if (other.getBoundingClientRect().top >= itemTop) return; // only above
        const media = other.querySelector('.reviews__media');
        if (media) {
          shrinkAbove += media.getBoundingClientRect().height +
            (parseFloat(getComputedStyle(media).marginTop) || 0);
        }
      });

      items.forEach((other) => other.classList.remove('is-open'));
      if (!willOpen) return;

      item.classList.add('is-open');

      // Scroll the opened review to just below the fixed header, accounting for
      // the collapse above.
      if (canScroll) {
        const headerH = header ? header.offsetHeight : 0;
        const targetY = Math.max(0, window.scrollY + itemTop - headerH - shrinkAbove);
        gsap.to(window, {
          duration: 0.6,
          scrollTo: { y: targetY, autoKill: false },
          ease: 'power2.inOut',
        });
      }
    });
  });

}

function initHeaderNav() {
  if (typeof gsap === 'undefined' || typeof ScrollToPlugin === 'undefined') return;
  gsap.registerPlugin(ScrollToPlugin);

  const links = document.querySelectorAll('.header-nav__link[data-target], .footer__nav-link[data-target]');
  if (!links.length) return;

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(link.dataset.target);
      if (!target) {
        // Sub-pages (events.html) share the header/footer includes, but the
        // sections these anchors point at only exist on the home page — so send
        // the click there instead of swallowing it.
        const href = link.getAttribute('href') || '';
        if (href.charAt(0) === '#') window.location.href = './' + href;
        return;
      }

      // The mobile menu locks scroll (html.is-menu-lock { overflow:hidden }) and
      // closes via a separate handler on the same click. Defer one frame so the
      // lock is removed and the window is scrollable before we animate, and keep
      // autoKill off so the scroll-position shift from unlocking doesn't cancel
      // the tween.
      requestAnimationFrame(() => {
        scrollPageTo(target, { duration: 1.2, ease: 'power3.inOut' });
      });
    });
  });
}

// The footer button scrolls back to the very top of the page.
function initFooterButton() {
  const btn = document.querySelector('.btn-footer');
  if (!btn) return;

  const hasGsap = typeof gsap !== 'undefined' && typeof ScrollToPlugin !== 'undefined';
  if (hasGsap) gsap.registerPlugin(ScrollToPlugin);

  btn.addEventListener('click', (e) => {
    e.preventDefault();

    if (hasGsap) {
      scrollPageTo(0, { duration: 1.2, ease: 'power3.inOut' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
}

// Mobile-only: the whole Malika sequence plays INSIDE layer 1 on one pinned
// screen. Layer 2 is hidden and used only as a source of the "next" photos /
// text. On scroll: the left photo drifts DOWN and the right photo rises UP
// while each image cross-fades to its next shot, the instagram button + lower
// text swap out, and "Беатріче" flies to the left edge.
function initMalikaMobile() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const scene = document.querySelector('.scene-3');
  if (!scene) return;

  const layer1 = scene.querySelector('.malika__layer--1');
  const layer2 = scene.querySelector('.malika__layer--2');
  if (!layer1) return;

  const name = scene.querySelector('.malika__name');
  const title = name && name.querySelector('.malika__title');
  const em = title && title.querySelector('em');

  // The name lives in .scene-3 (outside the sticky .malika), so its absolute
  // bottom was measured against the whole 250vh track. Move it inside the
  // sticky viewport (mobile only) so it shares the same coordinate space.
  const malikaEl = scene.querySelector('.malika');
  if (malikaEl && name && name.parentElement !== malikaEl) malikaEl.appendChild(name);

  const nameContent = layer1.querySelector('.malika__description');
  const remPx = () => parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;

  // Anchor the name from the TOP (not the bottom): its `top` is tied to the
  // bottom of the description, which is a fixed offset inside .malika — so it
  // never jumps when the mobile URL bar shows/hides (a bottom-anchored value
  // would). It sits just under the description, leaving the space below it to
  // absorb the URL bar, so the bar can't cover it. We size against the stable
  // clientHeight (the layout viewport doesn't breathe with the bar); if the
  // text wouldn't clear the bar/footer zone on small screens, shrink
  // role/title/lead/text proportionally (via --malika-tscale) until it does.
  const positionName = () => {
    if (!name || !malikaEl) return;
    const vh = document.documentElement.clientHeight || window.innerHeight;
    const gap = Math.max(remPx(), Math.round(vh * 0.02)); // >= 1rem under the description
    // Target the name's BOTTOM at ~84% of the (stable) viewport, so the whole
    // block fills ~80-85% and only a small gap is left for the URL bar + footer.
    const targetBottom = vh - Math.round(vh * 0.16);
    const MIN_SCALE = 0.9;

    let scale = 1;
    malikaEl.style.setProperty('--malika-tscale', scale);

    for (let i = 0; i < 12; i++) {
      const malikaTop = malikaEl.getBoundingClientRect().top;
      const contentBottom = nameContent
        ? nameContent.getBoundingClientRect().bottom - malikaTop
        : 0;
      const nameH = name.getBoundingClientRect().height;
      // Fixed px from the top (stable — no URL-bar jump): name bottom ≈ 84%.
      const top = targetBottom - nameH;

      // OK when the name still clears the description above it (>= 1rem gap).
      if (top >= contentBottom + gap || scale <= MIN_SCALE) {
        name.style.top = Math.round(Math.max(contentBottom + gap, top)) + 'px';
        break;
      }
      // Description too tall to fit above the name → shrink text and retry.
      scale = Math.max(MIN_SCALE, Math.round((scale - 0.05) * 100) / 100);
      malikaEl.style.setProperty('--malika-tscale', scale);
    }
  };
  positionName();
  window.addEventListener('load', positionName);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(positionName);

  const fLeft = layer1.querySelector('.malika__photo-frame--1');  // narrow, starts high
  const fRight = layer1.querySelector('.malika__photo-frame--2'); // wide, starts low
  const instagram = layer1.querySelector('.malika__instagram');
  const text = layer1.querySelector('.malika__text');

  // Pull the "next" content out of layer 2 (which never renders on mobile).
  const nextPhotos = layer2 ? layer2.querySelectorAll('.malika__photo') : [];
  const nextLeftSrc = nextPhotos[0] ? nextPhotos[0].getAttribute('src') : null;
  const nextRightSrc = nextPhotos[1] ? nextPhotos[1].getAttribute('src') : null;
  const nextTextSrc = layer2 ? layer2.querySelector('.malika__text') : null;

  // Overlay the next image on top of a frame's current photo.
  const addNextImg = (frame, src) => {
    if (!frame || !src) return null;
    const img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.className = 'malika__photo malika__photo--next';
    frame.appendChild(img);
    return img;
  };
  const nextLeft = addNextImg(fLeft, nextLeftSrc);
  const nextRight = addNextImg(fRight, nextRightSrc);

  // Wrap the gray paragraph + an overlaid copy of the next text for a cross-fade.
  let nextText = null;
  if (text && nextTextSrc) {
    const wrap = document.createElement('div');
    wrap.className = 'malika__text-swap';
    text.parentNode.insertBefore(wrap, text);
    wrap.appendChild(text);
    nextText = nextTextSrc.cloneNode(true);
    nextText.classList.add('malika__text--next');
    wrap.appendChild(nextText);
  }

  const overlays = [nextLeft, nextRight, nextText].filter(Boolean);
  gsap.set(overlays, { autoAlpha: 0 });
  if (name) gsap.set(name, { autoAlpha: 1 });
  if (em) gsap.set(em, { x: 0 });

  const rem = () => parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
  const shift = () => 7 * rem(); // vertical travel of the slots

  // How far "Беатріче" needs to travel to sit flush against the left edge.
  const flyDistance = () => {
    if (!title || !em) return 0;
    return Math.max(0, title.clientWidth - em.offsetWidth);
  };

  // No ScrollTrigger pin: .scene-3 is a 250vh track and .malika is
  // position:sticky (see _malika.sass), so the storyboard scrubs over the stuck
  // window — from when the section tops out ('top top') until its bottom reaches
  // the viewport bottom ('bottom bottom'), i.e. the 150vh the sticky stays put.
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: scene,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.4,
      invalidateOnRefresh: true,
    },
  });

  const S = 'swap';

  tl.to({}, { duration: 0.35 }); // hold state 1

  // Slots move: left photo down, right photo up.
  if (fLeft) tl.to(fLeft, { y: () => shift(), ease: 'power1.inOut', duration: 0.4 }, S);
  if (fRight) tl.to(fRight, { y: () => -shift(), ease: 'power1.inOut', duration: 0.4 }, S);

  // Images cross-fade to the next shot mid-move.
  if (nextLeft) tl.to(nextLeft, { autoAlpha: 1, duration: 0.3 }, S + '+=0.05');
  if (nextRight) tl.to(nextRight, { autoAlpha: 1, duration: 0.3 }, S + '+=0.05');

  // Instagram disappears; the lower text swaps.
  if (instagram) tl.to(instagram, { autoAlpha: 0, duration: 0.2 }, S);
  if (nextText) {
    tl.to(text, { autoAlpha: 0, duration: 0.25 }, S);
    tl.to(nextText, { autoAlpha: 1, duration: 0.25 }, S + '+=0.08');
  }

  // "Беатріче" flies to the left edge while "Маліка" stays put.
  if (em) tl.to(em, { x: () => -flyDistance(), ease: 'power2.inOut', duration: 0.4 }, S);

  tl.to({}, { duration: 0.35 }); // hold state 2
}

function initWhatWeDo() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const block = document.querySelector('.what-we-do');
  if (!block) return;

  // Solid black background while the section occupies the viewport, so a
  // dome/refresh glitch can never flash a white background (the dec dome only
  // handles the radial transition at the edges).
  ScrollTrigger.create({
    trigger: block,
    start: 'top top',
    end: 'bottom top',
    invalidateOnRefresh: true,
    toggleClass: { targets: block, className: 'is-filled' },
  });

  const reveal = document.querySelector('.what-we-do__reveal');
  if (reveal) {
    ScrollTrigger.create({
      trigger: block,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => gsap.to(reveal, { autoAlpha: 1, duration: 0.2, overwrite: 'auto' }),
      onLeave: () => gsap.to(reveal, { autoAlpha: 0, duration: 0.2, overwrite: 'auto' }),
      onEnterBack: () => gsap.to(reveal, { autoAlpha: 1, duration: 0.2, overwrite: 'auto' }),
      onLeaveBack: () => gsap.to(reveal, { autoAlpha: 0, duration: 0.2, overwrite: 'auto' }),
    });

    const getMaxDomeR = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      return Math.ceil(Math.sqrt((w / 2) * (w / 2) + h * h)) + 40;
    };

    const domeProxy = { r: 0 };
    gsap.to(domeProxy, {
      r: () => getMaxDomeR(),
      ease: 'none',
      scrollTrigger: {
        trigger: block,
        // Hold the radial reveal at 0 until .what-we-do is genuinely taking over
        // the viewport. 'top 120%' started it while .you-can was still the main
        // view, so the black dome peeked in at the you-can bottom too early.
        start: 'top 60%',
        end: 'top 0%',
        scrub: true,
        invalidateOnRefresh: true,
      },
      onUpdate: () => {
        reveal.style.setProperty('--dome-r', domeProxy.r + 'px');
      },
    });
  }

  const dec = document.querySelector('.what-we-do__dec');
  if (dec) {
    const getMaxDecRadius = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      return Math.ceil(Math.sqrt((w / 2) * (w / 2) + h * h)) + 40;
    };

    // Two INDEPENDENT proxies combined with min(), instead of one shared proxy
    // driven by two scrub tweens. The old shared decProxy let the exit tween's
    // "from: max" bleed into the entrance, so the circle was already fully open
    // while .you-can was still on screen. With min(): before the section in=0 /
    // out=max → 0; through the middle both max → max; only the active edge moves.
    const decIn = { r: 0 };                       // entrance: 0 → max
    const decOut = { r: getMaxDecRadius() };       // exit: max → 0 (starts open)
    const updateDecRadius = () => {
      dec.style.setProperty('--what-we-do-dec-r', Math.min(decIn.r, decOut.r) + 'px');
    };
    const setDecOrigin = (y) => {
      dec.style.setProperty('--what-we-do-dec-y', y);
    };

    dec.style.setProperty('--what-we-do-dec-r', '0px');
    setDecOrigin('100%');

    // Entrance: grow from the bottom as .what-we-do enters from the viewport
    // bottom ('top 100%'), so it starts filling the gap right away instead of
    // leaving empty space between the sections. (min() still holds it at 0 while
    // .you-can is the main view, so it can't crawl over the you-can content.)
    gsap.to(decIn, {
      r: () => getMaxDecRadius(),
      ease: 'none',
      scrollTrigger: {
        trigger: block,
        start: 'top 100%',
        end: 'top 0%',
        scrub: true,
        invalidateOnRefresh: true,
      },
      onStart: () => setDecOrigin('100%'),
      onReverseComplete: () => setDecOrigin('100%'),
      onUpdate: updateDecRadius,
    });

    // Exit: shrink toward the top. 'bottom 30%' clears the circle before the next
    // section is in view; .is-filled keeps the block black to 'bottom top' so
    // nothing flashes white.
    gsap.fromTo(decOut,
      { r: () => getMaxDecRadius() },
      {
        r: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: block,
          start: 'bottom bottom',
          end: 'bottom 30%',
          scrub: true,
          invalidateOnRefresh: true,
          onEnter: () => setDecOrigin('0%'),
          onEnterBack: () => setDecOrigin('0%'),
          onLeaveBack: () => setDecOrigin('100%'),
        },
        onUpdate: updateDecRadius,
      }
    );
  }

  const PHOTO_PARALLAX = [-46, -28, -58, -34, -64, -42];
  const allPhotos = gsap.utils.toArray(block.querySelectorAll('[class*="__photo"]'));
  const isBlurred = (el) => /__photo-\d+-1$/.test(el.className);

  const delayedStartPhoto = block.querySelector('.what-we-do__photo-1');
  const strongEndPhoto = block.querySelector('.what-we-do__photo-11');
  const mainPhotos = allPhotos.filter((p) => !isBlurred(p) && p !== strongEndPhoto && p !== delayedStartPhoto);
  // This main photo starts dropped further down than the rest before settling.
  const lowStartPhoto = block.querySelector('.what-we-do__item-8 .what-we-do__photo-8');
  // Blurred secondary photos (__photo-2-1, 4-1, 8-1, 11-1): start noticeably
  // lower and fly up higher/faster than the main photos. The last one (item-11)
  // sits near the section's bottom and is handled separately below so the exit
  // fade doesn't cut its fly-out short.
  const lastBlurredPhoto = block.querySelector('.what-we-do__item-11 .what-we-do__photo-11-1');
  const blurredPhotos = allPhotos.filter((p) => isBlurred(p) && p !== lastBlurredPhoto);

  // Fade the photos out at the very start of the section's exit. They sit in
  // FRONT of the dec circle, so the collapsing dec alone can't hide them — they
  // linger over the page while it shrinks. Fading them here (over the first bit
  // of the exit, before they ride up to the top) clears them out before the
  // collapse uncovers the next section. Only the last screen's photos are still
  // on-screen this late, so fading the rest is a harmless no-op.
  gsap.to(allPhotos, {
    autoAlpha: 0,
    ease: 'none',
    scrollTrigger: {
      trigger: block,
      start: 'bottom bottom',
      end: 'bottom 75%',
      scrub: true,
      invalidateOnRefresh: true,
    },
  });

  mainPhotos.forEach((photo, i) => {
    gsap.set(photo, { y: photo === lowStartPhoto ? 200 : 60 });
    gsap.to(photo, {
      y: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: photo,
        start: 'top 90%',
        end: 'top 50%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });

    const intensity = PHOTO_PARALLAX[i % PHOTO_PARALLAX.length];
    gsap.fromTo(photo,
      { yPercent: -intensity / 2 },
      {
        yPercent: intensity / 2,
        ease: 'none',
        scrollTrigger: {
          trigger: photo,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  });

  if (delayedStartPhoto) {
    gsap.set(delayedStartPhoto, { y: 340 });
    gsap.to(delayedStartPhoto, {
      y: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: delayedStartPhoto,
        start: 'top 30%',
        end: 'top -10%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });

    gsap.fromTo(delayedStartPhoto,
      { yPercent: 35 },
      {
        yPercent: -45,
        ease: 'none',
        scrollTrigger: {
          trigger: delayedStartPhoto,
          start: 'top 55%',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  }

  if (strongEndPhoto) {
    gsap.set(strongEndPhoto, { y: 60 });
    gsap.to(strongEndPhoto, {
      y: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: strongEndPhoto,
        start: 'top 90%',
        end: 'top 50%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });

    gsap.fromTo(strongEndPhoto,
      { yPercent: 35 },
      {
        yPercent: -155,
        ease: 'none',
        scrollTrigger: {
          trigger: strongEndPhoto,
          start: 'top bottom',
          end: 'top -80%',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  }

  blurredPhotos.forEach((photo) => {
    // Start lower than the main photos so they have further to travel.
    gsap.set(photo, { y: 220 });
    gsap.to(photo, {
      y: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: photo,
        start: 'top 20%',
        end: 'top -20%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });

    // Faster parallax + much bigger upward fly-out than the main photos.
    gsap.fromTo(photo,
      { yPercent: 45 },
      {
        yPercent: -300,
        ease: 'none',
        scrollTrigger: {
          trigger: photo,
          start: 'top 55%',
          end: 'top -120%',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  });

  // item-11 is the last block, near the section's exit fade. Fly it up fast and
  // early — the full (and much bigger) travel completes while it's still high on
  // screen, so it visibly shoots far up before the fade can catch it.
  if (lastBlurredPhoto) {
    gsap.set(lastBlurredPhoto, { y: 220 });
    gsap.to(lastBlurredPhoto, {
      y: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: lastBlurredPhoto,
        start: 'top 20%',
        end: 'top -20%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });

    gsap.fromTo(lastBlurredPhoto,
      { yPercent: 45 },
      {
        yPercent: -360,
        ease: 'none',
        scrollTrigger: {
          trigger: lastBlurredPhoto,
          start: 'top bottom',
          end: 'top 30%',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  }

  // Numbers ride in with extra gap ABOVE their caption, then shrink to their
  // base position as you scroll. They only ever move up (never below base), so
  // the big numerals never overlap the caption below them.
  const numbers = gsap.utils.toArray(block.querySelectorAll('.what-we-do__number'));
  numbers.forEach((num) => {
    gsap.fromTo(num,
      { yPercent: -12 },
      {
        yPercent: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: num,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  });

  const subtitles = gsap.utils.toArray(block.querySelectorAll('.what-we-do__subtitle'));
  subtitles.forEach((sub) => {
    gsap.fromTo(sub,
      { yPercent: 30 },
      {
        yPercent: -15,
        ease: 'none',
        scrollTrigger: {
          trigger: sub,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  });

  const items = gsap.utils.toArray(block.querySelectorAll('[class*="__item-"]'));
  items.forEach((item) => {
    const textEls = item.querySelectorAll('.what-we-do__subtitle, .what-we-do__number, .what-we-do__footnote');
    if (!textEls.length) return;

    gsap.set(textEls, { autoAlpha: 0 });

    gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: 'top 78%',
        end: 'bottom 22%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    })
      .to(textEls, {
        autoAlpha: 1,
        ease: 'none',
        stagger: 0.08,
        duration: 0.18,
      })
      .to(textEls, {
        autoAlpha: 1,
        ease: 'none',
        duration: 0.48,
      })
      .to(textEls, {
        autoAlpha: 0,
        ease: 'none',
        stagger: 0.06,
        duration: 0.18,
      });
  });

  const item8 = block.querySelector('.what-we-do__item-8');
  if (item8) {
    gsap.fromTo(item8,
      { '--photo-8-offset': '5rem' },
      {
        '--photo-8-offset': '-45rem',
        ease: 'none',
        scrollTrigger: {
          trigger: item8,
          start: 'top 55%',
          end: 'top 10%',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  }

  const itemsToScale = gsap.utils.toArray(block.querySelectorAll('.what-we-do__item-3, .what-we-do__item-6, .what-we-do__item-7, .what-we-do__item-10'));
  itemsToScale.forEach((item) => {
    gsap.to(item, {
      scale: 0.65,
      ease: 'none',
      scrollTrigger: {
        trigger: item,
        start: 'top 40%',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  });
}

function initWhatWeDoTitle() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const title = document.querySelector('.what-we-do__title');
  const block = document.querySelector('.what-we-do');
  if (!title || !block) return;

  const smallScale = 3.2 / 6.6;
  const remPx = () => parseFloat(getComputedStyle(document.documentElement).fontSize);
  const finalY = () => 18 * remPx();
  const vh = () => window.innerHeight;

  gsap.set(title, { autoAlpha: 0 });

  // Appear only once the section has come up enough that the black radial bg
  // (the dome in initWhatWeDo, which grows from 'top 120%'→'top 0%') has covered
  // the title's area. At the old 'top 120%' the dome radius was still ~0, so the
  // wide title flashed over the previous block (.you-can). 'top 75%' is past the
  // point where the dome covers the title's width — so it never overlaps you-can.
  ScrollTrigger.create({
    trigger: block,
    start: 'top 75%',
    end: 'bottom top',
    onEnter: () => gsap.to(title, { autoAlpha: 1, duration: 0.2, overwrite: 'auto' }),
    onLeave: () => gsap.to(title, { autoAlpha: 0, duration: 0.2, overwrite: 'auto' }),
    onEnterBack: () => gsap.to(title, { autoAlpha: 1, duration: 0.2, overwrite: 'auto' }),
    onLeaveBack: () => gsap.to(title, { autoAlpha: 0, duration: 0.2, overwrite: 'auto' }),
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: block,
      start: 'top 75%',
      end: () => `+=${vh() * 2}`,
      scrub: true,
      invalidateOnRefresh: true,
    },
  });

  tl.fromTo(title,
    { y: () => vh() * 0.88, yPercent: -50, scale: smallScale },
    { y: () => vh() / 2, yPercent: -50, scale: 1, ease: 'none', duration: 1 },
    0
  );

  tl.to(title,
    { y: () => finalY(), yPercent: 0, scale: smallScale, ease: 'none', duration: 1 },
    1
  );

  ScrollTrigger.create({
    trigger: block,
    start: 'bottom bottom',
    invalidateOnRefresh: true,
    onEnter: () => {
      const innerOffset = block.offsetHeight - vh() + finalY();
      gsap.set(title, {
        position: 'absolute',
        top: innerOffset,
        left: 0,
        right: 0,
        y: 0,
        yPercent: 0,
        scale: smallScale,
      });
    },
    onLeaveBack: () => {
      gsap.set(title, { clearProps: 'position,top,left,right' });
      gsap.set(title, {
        y: () => finalY(),
        yPercent: 0,
        scale: smallScale,
      });
    },
  });
}

// Stale-measurement correction, page-wide (desktop AND mobile). The page has
// ~220 lazy images and a lazily mounted gallery: anything that changes the
// document height AFTER ScrollTrigger measured shifts every trigger below the
// change — a pin fires early/late and lands on its neighbours, a scrubbed
// block ("Що ми зробили") unfolds a screen too soon, a fade-in fires before
// its element is on screen. Watch the page height and re-measure once the
// scroll has been idle for a beat. (Images that used to grow on load now
// reserve their box in CSS, so this is the safety net, not the plan.)
function initLayoutRefresh() {
  if (typeof ScrollTrigger === 'undefined') return;
  const MOBILE = !isDesktop();

  // A full ScrollTrigger.refresh() re-measures every trigger on the page and
  // re-runs every invalidateOnRefresh value — tens of milliseconds of blocked
  // main thread on a phone. Fired mid-flick it reads as the scroll slamming
  // into a wall, so every refresh below is parked until the scroll has been
  // idle for a beat.
  let lastScrollAt = 0;
  window.addEventListener('scroll', () => { lastScrollAt = Date.now(); }, { passive: true });

  let refreshTimer = null;
  const refreshWhenIdle = () => {
    window.clearTimeout(refreshTimer);
    const attempt = () => {
      if (Date.now() - lastScrollAt < 200) {
        refreshTimer = window.setTimeout(attempt, 200);
        return;
      }
      ScrollTrigger.refresh();
    };
    refreshTimer = window.setTimeout(attempt, 160);
  };

  // Watch the whole page height rather than any one section, then refresh
  // once layout settles.
  if (typeof ResizeObserver !== 'undefined') {
    let lastPageHeight = document.documentElement.scrollHeight;
    let lastViewportHeight = window.innerHeight;

    const layoutObserver = new ResizeObserver(() => {
      const nextPageHeight = document.documentElement.scrollHeight;
      const viewportChanged = window.innerHeight !== lastViewportHeight;
      lastViewportHeight = window.innerHeight;

      const delta = Math.abs(nextPageHeight - lastPageHeight);
      if (delta < 1) return;
      lastPageHeight = nextPageHeight;

      // MOBILE: the browser UI bar showing/hiding resizes the viewport, which
      // can reflow vh-sized bits by a few px — not a real content change, and
      // it fires precisely on the first scroll away from the top. Skip those
      // small ones. A big jump arriving in the same batch IS content (a lazy
      // image landing): the old rule dropped that too, and every trigger
      // below the image then stayed 300px stale for the rest of the visit.
      // On DESKTOP a viewport change is a real window resize — refresh.
      if (viewportChanged && MOBILE && delta < 64) return;

      refreshWhenIdle();
    });

    layoutObserver.observe(document.body);
  }

  // A final live measurement shortly before the long horizontal pin arrives.
  // Unlike a ScrollTrigger callback, IntersectionObserver uses the element's
  // current DOM position, so it is not affected by a stale cached pin start.
  // Stays connected (fires on every approach): images keep lazy-loading
  // throughout the session, so one early correction isn't enough.
  const scene = document.querySelector('.scene-6');
  if (scene && typeof IntersectionObserver !== 'undefined' && getComputedStyle(scene).display !== 'none') {
    const proximityObserver = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      refreshWhenIdle();
    }, { rootMargin: '150% 0px', threshold: 0 });

    proximityObserver.observe(scene);
  }

  // Desktop: the global ScrollTrigger config drops `resize` from
  // autoRefreshEvents (needed on mobile, where the URL bar spams it), so a
  // window resize/devtools toggle never re-measures anything and every pin
  // start goes stale. Restore it here, idle-gated, desktop only.
  if (!MOBILE) {
    window.addEventListener('resize', refreshWhenIdle);
  }
}

function initWhereWeWas() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const scene = document.querySelector('.scene-6');
  const section = document.querySelector('.where-we-was');
  const track = document.querySelector('.where-we-was__items');
  const viewport = document.querySelector('.where-we-was__in');
  const items = Array.from(document.querySelectorAll('.where-we-was__item'));
  if (!scene || !section || !track || !viewport || !items.length) return;

  // `.scene-6` is currently `display: none` (see _default.sass) — on mobile
  // the slide math below is computed from the viewport width, not from any
  // measured element, so distance() stays non-zero even while hidden. That
  // used to pin + snap-scroll a real ~3300px chunk of the page for a section
  // nobody can see, and the snap correction landing right before the footer
  // is what reads as "the footer scrolls a bit on its own". Bail out while
  // the section is hidden; this re-runs the same checks ScrollTrigger would
  // need on resize, so it stays correct if `.scene-6` ever becomes visible.
  if (getComputedStyle(scene).display === 'none') return;

  const firstItem = items[0];
  const lastItem = items[items.length - 1];

  const SCROLL_FACTOR = 2;
  const remPx = () => parseFloat(getComputedStyle(document.documentElement).fontSize);

  // ----- Mobile layout (6-column grid, slot-based block widths) -----
  const MOBILE = !isDesktop();
  const MOBILE_COLS = 6;

  // Width of `n` columns on the mobile 6-column grid (matches the SASS col() helper).
  const colW = (n) => {
    const rem = remPx();
    const margin = 2 * rem;   // $grid-margin
    const gutter = 1.2 * rem; // $grid-gutter
    const unit = (window.innerWidth - 2 * margin - (MOBILE_COLS - 1) * gutter) / MOBILE_COLS;
    return n * unit + (n - 1) * gutter;
  };
  // Center-to-center spacing: half the active block + half a neighbour + a small gap,
  // so the active/neighbour gap stays constant at any viewport width.
  const NEIGHBOUR_GAP = () => 0.6 * remPx();
  // Neighbour (±1) width so its OUTER edge sits flush with the container (which
  // has 1rem padding) while the active block stays centred on screen:
  //   W/2 = activeW/2 + gap + neighbourW + 1rem
  // i.e. neighbourW = W/2 - activeW/2 - gap - 1rem. Clamped to >= 1 col.
  const neighbourW = () => Math.max(
    colW(1),
    window.innerWidth / 2 - colW(3) / 2 - NEIGHBOUR_GAP() - remPx()
  );
  // Block width by slot: active = 3 cols, the two neighbours = flush to the
  // container edges, everything further out = 1 col.
  const slotW = (slot) => (slot === 0 ? colW(3) : Math.abs(slot) === 1 ? neighbourW() : colW(1));
  const pitch = () => colW(3) / 2 + neighbourW() / 2 + NEIGHBOUR_GAP();

  // Fixed horizontal center of every block (relative to the track's left edge).
  let centers = [];
  const refreshCenters = () => {
    const p = pitch();
    centers = items.map((_, i) => i * p + p / 2);
    track.style.width = (centers[centers.length - 1] + p) + 'px';
  };

  // Vertical cascade for mobile (item top, in vh). Mirrors the desktop SLOT_TOPS idea.
  // Positions are keyed off the active block: top = 27vh, height = 44vh,
  // so its bottom sits at 71vh. Neighbour height is 20vh.
  //  - previous block (-1): top-aligned with the active block (27vh)
  //  - next block (+1): bottom-aligned with the active block (71 - 20 = 51vh)
  // The active block sits at 27vh (not 20vh) so the block + caption unit is
  // centred within the title→footer band instead of hugging the top.
  const MOBILE_SLOT_TOPS = {
    '-3': '15vh',
    '-2': '21vh',
    '-1': '27vh',
    '0': '27vh',
    '1': '51vh',
    '2': '63vh',
    '3': '74vh',
  };
  const mobileSlotTop = (slot) => {
    if (MOBILE_SLOT_TOPS[slot] !== undefined) return MOBILE_SLOT_TOPS[slot];
    if (slot < -3) return (15 + (slot + 3) * 6) + 'vh';
    return (74 + (slot - 3) * 11) + 'vh';
  };

  // Size + position every block for the given active index. Blocks stay centered
  // on their fixed `centers[i]`, so width changes grow symmetrically (no geometry drift).
  const applyMobileSlots = (activeIdx) => {
    if (!centers.length) refreshCenters();
    items.forEach((item, i) => {
      const slot = i - activeIdx;
      const w = slotW(slot);
      item.style.width = w + 'px';
      item.style.left = (centers[i] - w / 2) + 'px';
      item.style.setProperty('--base-t', mobileSlotTop(slot));
    });
  };

  const computeOffsets = () => {
    const margin = 2 * remPx();
    const trackNaturalLeft = 2 * margin;
    const viewportCenter = window.innerWidth / 2;

    if (MOBILE) {
      refreshCenters();
      // .container has 1rem padding on mobile + the track sits at 2rem (grid-margin).
      const mobileLeft = 3 * remPx();
      return {
        startX: viewportCenter - centers[0] - mobileLeft,
        endX: viewportCenter - centers[centers.length - 1] - mobileLeft,
      };
    }

    const firstCenter = firstItem.offsetLeft + firstItem.offsetWidth / 2;
    const lastCenter = lastItem.offsetLeft + lastItem.offsetWidth / 2;

    return {
      startX: viewportCenter - firstCenter - trackNaturalLeft,
      endX: viewportCenter - lastCenter - trackNaturalLeft,
    };
  };

  const distance = () => {
    const { startX, endX } = computeOffsets();
    return Math.max(0, startX - endX);
  };

  if (distance() === 0) return;

  let snapPoints = [];
  const refreshSnapPoints = () => {
    const { startX, endX } = computeOffsets();
    const dist = startX - endX;
    if (dist === 0) {
      snapPoints = [0];
      return;
    }
    if (MOBILE) {
      const first = centers[0];
      const span = centers[centers.length - 1] - first;
      snapPoints = centers.map((c) => Math.min(1, Math.max(0, (c - first) / span)));
      return;
    }
    const firstCenter = firstItem.offsetLeft + firstItem.offsetWidth / 2;
    snapPoints = items.map((item) => {
      const center = item.offsetLeft + item.offsetWidth / 2;
      return Math.min(1, Math.max(0, (center - firstCenter) / dist));
    });
  };

  const SLOT_TOPS = {
    '-3': '4vh',
    '-2': '10vh',
    '-1': 'var(--active-top)',
    '0': 'var(--active-top)',
    '1': 'calc(var(--active-bottom) - var(--col2))',
    '2': 'calc(var(--active-bottom) - var(--col2) + 14vh)',
    '3': 'calc(var(--active-bottom) - var(--col2) + 30vh)',
    '4': 'calc(var(--active-bottom) - var(--col2) + 46vh)',
  };
  const slotToTop = (slot) => {
    if (SLOT_TOPS[slot] !== undefined) return SLOT_TOPS[slot];
    if (slot < -3) return (4 + (slot + 3) * 8) + 'vh';
    return 'calc(var(--active-bottom) - var(--col2) + ' + (46 + (slot - 4) * 16) + 'vh)';
  };

  const applySlotTops = (activeIdx) => {
    items.forEach((item, i) => {
      const slot = i - activeIdx;
      item.style.setProperty('--base-t', slotToTop(slot));
    });
  };

  let activeItem = null;
  let activeIdx = -1;
  const updateActive = () => {
    const centerX = window.innerWidth / 2;
    let closestIdx = -1;
    let minDist = Infinity;
    items.forEach((item, i) => {
      const rect = item.getBoundingClientRect();
      const itemCenter = rect.left + rect.width / 2;
      const dist = Math.abs(itemCenter - centerX);
      if (dist < minDist) {
        minDist = dist;
        closestIdx = i;
      }
    });
    if (closestIdx === activeIdx) return;
    if (activeItem) activeItem.classList.remove('is-active');
    activeItem = items[closestIdx];
    activeIdx = closestIdx;
    if (activeItem) activeItem.classList.add('is-active');
    if (MOBILE) applyMobileSlots(closestIdx);
    else applySlotTops(closestIdx);
  };

  if (MOBILE) applyMobileSlots(0);

  refreshSnapPoints();

  gsap.fromTo(track,
    { x: () => computeOffsets().startX },
    {
      x: () => computeOffsets().endX,
      ease: 'none',
      // The scrubbed track keeps travelling for up to a second after the
      // scroll itself stops, so the active card must follow the TRACK, not the
      // scroll: measured only on scroll updates, the closing card could park
      // dead centre with its neighbour still marked active.
      onUpdate: updateActive,
      scrollTrigger: {
        trigger: scene,
        start: 'top top',
        end: () => `+=${distance() * SCROLL_FACTOR}`,
        pin: true,
        // Pin one frame early on fast scroll — otherwise the section blows a
        // frame past the pin point and visibly snaps back ("pins too late").
        anticipatePin: 1,
        // Higher refresh priority than the default (0); lower than the earlier
        // about pin (2) — this pin's spacer must exist before later triggers
        // measure their start positions, or they land too high up the page.
        refreshPriority: 1,
        // Snappier follow + quicker auto-snap on mobile (less "hang" after the finger lifts).
        scrub: MOBILE ? 0.3 : 1,
        snap: {
          snapTo: (progress) => snapPoints.reduce((prev, curr) =>
            Math.abs(curr - progress) < Math.abs(prev - progress) ? curr : prev
          ),
          duration: MOBILE ? { min: 0.2, max: 0.4 } : { min: 0.05, max: 0.15 },
          delay: 0,
          ease: 'power3.out',
        },
        invalidateOnRefresh: true,
        onUpdate: updateActive,
        onRefresh: () => {
          if (MOBILE) {
            refreshCenters();
            applyMobileSlots(activeIdx < 0 ? 0 : activeIdx);
          }
          refreshSnapPoints();
          updateActive();
        },
      },
    }
  );

  // Stale-measurement correction (late layout growth, resize) lives in
  // initLayoutRefresh() — page-wide, and it runs even when this scene is
  // hidden, so it no longer depends on this function getting this far.

  const header = document.querySelector('.header');
  const decSigns = gsap.utils.toArray('.dec-sign');
  const forceDifference = () => {
    if (header) header.style.mixBlendMode = 'difference';
    decSigns.forEach((el) => { el.style.mixBlendMode = 'difference'; });
  };
  // Desktop only: on mobile the page background is driven by the section
  // observers (Malika / join), and forcing white !important here would fight the
  // join's beige and get wiped by releaseBody.
  const forceWhiteBody = () => {
    if (!isDesktop()) return;
    document.body.style.setProperty('background-color', '#ffffff', 'important');
  };
  const releaseBody = () => {
    if (!isDesktop()) return;
    document.body.style.removeProperty('background-color');
  };
  const enterScene = () => {
    forceDifference();
    forceWhiteBody();
  };
  ScrollTrigger.create({
    trigger: scene,
    start: 'top 80%',
    end: 'bottom 20%',
    onEnter: enterScene,
    onEnterBack: enterScene,
    onLeave: releaseBody,
    onLeaveBack: releaseBody,
    onRefresh: (self) => {
      if (self.isActive) enterScene();
      else releaseBody();
    },
  });

  updateActive();
}

function initReviews() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.reviews');
  if (!section) return;

  const head = section.querySelector('.reviews__head');
  const names = Array.from(section.querySelectorAll('.reviews__name'));
  const footer = section.querySelector('.reviews__footer');

  if (head) {
    gsap.set(head, { y: 40, autoAlpha: 0 });

    gsap.to(head, {
      y: 0,
      autoAlpha: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 75%',
        end: 'top 40%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }

  // Each name pulls up as IT reaches the bottom of the viewport (not when the
  // section top does), so the item-by-item reveal keeps firing for the whole
  // scroll through the list instead of finishing while the section is still
  // entering. Progress is computed from the item's live viewport position
  // (minus its own transform) rather than fixed ScrollTrigger positions,
  // because the rowGap scrub below reflows the list during the scroll and
  // would make precomputed trigger points drift.
  if (names.length) {
    const NAME_SHIFT = 120;

    gsap.set(names, { y: NAME_SHIFT, autoAlpha: 0 });

    const updateNames = () => {
      const vh = window.innerHeight;
      const startY = vh;         // reveal starts: item top at viewport bottom
      const endY = vh * 0.72;    // fully settled: item top at 72% of viewport

      const tops = names.map((name) => {
        const y = parseFloat(gsap.getProperty(name, 'y')) || 0;
        return name.getBoundingClientRect().top - y;
      });

      names.forEach((name, i) => {
        const p = gsap.utils.clamp(0, 1, (startY - tops[i]) / (startY - endY));
        gsap.set(name, { y: NAME_SHIFT * (1 - p), autoAlpha: p });
      });
    };

    ScrollTrigger.create({
      trigger: section,
      start: 'top bottom',
      end: 'bottom top',
      onUpdate: updateNames,
      onRefresh: updateNames,
      invalidateOnRefresh: true,
    });
  }

  const list = section.querySelector('.reviews__list');
  if (list) {
    gsap.fromTo(list,
      { rowGap: '6rem' },
      {
        rowGap: '1.6rem',
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'top top',
          scrub: 1.2,
          invalidateOnRefresh: true,
        },
      }
    );
  }

  if (footer) {
    gsap.set(footer, { y: 40, autoAlpha: 0 });

    gsap.to(footer, {
      y: 0,
      autoAlpha: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 55%',
        end: 'top 5%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }
}

function initReviewsHover() {
  if (typeof gsap === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

  const list = document.querySelector('.reviews__list');
  if (!list) return;

  const items = Array.from(list.querySelectorAll('.reviews__name'));
  if (!items.length) return;

  const map = (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c;
  const lerp = (a, b, n) => (1 - n) * a + n * b;
  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

  let mousePos = { x: 0, y: 0 };
  let mousePosCache = mousePos;
  let direction = { x: 0, y: 0 };
  let activeItem = null;

  window.addEventListener('mousemove', (ev) => {
    mousePos = { x: ev.clientX, y: ev.clientY };
  });

  const animatableProperties = {
    tx: { previous: 0, current: 0, amt: 0.08 },
    ty: { previous: 0, current: 0, amt: 0.08 },
    rotation: { previous: 0, current: 0, amt: 0.08 },
    brightness: { previous: 1, current: 1, amt: 0.08 },
  };

  items.forEach((item) => {
    const src = item.dataset.img;
    if (src) {
      const preload = new Image();
      preload.src = src;
    }
  });

  items.forEach((item) => {
    const reveal = document.createElement('div');
    reveal.className = 'reviews-hover-reveal';

    const revealInner = document.createElement('div');
    revealInner.className = 'reviews-hover-reveal__inner';

    const revealImage = document.createElement('div');
    revealImage.className = 'reviews-hover-reveal__img';
    revealImage.style.backgroundImage = `url(${item.dataset.img})`;

    revealInner.appendChild(revealImage);
    reveal.appendChild(revealInner);
    item.appendChild(reveal);

    let bounds = null;
    let requestId = null;
    let firstRAFCycle = false;

    const calcBounds = () => {
      bounds = {
        item: item.getBoundingClientRect(),
        reveal: reveal.getBoundingClientRect(),
      };
    };

    const loopRender = () => {
      if (!requestId) {
        requestId = requestAnimationFrame(render);
      }
    };

    const stopRendering = () => {
      if (requestId) {
        window.cancelAnimationFrame(requestId);
        requestId = null;
      }
    };

    const showImage = () => {
      gsap.killTweensOf(revealInner);
      gsap.killTweensOf(revealImage);

      gsap.timeline({
        onStart: () => {
          reveal.style.opacity = 1;
          gsap.set(item, { zIndex: items.length + 100 });
        },
      })
        .to(revealInner, {
          duration: 0.2,
          ease: 'sine.out',
          startAt: { x: direction.x < 0 ? '-100%' : '100%' },
          x: '0%',
        })
        .to(revealImage, {
          duration: 0.2,
          ease: 'sine.out',
          startAt: { x: direction.x < 0 ? '100%' : '-100%' },
          x: '0%',
        }, 0);
    };

    const hideImage = () => {
      gsap.killTweensOf(revealInner);
      gsap.killTweensOf(revealImage);

      gsap.timeline({
        onStart: () => {
          gsap.set(item, { zIndex: 1 });
        },
        onComplete: () => {
          gsap.set(reveal, { opacity: 0 });
        },
      })
        .to(revealInner, {
          duration: 0.2,
          ease: 'sine.out',
          x: direction.x < 0 ? '100%' : '-100%',
        })
        .to(revealImage, {
          duration: 0.2,
          ease: 'sine.out',
          x: direction.x < 0 ? '-100%' : '100%',
        }, 0);
    };

    const render = () => {
      requestId = null;

      if (firstRAFCycle) {
        calcBounds();
      }

      const mouseDistanceX = clamp(Math.abs(mousePosCache.x - mousePos.x), 0, 100);
      direction = {
        x: mousePosCache.x - mousePos.x,
        y: mousePosCache.y - mousePos.y,
      };
      mousePosCache = { x: mousePos.x, y: mousePos.y };

      animatableProperties.tx.current = Math.abs(mousePos.x - bounds.item.left) - bounds.reveal.width / 2;
      animatableProperties.ty.current = Math.abs(mousePos.y - bounds.item.top) - bounds.reveal.height / 2;
      animatableProperties.rotation.current = firstRAFCycle ? 0 : map(mouseDistanceX, 0, 100, 0, direction.x < 0 ? 60 : -60);
      animatableProperties.brightness.current = firstRAFCycle ? 1 : map(mouseDistanceX, 0, 100, 1, 4);

      animatableProperties.tx.previous = firstRAFCycle ? animatableProperties.tx.current : lerp(animatableProperties.tx.previous, animatableProperties.tx.current, animatableProperties.tx.amt);
      animatableProperties.ty.previous = firstRAFCycle ? animatableProperties.ty.current : lerp(animatableProperties.ty.previous, animatableProperties.ty.current, animatableProperties.ty.amt);
      animatableProperties.rotation.previous = firstRAFCycle ? animatableProperties.rotation.current : lerp(animatableProperties.rotation.previous, animatableProperties.rotation.current, animatableProperties.rotation.amt);
      animatableProperties.brightness.previous = firstRAFCycle ? animatableProperties.brightness.current : lerp(animatableProperties.brightness.previous, animatableProperties.brightness.current, animatableProperties.brightness.amt);

      gsap.set(reveal, {
        x: animatableProperties.tx.previous,
        y: animatableProperties.ty.previous,
        rotation: animatableProperties.rotation.previous,
        filter: `brightness(${animatableProperties.brightness.previous})`,
      });

      firstRAFCycle = false;
      loopRender();
    };

    item.addEventListener('mouseenter', () => {
      if (activeItem) activeItem.classList.remove('is-active');
      activeItem = item;
      item.classList.add('is-active');
      showImage();
      firstRAFCycle = true;
      loopRender();
    });

    item.addEventListener('mouseleave', () => {
      stopRendering();
      hideImage();
      item.classList.remove('is-active');
      if (activeItem === item) activeItem = null;
    });
  });
}

// Lightbox video modal for the reviews list, the where-we-was video tiles, the
// awards videos AND the support items: clicking a play button opens a centered
// video over a dark overlay (same idea as the about-item video). The source
// comes from `data-video` on the closest item; if it has none yet, it falls
// back to the shared placeholder (the about videos use the same one). Close via
// the × button, the backdrop, or Esc.
function initReviewsVideo() {
  if (typeof gsap === 'undefined') return;

  const PLAY_SELECTOR = '.reviews__item-play, .where-we-was__play, .awards__play, .support__play, .event-detail__play';
  // The event detail re-renders its video slider per event, so play buttons
  // come and go — one delegated listener (below) covers them all.
  if (!document.querySelector(PLAY_SELECTOR) && !document.querySelector('.event-detail')) return;

  const FALLBACK_SRC = 'https://brandface.kiev.ua/old/video/video-9.mp4';

  let overlay = null;
  let dialog = null;
  let video = null;
  let closeBtn = null;
  let lastTrigger = null;
  let isOpen = false;

  const build = () => {
    overlay = document.createElement('div');
    overlay.className = 'reviews-video';

    // Wrap the video so the close button can sit on the video's corner (not the
    // screen corner) and scale together with it on open/close.
    dialog = document.createElement('div');
    dialog.className = 'reviews-video__dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Відео');
    dialog.tabIndex = -1;

    video = document.createElement('video');
    video.className = 'reviews-video__player';
    video.controls = true;
    video.playsInline = true;
    video.preload = 'none';
    video.setAttribute('aria-label', 'Відео');

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'reviews-video__close';
    closeBtn.setAttribute('aria-label', 'Закрити відео');

    dialog.appendChild(video);
    dialog.appendChild(closeBtn);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    // Backdrop click (but not clicks on the video itself) closes.
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    closeBtn.addEventListener('click', close);

    gsap.set(overlay, { autoAlpha: 0 });
  };

  const open = (src) => {
    if (isOpen || !src) return;
    if (!overlay) build();
    isOpen = true;

    if (video.getAttribute('src') !== src) video.setAttribute('src', src);
    lockPageScroll(true);

    gsap.killTweensOf(overlay);
    gsap.killTweensOf(dialog);
    gsap.set(dialog, { scale: 0.94, y: 24 });
    gsap.to(overlay, { autoAlpha: 1, duration: 0.3, ease: 'power2.out' });
    gsap.to(dialog, { scale: 1, y: 0, duration: 0.45, ease: 'power3.out' });
    if (closeBtn) closeBtn.focus({ preventScroll: true });

    // Triggered from a click, so playback with sound is allowed.
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  const close = () => {
    if (!isOpen) return;
    isOpen = false;

    if (video) video.pause();

    gsap.killTweensOf(overlay);
    gsap.killTweensOf(dialog);
    gsap.to(dialog, { scale: 0.96, y: 12, duration: 0.25, ease: 'power2.in' });
    gsap.to(overlay, {
      autoAlpha: 0,
      duration: 0.3,
      ease: 'power2.in',
      onComplete: () => {
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.load();
        }
        lockPageScroll(false);
        if (lastTrigger) lastTrigger.focus({ preventScroll: true });
      },
    });
  };

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) close();
  });

  document.addEventListener('click', (e) => {
    const btn = e.target && e.target.closest ? e.target.closest(PLAY_SELECTOR) : null;
    if (!btn) return;
    e.preventDefault();
    lastTrigger = btn;
    const item = btn.closest('.reviews__name, .where-we-was__item, .awards__video, .support__item, .event-detail__media-item');
    open((item && item.dataset.video) || FALLBACK_SRC);
  });
}

// "Що ми зробили": height-accordion, per the design's Default → Scroll 1 →
// Scroll 2 storyboard. The section is NOT pinned — it scrolls normally and the
// rows unfold as it passes through the viewport. To keep this from shifting
// everything below it, the inner block is frozen at its final (all-open) height
// so the section's own height never changes while the rows grow. By default
// every row is collapsed to a short slice — overflow:hidden clips the big
// number to its top part, the items reading as if they've slid onto each other
// — which leaves an empty band at the bottom (the "Default" frame). Scrolling
// grows the rows back to full height one by one, top to bottom, strictly tied
// to scroll (scrub, ease none — «просто за скролом»); each row fully unfolds
// before the next starts, and the rows below slide down as the band is
// consumed. At the end every row is open. Runs on desktop and mobile.
function initWhatWeDone() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.what-we-done');
  if (!section) return;

  const inner = section.querySelector('.what-we-done__in');
  const rows = Array.from(section.querySelectorAll('.what-we-done__row'));
  if (!inner || !rows.length) return;

  // Collapsed slice of a row: top padding + the number's top ~72%, so only the
  // very bottom of the digits is clipped (matching the design's stacked look).
  // offsetTop is measured from the row's top, so it already includes the
  // padding.
  const collapsedH = (row) => {
    const num = row.querySelector('.what-we-done__num');
    return num ? num.offsetTop + num.offsetHeight * 0.72 : row.offsetHeight * 0.55;
  };

  // A row's natural (fully open) height, measured with the inline clamp off.
  const openH = (row) => {
    const prev = row.style.height;
    row.style.height = 'auto';
    const h = row.offsetHeight;
    row.style.height = prev;
    return h;
  };

  // Freeze the inner block at its all-open height and collapse every row, so
  // the section keeps that height while the rows start short (the empty band
  // at the bottom of the "Default" frame). Re-run before each refresh.
  const reset = () => {
    rows.forEach((row) => { row.style.height = 'auto'; });
    inner.style.minHeight = '';
    inner.style.minHeight = inner.offsetHeight + 'px';
    rows.forEach((row) => { row.style.height = collapsedH(row) + 'px'; });
  };
  reset();
  ScrollTrigger.addEventListener('refreshInit', reset);

  // No pin. Start point differs per breakpoint. Desktop keeps the original
  // late start: the section scrolls up fully collapsed (so the stacked
  // "Default" state actually reads for a while) and the rows only begin
  // unfolding once its top reaches the top of the viewport. On mobile that
  // read as "розкривається надто пізно" (client feedback), so there the rows
  // begin once the section's top crosses the middle of the viewport — by the
  // time the block sits centered on screen the first row is already opening.
  // The whole sequence is compressed into ~one viewport of scroll (not the
  // section's full ~2-screen pass), so the last rows finish opening while
  // they're still a bit below the top instead of way past it — and every row
  // gets the same slice of scroll, so the pace stays even. Section height is
  // fixed, so the rows stay in view as they open and nothing below jumps.
  // The 0.9 factor is the tuning knob: smaller = finishes sooner.
  //
  // scrub is a NUMBER, not `true`: the timeline eases toward the scroll
  // position over that many seconds instead of snapping 1:1. Mouse wheels
  // scroll in discrete ~100px notches — a hard scrub replays those steps as
  // visible jerks; the smoothing absorbs them into one continuous glide (the
  // usual "awwwards" feel) while staying fully scroll-driven: stop scrolling
  // and it settles right where the scroll maps to. Mobile gets a much longer
  // lag: one thumb flick jumps the whole 0.9-viewport mapping at once, and
  // with the desktop value the rows finished before the eye caught them — the
  // longer glide lets the unfold actually play out after the flick lands.
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: () => (isDesktop() ? 'top top' : 'top 50%'),
      end: () => '+=' + window.innerHeight * 0.9,
      scrub: isDesktop() ? 0.8 : 2.2,
      invalidateOnRefresh: true,
    },
  });

  // Sequential: each row grows from its slice to full height; the next only
  // starts once this one is done. Inside each row the content is staged (all
  // still scrubbed, no tweens of their own): first the subtitle fades in with
  // a minimal rise — not "from the very bottom", just enough to read as
  // motion — then the description repeats the exact same fade+rise a beat
  // later, so it visibly trails the title instead of popping in with it.
  const RISE = 14;        // px of lift — deliberately small ("мінімально анімації")
  const TEXT_DELAY = 0.3; // description starts this far into the row's segment
  const FADE_DUR = 0.55;  // same speed for subtitle and description
  rows.forEach((row) => {
    const label = 'row' + tl.duration();
    tl.addLabel(label);
    tl.fromTo(row, { height: () => collapsedH(row) }, {
      height: () => openH(row),
      duration: 1,
      ease: 'none',
      // Whole-pixel heights: keeps the dashed rules below from shimmering on
      // subpixel positions while the rows are in motion.
      snap: { height: 1 },
      immediateRender: false,
    }, label);

    // immediateRender:true on both so ALL subtitles/descriptions start hidden
    // (alpha 0) from the very first frame — otherwise the ones whose segment
    // hasn't played yet would sit fully visible inside rows that are still
    // closed.
    const sub = row.querySelector('.what-we-done__subtitle');
    if (sub) {
      tl.fromTo(sub, { y: RISE, autoAlpha: 0 }, {
        y: 0,
        autoAlpha: 1,
        duration: FADE_DUR,
        ease: 'none',
        immediateRender: true,
      }, label);
    }

    const text = row.querySelector('.what-we-done__text');
    if (text) {
      tl.fromTo(text, { y: RISE, autoAlpha: 0 }, {
        y: 0,
        autoAlpha: 1,
        duration: FADE_DUR,
        ease: 'none',
        immediateRender: true,
      }, label + '+=' + TEXT_DELAY);
    }
  });
}

// Fade-in-up for the "support" block: the intro text rises in first, then the
// photo cascade follows item by item — same scrubbed feel as initYouCan below.
function initSupport() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.support');
  if (!section) return;

  const intro = Array.from(section.querySelectorAll('.support__title, .support__label, .support__lead'));
  const items = Array.from(section.querySelectorAll('.support__item'));

  if (intro.length) {
    gsap.set(intro, { y: 40, autoAlpha: 0 });

    gsap.to(intro, {
      y: 0,
      autoAlpha: 1,
      ease: 'none',
      stagger: 0.08,
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        end: 'top 40%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }

  if (items.length) {
    gsap.set(items, { y: 90, autoAlpha: 0 });

    const itemsBox = section.querySelector('.support__list') || section;
    gsap.to(items, {
      y: 0,
      autoAlpha: 1,
      ease: 'none',
      stagger: 0.3,
      scrollTrigger: {
        trigger: itemsBox,
        start: 'top 90%',
        end: 'top 10%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }
}

function initSupportMobile() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.support');
  if (!section) return;

  // No .support__label here: it's display:none on mobile (it would sit as a
  // bogus slide inside the horizontal track).
  const intro = Array.from(section.querySelectorAll('.support__title, .support__lead'));
  const items = Array.from(section.querySelectorAll('.support__item'));

  if (intro.length) {
    gsap.set(intro, { y: 30, autoAlpha: 0 });
    ScrollTrigger.batch(intro, {
      start: 'top 88%',
      onEnter: (batch) => gsap.to(batch, {
        y: 0,
        autoAlpha: 1,
        duration: 1.2,
        ease: 'power3.out',
        stagger: 0.15,
        overwrite: true,
      }),
    });
  }

  if (items.length) {
    gsap.set(items, { y: 70, autoAlpha: 0 });
    ScrollTrigger.batch(items, {
      start: 'top 90%',
      onEnter: (batch) => gsap.to(batch, {
        y: 0,
        autoAlpha: 1,
        duration: 1.4,
        ease: 'power3.out',
        stagger: 0.35,
        overwrite: true,
      }),
    });
  }
}

function initInstagramFade() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('.instagram').forEach((section) => {
    const columns = Array.from(section.querySelectorAll('.instagram__column'));
    if (!columns.length) return;

    // Reveal the columns in order, but the steps column unfolds step by step
    // instead of as one block — so replace it in the target list with its own
    // .instagram__step items.
    const targets = [];
    columns.forEach((col) => {
      const steps = Array.from(col.querySelectorAll('.instagram__step'));
      if (steps.length) targets.push(...steps);
      else targets.push(col);
    });

    gsap.set(targets, { y: 100, autoAlpha: 0 });

    gsap.to(targets, {
      y: 0,
      autoAlpha: 1,
      ease: 'none',
      stagger: 0.2,
      scrollTrigger: {
        trigger: section,
        start: 'top 100%',
        end: 'center center',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  });
}

function initInstagramFadeMobile() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('.instagram').forEach((section) => {
    // Animate the leaf elements one by one, not whole columns: on mobile the
    // columns stack into one tall strip, so a per-column fade reveals several
    // screens of content at once.
    const items = Array.from(section.querySelectorAll(
      '.instagram__title, .instagram__subtitle, .instagram-block, .instagram__step'
    ));
    if (!items.length) return;

    gsap.set(items, { y: 60, autoAlpha: 0 });
    ScrollTrigger.batch(items, {
      start: 'top 88%',
      onEnter: (batch) => gsap.to(batch, {
        y: 0,
        autoAlpha: 1,
        duration: 1.4,
        ease: 'power3.out',
        stagger: 0.25,
        overwrite: true,
      }),
    });
  });
}

function initYouCan() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.you-can');
  if (!section) return;

  const title = section.querySelector('.you-can__title');
  const photos = Array.from(section.querySelectorAll('.you-can__photo'));
  const photo1 = section.querySelector('.you-can__photo--1');
  const photo2 = section.querySelector('.you-can__photo--2');
  const items = Array.from(section.querySelectorAll('.you-can-item'));
  const watermark = section.querySelector('.you-can__watermark');

  if (title) {
    gsap.set(title, { y: 40, autoAlpha: 0 });

    gsap.to(title, {
      y: 0,
      autoAlpha: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 75%',
        end: 'top 40%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }

  if (photos.length) {
    gsap.set(photos, {
      clipPath: 'inset(100% 0% 0% 0%)',
      scale: 1.08,
      transformOrigin: 'center center',
    });

    gsap.to(photos, {
      clipPath: 'inset(0% 0% 0% 0%)',
      scale: 1,
      ease: 'none',
      stagger: 0.15,
      scrollTrigger: {
        trigger: section,
        start: 'top 58%',
        end: 'top 18%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }

  if (photo1) {
    gsap.fromTo(photo1,
      { yPercent: 12 },
      {
        yPercent: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top 58%',
          end: 'top 18%',
          scrub: true,
          invalidateOnRefresh: true,
        },
      },
    );
  }

  if (photo2) {
    gsap.fromTo(photo2,
      { yPercent: 6 },
      {
        yPercent: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top 58%',
          end: 'top 18%',
          scrub: true,
          invalidateOnRefresh: true,
        },
      },
    );
  }

  if (items.length) {
    gsap.set(items, { y: 40, autoAlpha: 0 });

    // Anchor the stagger to the items' OWN block (.you-can__text), not the
    // section top. The items sit deep in the section (after 14rem padding + the
    // title + 8rem), so a section-top trigger ran the whole fade-in while they
    // were still below the fold — the user never saw it. Triggering here and
    // starting later makes the cascade play as the items rise into view.
    const itemsBox = section.querySelector('.you-can__text') || section;
    gsap.to(items, {
      y: 0,
      autoAlpha: 1,
      ease: 'none',
      stagger: 0.1,
      scrollTrigger: {
        trigger: itemsBox,
        start: 'top 80%',
        end: 'top 30%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }

  if (watermark) {
    gsap.set(watermark, { scale: 0.92, autoAlpha: 0, transformOrigin: 'center bottom' });

    gsap.to(watermark, {
      scale: 1,
      autoAlpha: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 60%',
        end: 'bottom 90%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }
}

// Mobile-only: play-on-enter reveal for the "Що ти можеш" block — the title
// fades up first, then the items fade up one-by-one as they scroll into view.
function initYouCanMobile() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.you-can');
  if (!section) return;

  const title = section.querySelector('.you-can__title');
  const items = Array.from(section.querySelectorAll('.you-can-item'));

  if (title) {
    gsap.set(title, { y: 30, autoAlpha: 0 });
    ScrollTrigger.create({
      trigger: title,
      start: 'top 85%',
      once: true,
      onEnter: () => gsap.to(title, { y: 0, autoAlpha: 1, duration: 1.4, ease: 'power3.out' }),
    });
  }

  if (items.length) {
    gsap.set(items, { y: 48, autoAlpha: 0 });
    ScrollTrigger.batch(items, {
      start: 'top 88%',
      onEnter: (batch) => gsap.to(batch, {
        y: 0,
        autoAlpha: 1,
        duration: 1.3,
        ease: 'power3.out',
        stagger: 0.25,
        overwrite: true,
      }),
    });
  }
}

// "Model Camp": the headline rides in on the scroll like the you-can title,
// the photos unveil bottom-up (clip-path, same recipe as .you-can__photo),
// and the copy — label, lead, arrow, the three groups — fades up in DOM order
// as it enters the viewport (fadeInOnView, so it also plays on mobile).
function initModelCamp() {
  const section = document.querySelector('.model-camp');
  if (!section) return;

  const title = section.querySelector('.model-camp__title');
  const photos = Array.from(section.querySelectorAll('.model-camp__photo'));
  const copy = Array.from(section.querySelectorAll(
    '.model-camp__label, .model-camp__lead, .model-camp-group, .model-camp__link'
  ));

  const hasScrub = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';

  if (hasScrub && title) {
    gsap.registerPlugin(ScrollTrigger);
    gsap.set(title, { y: 40, autoAlpha: 0 });
    gsap.to(title, {
      y: 0,
      autoAlpha: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 85%',
        end: 'top 25%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }

  if (hasScrub && photos.length && isDesktop()) {
    gsap.set(photos, {
      clipPath: 'inset(100% 0% 0% 0%)',
      scale: 1.08,
      transformOrigin: 'center center',
    });
    gsap.to(photos, {
      clipPath: 'inset(0% 0% 0% 0%)',
      scale: 1,
      ease: 'none',
      stagger: 0.15,
      scrollTrigger: {
        // Anchored to the photos themselves: the unveiling runs from the
        // moment they show up until they sit near the middle of the screen.
        trigger: section.querySelector('.model-camp__visual') || section,
        start: 'top 90%',
        end: 'center 45%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  } else if (photos.length) {
    fadeInOnView(photos, 0.15);
  }

  fadeInOnView(copy, 0.1);
}

// "Де ми були" in the nav/footer and the "Дивитись усі" card open the events
// page IN PLACE: a full-screen overlay with the page loaded in an iframe. The
// page underneath keeps its scroll position and state, and the events page
// runs its own scroller, stage and detail exactly as when opened directly —
// entrance (the headline pour) included. Inside the frame the page is in
// embedded mode (html.is-embedded, see header-helper): no header of its own,
// nav links handed back here. Desktop and mobile alike.
function initEventsOverlay() {
  const links = Array.prototype.slice.call(document.querySelectorAll('[data-events-overlay]'));
  if (!links.length || document.documentElement.classList.contains('is-embedded')) return;

  let overlay = null;
  let frame = null;
  let isOpen = false;
  let pushedState = false;

  const setPageFrozen = (frozen) => {
    lockPageScroll(frozen);
    if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.normalizeScroll) {
      const normalizer = ScrollTrigger.normalizeScroll();
      if (normalizer) {
        if (frozen) normalizer.disable();
        else normalizer.enable();
      }
    }
  };

  const frameGo = (url) => {
    try {
      frame.contentWindow.location.replace(url);
    } catch (err) {
      frame.src = url; // cross-origin about:blank edge — fall back
    }
  };

  const build = () => {
    overlay = document.createElement('div');
    overlay.className = 'events-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Наші події');

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'events-overlay__close';
    closeBtn.setAttribute('aria-label', 'Повернутися');
    closeBtn.addEventListener('click', () => close(false));

    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);
  };

  // A fresh iframe per visit: its first navigation adds no history entry, and
  // removing it (instead of navigating it away) never collides with a history
  // traversal Chrome is still carrying out for the joint session history.
  const mountFrame = () => {
    if (frame) frame.remove();
    frame = document.createElement('iframe');
    frame.className = 'events-overlay__frame';
    frame.title = 'Наші події';
    frame.setAttribute('loading', 'eager');
    overlay.appendChild(frame);
  };

  // The address is the source of truth: #events opens the overlay,
  // #events/<slug> opens it with that event, anything else closes it. Typing
  // it into the bar, Back/Forward and our own clicks all go through sync().
  const hashFor = (slug) => (slug ? '#events/' + slug : '#events');
  const parseHash = () => {
    const m = /^#events(?:\/([a-z0-9-]+))?$/.exec(window.location.hash || '');
    return m ? { slug: m[1] || '' } : null;
  };
  let currentSlug = null;
  // True while a #events/<slug> entry of ours sits on top of the #events one.
  let detailEntry = false;

  let loadToken = 0;
  const open = (slug, push) => {
    if (isOpen) return;
    isOpen = true;
    currentSlug = slug || '';
    if (!overlay) build();
    mountFrame();
    setPageFrozen(true);
    const header = document.querySelector('.header');
    if (header) header.classList.remove('is-scroll-hidden');
    // Our own clicks add a history entry (so Back closes the overlay) with
    // the shareable address; a hash the browser already navigated to has one.
    if (push !== false) history.pushState({ bfEventsOverlay: true }, '', hashFor(slug));
    pushedState = true;

    // The page underneath stays fully visible while the events page loads
    // (no blank, no curtain); the layer then rises over it and the events
    // headline plays its entrance. A fresh load every time, so that entrance
    // repeats and no previous visit leaks through.
    const token = ++loadToken;
    document.documentElement.classList.add('is-events-loading');
    const reveal = () => {
      if (token !== loadToken || !isOpen) return;
      document.documentElement.classList.remove('is-events-loading');
      overlay.classList.add('is-open');
      window.setTimeout(() => {
        if (token === loadToken && isOpen && frame && frame.contentWindow) {
          frame.contentWindow.postMessage({ type: 'bf:overlay-shown' }, location.origin);
        }
      }, 550);
    };
    frame.addEventListener('load', reveal, { once: true });
    window.setTimeout(reveal, 6000); // a stalled asset must not keep the page hidden
    // location.replace, not src: an iframe navigation via src adds an entry
    // to the tab's history and throws the Back/close counting off.
    // events.php, not the pretty /events: the page must open even when the
    // hosting ignores (or lacks) the .htaccess rewrite.
    frameGo('events.php?embed=1' + (slug ? '&event=' + encodeURIComponent(slug) : ''));
  };

  const close = (viaHistory) => {
    if (!isOpen) return;
    isOpen = false;
    loadToken++;
    document.documentElement.classList.remove('is-events-loading');
    // Closing from the UI steps back to the address before the overlay — two
    // steps when an event inside has its own #events/<slug> entry.
    if (!viaHistory && parseHash()) history.go(detailEntry ? -2 : -1);
    detailEntry = false;
    pushedState = false;
    overlay.classList.remove('is-open');
    overlay.classList.remove('has-detail');
    setPageFrozen(false);
    // Drop the page once it has faded — frees its scroller, videos, listeners.
    window.setTimeout(() => { if (!isOpen && frame) { frame.remove(); frame = null; } }, 500);
  };

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      open('', true);
    });
  });

  // Reconcile the overlay with whatever the address says now.
  const sync = () => {
    const want = parseHash();
    if (want) {
      if (!isOpen) {
        open(want.slug, false);
      } else if (want.slug === '' && overlay.classList.contains('has-detail')) {
        // Back from #events/<slug> to #events: close the event inside only.
        detailEntry = false;
        currentSlug = '';
        if (frame && frame.contentWindow) frame.contentWindow.postMessage({ type: 'bf:events-close-detail' }, location.origin);
      } else if (want.slug !== currentSlug) {
        // The hash was edited to another event while open: load that one.
        close(true);
        open(want.slug, false);
      }
    } else if (isOpen) {
      close(true);
    }
  };
  window.addEventListener('hashchange', sync);
  window.addEventListener('popstate', sync);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) close(false);
  });

  // The embedded page talks back: Esc / its own "go home" links.
  window.addEventListener('message', (e) => {
    if (e.origin !== location.origin || !e.data || typeof e.data !== 'object') return;
    if (e.data.type === 'bf:events-close') {
      close(false);
    } else if (e.data.type === 'bf:events-detail') {
      // The embedded page's own event detail has its back button exactly
      // where ours sits — step aside while it is open. And mirror the open
      // event in our address, so a copied link lands on that very event.
      if (overlay) overlay.classList.toggle('has-detail', !!e.data.open);
      if (isOpen) {
        const slug = e.data.open && typeof e.data.slug === 'string' ? e.data.slug.replace(/[^a-z0-9-]/g, '') : '';
        const here = parseHash();
        if (e.data.open) {
          currentSlug = slug;
          // Opened inside: an entry of ours, so Back closes the event first.
          // (A deep link already sits on #events/<slug> — nothing to add.)
          if (here && here.slug !== slug) {
            history.pushState({ bfEventsOverlay: true }, '', hashFor(slug));
            detailEntry = true;
          }
        } else {
          currentSlug = '';
          if (detailEntry) {
            // Closed with its own button: retire our entry (Back would have).
            detailEntry = false;
            if (here && here.slug) history.back();
          } else if (here && here.slug) {
            history.replaceState({ bfEventsOverlay: true }, '', hashFor(''));
          }
        }
      }
    } else if (e.data.type === 'bf:navigate' && typeof e.data.href === 'string') {
      const href = e.data.href;
      close(false);
      const hash = href.charAt(0) === '#' ? href : (href.indexOf('#') !== -1 ? href.slice(href.indexOf('#')) : '');
      const navLink = hash && document.querySelector('.header-nav__link[href="' + hash + '"]');
      if (navLink) {
        window.setTimeout(() => navLink.click(), 450);
      } else if (!hash) {
        window.location.href = href;
      }
    }
  });

  // Deep link: /#events or /#events/<slug> opens the overlay straight away
  // (with that event open inside). On mobile the plain page is the target.
  const deep = parseHash();
  if (deep) {
    // Give Back somewhere to go: the plain home address under the overlay.
    history.replaceState(null, '', window.location.pathname + window.location.search);
    open(deep.slug, true);
  }
}

// Running inside the events overlay of another page: nav/footer links that
// point at the parent's sections, and Esc with nothing else open, are the
// parent's business.
function initEmbeddedPage() {
  if (!document.documentElement.classList.contains('is-embedded') || window.self === window.top) return;

  const send = (data) => window.parent.postMessage(data, location.origin);

  document.addEventListener('click', (e) => {
    const link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!link) return;
    if (link.hasAttribute('data-events-overlay')) { e.preventDefault(); return; } // already here
    if (!link.matches('.header-nav__link, .footer__nav-link, .header-logo, .footer__logo')) return;
    const href = link.getAttribute('href') || '';
    if (href.charAt(0) === '#' || href.indexOf('./') === 0 || href === 'index.html' || href === '/') {
      e.preventDefault();
      send({ type: 'bf:navigate', href: href });
    }
  }, true);

  // Tell the parent when the event detail is up (its back button needs the spot).
  const detail = document.querySelector('.event-detail');
  if (detail && typeof MutationObserver !== 'undefined') {
    let wasOpen = detail.classList.contains('is-open');
    const report = (open) => send({ type: 'bf:events-detail', open: open, slug: open ? (detail.getAttribute('data-slug') || '') : '' });
    new MutationObserver(() => {
      const open = detail.classList.contains('is-open');
      if (open !== wasOpen) { wasOpen = open; report(open); }
    }).observe(detail, { attributes: true, attributeFilter: ['class'] });
    if (wasOpen) report(true);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const detail = document.querySelector('.event-detail.is-open');
    if (!detail) send({ type: 'bf:events-close' });
  });

  window.addEventListener('message', (e) => {
    if (e.origin !== location.origin || !e.data) return;
    if (e.data.type === 'bf:overlay-shown') document.dispatchEvent(new CustomEvent('bf:overlay-shown'));
    if (e.data.type === 'bf:events-close-detail') document.dispatchEvent(new CustomEvent('bf:close-detail'));
  });
}

// Light opacity-only fade-in as elements scroll into view, staggered by DOM
// order. Uses IntersectionObserver + a CSS opacity transition instead of
// ScrollTrigger/gsap on purpose: these blocks sit after the long where-we-was
// pin (which shifts trigger positions) and some are centred via
// transform:translate(-50%,-50%) (which gsap's y/transform would clobber).
// Pure opacity sidesteps both.
function fadeInOnView(els, stagger) {
  if (!els || !els.length) return;
  const step = stagger || 0.12;
  const DUR = 1.3;                                  // matches the you-can-item feel
  const EASE = 'cubic-bezier(0.165, 0.84, 0.44, 1)'; // ~ gsap power3.out
  const RISE = 40;

  // Once revealed, hand the element back to its stylesheet: leaving the inline
  // transition (with its stagger delay!) in place would also delay every later
  // hover/focus transition — a link that changes colour 1.5s after hover reads
  // as broken.
  const finish = (el) => {
    el.style.transition = '';
    el.style.transitionDelay = '';
    el.style.opacity = '';
    el.style.transform = '';
  };

  els.forEach((el, i) => {
    // Elements with their own transform (e.g. .join__center's translate
    // centering) get opacity-only so we don't clobber it; the rest rise + fade.
    const rises = getComputedStyle(el).transform === 'none';
    el.dataset.fiRise = rises ? '1' : '';
    el.dataset.fiDelay = (i * step).toFixed(2);
    el.style.opacity = '0';
    el.style.transition = rises
      ? 'opacity ' + DUR + 's ' + EASE + ', transform ' + DUR + 's ' + EASE
      : 'opacity ' + DUR + 's ' + EASE;
    el.style.transitionDelay = el.dataset.fiDelay + 's';
    if (rises) el.style.transform = 'translateY(' + RISE + 'px)';
  });

  if (typeof IntersectionObserver === 'undefined') {
    els.forEach(finish);
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      el.style.opacity = '1';
      if (el.dataset.fiRise) el.style.transform = 'translateY(0)';
      window.setTimeout(() => finish(el), (DUR + parseFloat(el.dataset.fiDelay || '0')) * 1000 + 100);
      io.unobserve(el);
    });
  }, { threshold: 0.1, rootMargin: '0px' });

  els.forEach((el) => io.observe(el));
}

// Mobile-only: same light fade-in for EVERYTHING in the footer — column
// titles, contact links, open-hours text and social buttons included, not
// just the nav items (a mix of animated and already-in-place text read as
// broken). The wordmark (.footer__brandface) is appended LAST so it fades in
// after everything else (querySelectorAll is DOM order, where brandface sits
// before terms — so we build the list manually to control the stagger).
function initFooterMobile() {
  const footer = document.querySelector('.footer');
  if (!footer) return;

  const items = Array.from(footer.querySelectorAll(
    '.footer__seal, .footer__col-title, .footer__address, .footer__link, ' +
    '.footer__text, .footer__nav-item, .footer__instagram, .footer__terms, .footer__social-btn'
  ));
  items.push(...footer.querySelectorAll('.footer__brandface'));
  fadeInOnView(items, 0.07);
}

// Animates the footer background's SVG hue-rotate filter (drives the
// turbulence/displacement shadow effect). Plain rAF loop — no animation
// library needed for a single looping numeric value.
function initFooterShadow() {
  const hueRotate = document.querySelector('.footer__shadow-huerotate');
  if (!hueRotate) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const durationMs = 5840; // 0 -> 360 deg per loop
  let start = null;

  function frame(now) {
    if (start === null) start = now;
    const progress = ((now - start) % durationMs) / durationMs;
    hueRotate.setAttribute('values', String(progress * 360));
    requestAnimationFrame(frame);
  }

  requestAnimationFrame(frame);
}

// Awards slider: plain prev/next slide switcher (no carousel library — only
// two arrow buttons to wire up, doesn't warrant a dependency).
function initAwardsSlider() {
  const slider = document.querySelector('.awards__slider');
  if (!slider) return;

  const track = slider.querySelector('.awards__track');
  const slides = Array.from(slider.querySelectorAll('.awards__slide'));
  const prevBtn = document.querySelector('.awards__arrow--prev');
  const nextBtn = document.querySelector('.awards__arrow--next');
  if (!track || slides.length < 2 || !prevBtn || !nextBtn) return;

  const hasGsap = typeof gsap !== 'undefined';
  let index = 0;
  let animating = false;

  // Mobile pagination (the arrows are hidden there): one dot per slide.
  const dotsWrap = document.querySelector('.awards__dots');
  const dots = [];
  if (dotsWrap) {
    dotsWrap.innerHTML = '';
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'awards__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Показати нагороду ' + (i + 1));
      dot.addEventListener('click', () => {
        if (animating || i === index) return;
        goTo(i, i > index ? 1 : -1);
      });
      dotsWrap.appendChild(dot);
      dots.push(dot);
    });
  }
  const setDot = (i) => dots.forEach((d, k) => d.classList.toggle('is-active', k === i));

  const photos = slides.map((s) => s.querySelector('.awards__video-photo'));
  // Cups per slide: prev award (small, left), the ACTIVE award (big, centre),
  // next award (small, right) — the size shows the status. The HTML keeps
  // neighbouring slides in sync (this slide's right ghost IS the next slide's
  // main award), which is what lets the switch morph a cup between slots.
  const cups = slides.map((s) => ({
    left: s.querySelector('.awards__trophy-ghost--left'),
    main: s.querySelector('.awards__trophy'),
    right: s.querySelector('.awards__trophy-ghost--right'),
  }));
  const cupList = (i) => [cups[i].left, cups[i].main, cups[i].right].filter(Boolean);
  // The info copy (name/quote/date) rides the horizontal axis together with
  // the cup shelf — see revealSlide/goTo. The title is separate: it's
  // identical on every slide, so re-animating it on each switch read as a
  // pointless blink — it only lifts in once, on the initial entrance. The
  // hidden slides' own (identical, aligned) titles stay at CSS defaults, so
  // the crossfade never shows on it.
  const infoEls = slides.map((s) => s.querySelector('.awards__info'));
  const titleEl = slides[0].querySelector('.awards__title');

  // Centre-to-side slot distance, for the initial entrance ride. Slides are
  // stacked with visibility/opacity, so rects stay measurable when hidden.
  const slotDist = (i) => {
    const c = cups[i];
    if (!c.main || !c.left) return window.innerWidth * 0.2;
    const cx = (el) => {
      const r = el.getBoundingClientRect();
      return r.left + r.width / 2;
    };
    return Math.abs(cx(c.main) - cx(c.left)) || window.innerWidth * 0.2;
  };

  // Every cup movement in one switch shares this duration + ease (and runs in
  // lockstep with the slide crossfade), so the whole thing reads as one
  // carousel step along the horizontal axis.
  const SHELF_DUR = 0.8;
  const SHELF_EASE = 'power2.inOut';
  // Must match .awards__trophy-ghost's CSS filter — the morphs tween between
  // the ghost look and the full-strength look.
  const GHOST_FILTER = 'grayscale(40%) opacity(0.3)';
  const PLAIN_FILTER = 'grayscale(0%) opacity(1)';

  // Slides sit stacked in the same grid cell (see _awards.sass); only the
  // active one is visible, the rest are hidden until they crossfade in.
  slides.forEach((s, i) => {
    if (hasGsap) {
      gsap.set(s, { autoAlpha: i === 0 ? 1 : 0, zIndex: i === 0 ? 2 : 1 });
    } else {
      s.style.visibility = i === 0 ? '' : 'hidden';
    }
  });

  if (hasGsap) {
    photos.forEach((p) => p && gsap.set(p, { scale: 1.16, transformOrigin: '50% 50%' }));
    infoEls.forEach((info) => info && gsap.set(info, { autoAlpha: 0 }));
    if (titleEl) gsap.set(titleEl, { y: 26, autoAlpha: 0 });
    slides.forEach((_, i) => cupList(i).length && gsap.set(cupList(i), { autoAlpha: 0 }));
  }

  // Photo settles from a slight zoom-in and the card copy lifts in with a
  // stagger, instead of the slide just snapping into place. The cups ride in
  // along the axis only on the INITIAL entrance (IntersectionObserver below):
  // on arrow/swipe switches goTo runs the slot-morph itself and passes
  // cupsHandled so we don't double-animate them.
  function revealSlide(i, dir, cupsHandled) {
    if (!hasGsap) return;
    if (dir !== 1 && dir !== -1) dir = 1;
    const photo = photos[i];
    const info = infoEls[i];
    if (photo) gsap.fromTo(photo, { scale: 1.16 }, { scale: 1, duration: 1.3, ease: 'power3.out', overwrite: true });
    // The info block rides the same horizontal axis as the cup shelf: on
    // arrow/swipe switches it arrives from the travel side (dir), on the
    // initial entrance it rides in alongside the cups (which enter from the
    // opposite sign, see the cups fromTo below).
    if (info) {
      gsap.fromTo(info, { x: (cupsHandled ? dir : -dir) * slotDist(i), autoAlpha: 0 }, {
        x: 0,
        autoAlpha: 1,
        duration: SHELF_DUR,
        ease: SHELF_EASE,
        overwrite: true,
      });
    }
    // One-shot title entrance; switches (cupsHandled) never re-run it, so the
    // shared title reads as one static heading across all slides.
    if (!cupsHandled && titleEl) {
      gsap.to(titleEl, { y: 0, autoAlpha: 1, duration: 0.8, ease: 'power3.out', delay: 0.15, overwrite: true });
    }
    if (!cupsHandled && cupList(i).length) {
      gsap.fromTo(cupList(i), { x: -dir * slotDist(i), autoAlpha: 0 }, {
        x: 0,
        autoAlpha: 1,
        duration: SHELF_DUR,
        ease: SHELF_EASE,
        overwrite: true,
      });
    }
  }

  function pulse(btn) {
    if (!hasGsap) return;
    gsap.fromTo(btn, { scale: 0.88 }, { scale: 1, duration: 0.5, ease: 'back.out(3)' });
  }

  // Slide 0's reveal waits for the section to actually be on screen (same
  // treatment as every other section's entrance) — firing it unconditionally
  // on load would finish the animation long before anyone scrolls down here.
  if (hasGsap && typeof IntersectionObserver !== 'undefined') {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        revealSlide(0);
        io.disconnect();
      });
    }, { threshold: 0.2 });
    io.observe(slider);
  } else {
    revealSlide(0);
  }

  function goTo(next, dir) {
    if (animating || next === index) return;
    // Travel direction for the card spin; callers pass it explicitly (the
    // index comparison alone lies on the wrap-around jumps like last -> 0).
    if (dir !== 1 && dir !== -1) dir = next > index ? 1 : -1;
    animating = true;
    prevBtn.classList.add('is-disabled');
    nextBtn.classList.add('is-disabled');

    const outgoing = slides[index];
    const incoming = slides[next];

    if (hasGsap) {
      // The incoming slide fades in ON TOP of the outgoing one. Card and photo
      // are opaque, so the outgoing content stays put underneath and the
      // switch reads as the content crossfading in place — nothing moves
      // horizontally. The trophies then spin in via revealSlide below.
      gsap.set(incoming, { zIndex: 3, autoAlpha: 0 });
      // The outgoing info pages away along the travel axis, mirroring the
      // cups; the incoming one rides in from the other side via revealSlide.
      if (infoEls[index]) {
        gsap.to(infoEls[index], {
          x: -dir * slotDist(index),
          autoAlpha: 0,
          duration: SHELF_DUR,
          ease: SHELF_EASE,
          overwrite: true,
        });
      }

      // --- Carousel step of the cup shelf -------------------------------
      // On "next" (dir 1): the left (prev) cup pages away, the ACTIVE cup
      // shrinks into the left slot, the right (next) cup grows into the
      // centre and becomes active, and the upcoming award rides in on the
      // right. "prev" mirrors it. The shrink/grow pairs are morphs between
      // the outgoing cup and its incoming twin (same award image): both
      // interpolate between the same two slot geometries with the same
      // ease, so they coincide every frame and the slide crossfade under
      // them is invisible — it reads as one cup travelling along the axis.
      // Captured NOW: `index` is reassigned to `next` before onComplete fires.
      const outIdx = index;
      const outCups = cups[outIdx];
      const inCups = cups[next];
      const allCups = [...cupList(outIdx), ...cupList(next)];
      if (outCups.main && inCups.main && outCups.left && outCups.right && inCups.left && inCups.right) {
        gsap.killTweensOf(allCups);
        // Neutral pose first, so the slot geometry we measure is the resting one.
        gsap.set(allCups, { x: 0, y: 0, scale: 1, transformOrigin: '50% 100%' });

        const geo = (el) => {
          const r = el.getBoundingClientRect();
          return { cx: r.left + r.width / 2, b: r.bottom, h: r.height || 1 };
        };
        const g = {
          outL: geo(outCups.left), outC: geo(outCups.main), outR: geo(outCups.right),
          inL: geo(inCups.left), inC: geo(inCups.main), inR: geo(inCups.right),
        };
        const move = { duration: SHELF_DUR, ease: SHELF_EASE, overwrite: true };

        // a (on screen now, at rest) glides onto b's resting slot; b rides the
        // exact same path from a's slot into its own resting pose.
        const morphPair = (a, ga, b, gb, filterFrom, filterTo) => {
          gsap.fromTo(a, { filter: filterFrom }, {
            x: gb.cx - ga.cx, y: gb.b - ga.b, scale: gb.h / ga.h, filter: filterTo, ...move,
          });
          gsap.set(b, { autoAlpha: 1 });
          gsap.fromTo(b, { x: ga.cx - gb.cx, y: ga.b - gb.b, scale: ga.h / gb.h }, { x: 0, y: 0, scale: 1, ...move });
        };

        if (dir === 1) {
          morphPair(outCups.main, g.outC, inCups.left, g.inL, PLAIN_FILTER, GHOST_FILTER);
          morphPair(outCups.right, g.outR, inCups.main, g.inC, GHOST_FILTER, PLAIN_FILTER);
          // Prev cup pages away one more slot left; the upcoming award enters
          // from one slot beyond the right edge.
          gsap.to(outCups.left, { x: g.outL.cx - g.outC.cx, autoAlpha: 0, ...move });
          gsap.fromTo(inCups.right, { x: g.inR.cx - g.inC.cx, autoAlpha: 0 }, { x: 0, autoAlpha: 1, ...move });
        } else {
          morphPair(outCups.main, g.outC, inCups.right, g.inR, PLAIN_FILTER, GHOST_FILTER);
          morphPair(outCups.left, g.outL, inCups.main, g.inC, GHOST_FILTER, PLAIN_FILTER);
          gsap.to(outCups.right, { x: g.outR.cx - g.outC.cx, autoAlpha: 0, ...move });
          gsap.fromTo(inCups.left, { x: g.inL.cx - g.inC.cx, autoAlpha: 0 }, { x: 0, autoAlpha: 1, ...move });
        }
      } else if (cupList(next).length) {
        // Some cup is missing (defensive) — plain fade-in for the new set.
        gsap.set(cupList(next), { autoAlpha: 1 });
      }

      gsap.to(incoming, {
        autoAlpha: 1,
        duration: SHELF_DUR,
        ease: 'power2.inOut',
        onComplete: () => {
          gsap.set(outgoing, { autoAlpha: 0, zIndex: 1 });
          gsap.set(incoming, { zIndex: 2 });
          // Wipe the outgoing cups' inline morph state (transform/filter/
          // alpha), so they're back at CSS defaults when this slide returns.
          gsap.set(cupList(outIdx), { clearProps: 'transform,filter,opacity,visibility' });
          animating = false;
          prevBtn.classList.remove('is-disabled');
          nextBtn.classList.remove('is-disabled');
        },
      });
    } else {
      outgoing.style.visibility = 'hidden';
      incoming.style.visibility = '';
      animating = false;
      prevBtn.classList.remove('is-disabled');
      nextBtn.classList.remove('is-disabled');
    }

    index = next;
    setDot(index);
    revealSlide(index, dir, true);
  }

  nextBtn.addEventListener('click', () => {
    if (animating) return;
    pulse(nextBtn);
    goTo((index + 1) % slides.length, 1);
  });

  prevBtn.addEventListener('click', () => {
    if (animating) return;
    pulse(prevBtn);
    goTo((index - 1 + slides.length) % slides.length, -1);
  });

  // Touch swipe flips the slides too (mobile). Passive listeners: the page
  // keeps scrolling normally, we only react to a mostly-horizontal gesture.
  let touchX = 0;
  let touchY = 0;
  slider.addEventListener('touchstart', (e) => {
    touchX = e.touches[0].clientX;
    touchY = e.touches[0].clientY;
  }, { passive: true });
  slider.addEventListener('touchend', (e) => {
    if (animating) return;
    const dx = e.changedTouches[0].clientX - touchX;
    const dy = e.changedTouches[0].clientY - touchY;
    // Ignore taps and vertical scrolls.
    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
    if (dx < 0) {
      pulse(nextBtn);
      goTo((index + 1) % slides.length, 1);
    } else {
      pulse(prevBtn);
      goTo((index - 1 + slides.length) % slides.length, -1);
    }
  }, { passive: true });
}

// "Наші партнери": the logo cards run as a marquee. The set is cloned once
// and the CSS animation slides the track by half its width (one set), so the
// loop never shows a seam; the duration is derived from the measured set
// width to keep a constant px/s whatever the logo count or viewport.
function initPartners() {
  const section = document.querySelector('.partners');
  if (!section) return;
  const track = section.querySelector('.partners__items');
  const items = track ? Array.from(track.children) : [];
  if (track && items.length) {
    items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
    const SPEED = 40; // px per second
    const setDuration = () => {
      const setWidth = track.scrollWidth / 2;
      if (setWidth > 0) track.style.setProperty('--marquee-duration', (setWidth / SPEED).toFixed(2) + 's');
    };
    setDuration();
    let timer = null;
    window.addEventListener('resize', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(setDuration, 150);
    });
  }
  fadeInOnView(Array.from(section.querySelectorAll('.partners__intro, .partners__marquee')), 0.12);
}

// 3D tilt on the instagram card: the card rotates toward the cursor while its
// layers (background watermark vs. icon/body/handle) sit at different
// z-depths, so the rotation visibly separates them — a depth/parallax
// illusion rather than a flat hover state.
function initInstagramTilt() {
  if (typeof gsap === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

  document.querySelectorAll('.instagram-block').forEach(initCard);

  function initCard(card) {
  // Hit-test on the whole .instagram section, not the card itself: the tilt
  // should respond to the cursor anywhere over the block, and once the card is
  // tilted in 3D its painted quad shifts in screen space, so listening on the
  // card causes the cursor to drift in/out of it near the edges and the tilt
  // snaps back and forth (mouseleave -> reset -> re-enter). The section never
  // transforms, so its hit area stays put.
  const hitArea = card.closest('.instagram') || card.parentElement || card;

  const watermark = card.querySelector('.instagram-block__watermark');
  const foreground = [
    card.querySelector('.instagram-block__icon'),
    card.querySelector('.instagram-block__body'),
    card.querySelector('.instagram-block__handle'),
  ].filter(Boolean);

  const maxTilt = 18;

  gsap.set(card, { transformPerspective: 600, transformStyle: 'preserve-3d' });
  if (watermark) gsap.set(watermark, { z: -70 });
  if (foreground.length) gsap.set(foreground, { z: 90 });

  // Longer duration = a touch of lag/inertia, so the card eases after the
  // cursor instead of snapping with it.
  const setRotationX = gsap.quickTo(card, 'rotationX', { duration: 1.1, ease: 'power2.out' });
  const setRotationY = gsap.quickTo(card, 'rotationY', { duration: 1.1, ease: 'power2.out' });

  // Snapshot the hit area's box once on entry instead of re-reading
  // getBoundingClientRect on every move: layout reads per mousemove are
  // wasted work when nothing has moved.
  let rect = null;

  hitArea.addEventListener('mouseenter', () => {
    rect = hitArea.getBoundingClientRect();
  });

  // Scrolling shifts the section's client coords without firing mousemove —
  // drop the snapshot so the next move re-measures.
  window.addEventListener('scroll', () => { rect = null; }, { passive: true });

  hitArea.addEventListener('mousemove', (ev) => {
    if (!rect) rect = hitArea.getBoundingClientRect();

    // Cursor position across the whole section maps to the full tilt range —
    // the card is centred in the block, so dead-centre cursor = flat card.
    const px = Math.min(1, Math.max(0, (ev.clientX - rect.left) / rect.width));
    const py = Math.min(1, Math.max(0, (ev.clientY - rect.top) / rect.height));

    setRotationX((0.5 - py) * maxTilt * 2);
    setRotationY((px - 0.5) * maxTilt * 2);
  });

  hitArea.addEventListener('mouseleave', () => {
    rect = null;
    setRotationX(0);
    setRotationY(0);
  });
  }
}

function initSceneBg() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const scene3 = document.querySelector('.scene-3');
  if (!scene3) return;

  gsap.fromTo(document.body,
    { backgroundColor: '#ffffff' },
    {
      backgroundColor: '#EDE7E0',
      ease: 'none',
      scrollTrigger: {
        trigger: scene3,
        start: 'top bottom',
        end: 'top center',
        scrub: true,
        invalidateOnRefresh: true,
      },
    }
  );

  const youCan = document.querySelector('.you-can');
  if (youCan) {
    gsap.fromTo(document.body,
      { backgroundColor: '#EDE7E0' },
      {
        backgroundColor: '#ffffff',
        ease: 'none',
        immediateRender: false,
        scrollTrigger: {
          trigger: youCan,
          start: 'top bottom',
          end: 'top center',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  }
}

// Mobile-only: tint the page background to Malika's beige while the section is
// on screen, then return to the default white as it leaves. The colour is set
// on <body> (the section itself stays transparent) so it fills the content
// edge-to-edge. html stays white, so the canvas / iOS safe-area bar isn't
// tinted; and we always revert on leave, so it never sticks on later sections.
function initSceneBgMobile() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const scene3 = document.querySelector('.scene-3');
  if (!scene3) return;
  const youCan = document.querySelector('.you-can');

  const DEFAULT_BG = '#ffffff';
  const MALIKA_BG = '#EDE7E0';
  const toBg = (color) => gsap.to(document.body, {
    backgroundColor: color,
    duration: 0.7,
    ease: 'power1.inOut',
    overwrite: 'auto',
  });

  // Beige as we reach Malika.
  ScrollTrigger.create({
    trigger: scene3,
    start: 'top 75%',
    invalidateOnRefresh: true,
    onEnter: () => toBg(MALIKA_BG),
    onLeaveBack: () => toBg(DEFAULT_BG),
  });

  // Back to white only once the NEXT section (you-can) actually arrives — Malika
  // is pinned, so keying the revert off its own bottom fired too early; the next
  // section is a reliable "we're past the block" marker, much later.
  if (youCan) {
    ScrollTrigger.create({
      trigger: youCan,
      start: 'top 70%',
      invalidateOnRefresh: true,
      onEnter: () => toBg(DEFAULT_BG),
      onLeaveBack: () => toBg(MALIKA_BG),
    });
  }
}

// Mobile-only black-background reveal for what-we-do. The sticky
// .what-we-do__dec circle (CSS ::before sized by --what-we-do-dec-r) grows from
// the bottom-center to bloom the dark background in between you-can and
// what-we-do. It always grows from the bottom and never shrinks-from-top (that
// made the circle look like it "flew up" near the end) — the black simply
// leaves with the sticky section as it scrolls off. The section background is
// transparent (see _what-we-do.sass) so the circle is what paints the black.
function initWhatWeDoBgMobile() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const block = document.querySelector('.what-we-do');
  const dec = document.querySelector('.what-we-do__dec');
  if (!block || !dec) return;

  // Base the radius on the dec's ACTUAL size (its height is 100vh, which on
  // mobile Safari is the large viewport — taller than window.innerHeight). The
  // circle grows from the bottom-center, so the farthest point is a top corner:
  // sqrt((w/2)^2 + h^2). Generous margin so the top corners stay fully covered.
  const getMaxDecRadius = () => {
    const w = dec.offsetWidth || window.innerWidth;
    const h = dec.offsetHeight || window.innerHeight;
    return Math.ceil(Math.sqrt((w / 2) * (w / 2) + h * h)) + 120;
  };

  const decProxy = { r: 0 };
  const updateDecRadius = () => dec.style.setProperty('--what-we-do-dec-r', decProxy.r + 'px');

  dec.style.setProperty('--what-we-do-dec-r', '0px');
  dec.style.setProperty('--what-we-do-dec-y', '100%'); // always grow from the bottom

  // Grow from the bottom-center as the section arrives, then stay expanded
  // (no shrink). Starts a bit earlier than the desktop dome.
  gsap.to(decProxy, {
    r: () => getMaxDecRadius(),
    ease: 'none',
    scrollTrigger: {
      trigger: block,
      start: 'top 150%',
      end: 'top 0%',
      scrub: true,
      invalidateOnRefresh: true,
    },
    onUpdate: updateDecRadius,
  });

  // Solid black background while the section occupies the viewport (from the
  // moment it tops out until it has fully scrolled off the top). The dec circle
  // only does the radial transition at the edges, so a sticky/refresh glitch
  // mid-section can never flash a white background.
  ScrollTrigger.create({
    trigger: block,
    start: 'top top',
    end: 'bottom top',
    invalidateOnRefresh: true,
    toggleClass: { targets: block, className: 'is-filled' },
  });

  // Past the section's midpoint, mark .what-we-do with is-ovh (overflow:hidden);
  // remove it again before the midpoint.
  ScrollTrigger.create({
    trigger: block,
    start: 'top top',
    end: 'bottom bottom',
    invalidateOnRefresh: true,
    onUpdate: (self) => {
      block.classList.toggle('is-ovh', self.progress >= 0.5);
    },
  });
}

function initMalika() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.malika');
  if (!section) return;

  const layer1 = section.querySelector('.malika__layer--1');
  const layer2 = section.querySelector('.malika__layer--2');

  [layer1, layer2].forEach((layer) => {
    if (!layer) return;

    const photoFrames = Array.from(layer.querySelectorAll('.malika__photo-frame'));
    const photos = Array.from(layer.querySelectorAll('.malika__photo'));
    const photoFrame1 = layer.querySelector('.malika__photo-frame--1');
    const photoFrame2 = layer.querySelector('.malika__photo-frame--2');
    const photoFrame3 = layer.querySelector('.malika__photo-frame--3');
    const photoFrame4 = layer.querySelector('.malika__photo-frame--4');
    const delayedPhotoFrames = photoFrames.filter((frame) => (
      frame.classList.contains('malika__photo-frame--2') ||
      frame.classList.contains('malika__photo-frame--3') ||
      frame.classList.contains('malika__photo-frame--4')
    ));
    const defaultPhotoFrames = photoFrames.filter((frame) => !delayedPhotoFrames.includes(frame));
    const descBlocks = [
      layer.querySelector('.malika__lead'),
      layer.querySelector('.malika__text'),
      layer.querySelector('.malika__instagram'),
    ].filter(Boolean);

    if (photoFrames.length) {
      gsap.set(photoFrames, {
        clipPath: 'inset(100% 0% 0% 0%)',
        scale: 1.04,
        transformOrigin: 'center center',
      });
      gsap.set(photos, {
        scale: 1.22,
        transformOrigin: 'center center',
      });

      if (defaultPhotoFrames.length) {
        gsap.to(defaultPhotoFrames, {
          clipPath: 'inset(0% 0% 0% 0%)',
          scale: 1,
          ease: 'none',
          stagger: 0.15,
          scrollTrigger: {
            trigger: layer,
            start: 'top 90%',
            end: 'top 30%',
            scrub: true,
            invalidateOnRefresh: true,
          },
        });
      }

      if (delayedPhotoFrames.length) {
        gsap.to(delayedPhotoFrames, {
          clipPath: 'inset(0% 0% 0% 0%)',
          scale: 1,
          ease: 'none',
          stagger: 0.15,
          scrollTrigger: {
            trigger: layer,
            start: 'top 58%',
            end: 'top 16%',
            scrub: true,
            invalidateOnRefresh: true,
          },
        });
      }

      gsap.to(photos, {
        scale: 1.07,
        ease: 'none',
        stagger: 0.15,
        scrollTrigger: {
          trigger: layer,
          start: 'top 80%',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    }

    if (descBlocks.length) {
      gsap.set(descBlocks, { y: 40, autoAlpha: 0 });

      gsap.to(descBlocks, {
        y: 0,
        autoAlpha: 1,
        ease: 'none',
        stagger: 0.12,
        scrollTrigger: {
          trigger: layer,
          start: 'top 80%',
          end: 'top 25%',
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    }

    if (photoFrame1) {
      gsap.to(photoFrame1, {
        yPercent: -44,
        ease: 'none',
        scrollTrigger: {
          trigger: layer,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    }
    if (photoFrame2) {
      gsap.to(photoFrame2, {
        yPercent: -58,
        ease: 'none',
        scrollTrigger: {
          trigger: layer,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    }
    if (photoFrame3) {
      gsap.to(photoFrame3, {
        yPercent: -52,
        ease: 'none',
        scrollTrigger: {
          trigger: layer,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    }
    if (photoFrame4) {
      gsap.to(photoFrame4, {
        yPercent: -22,
        ease: 'none',
        scrollTrigger: {
          trigger: layer,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    }
  });

  const name = document.querySelector('.scene-3 .malika__name');
  const scene3 = document.querySelector('.scene-3');
  const title = name && name.querySelector('.malika__title');

  let titleName = null;
  if (title) {
    const firstNode = title.firstChild;
    if (firstNode && firstNode.nodeType === Node.TEXT_NODE && firstNode.textContent.trim()) {
      titleName = document.createElement('span');
      titleName.className = 'malika__title-name';
      titleName.style.display = 'inline-block';
      titleName.textContent = firstNode.textContent.trim();
      title.replaceChild(titleName, firstNode);
    }
  }

  const role = name && name.querySelector('.malika__role');
  const titleEm = title && title.querySelector('em');
  const nameItems = [role, titleName, titleEm].filter(Boolean);

  if (name && scene3) {
    gsap.set(name, { autoAlpha: 0 });
    if (nameItems.length) {
      gsap.set(nameItems, { y: 40, autoAlpha: 0 });
    }

    const fadeIn = gsap.timeline({
      scrollTrigger: {
        trigger: scene3,
        start: 'top 48%',
        end: 'top 12%',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
    fadeIn.to(name, { autoAlpha: 1, ease: 'none' }, 0);
    if (nameItems.length) {
      fadeIn.to(nameItems, {
        y: 0,
        autoAlpha: 1,
        ease: 'none',
        stagger: 0.15,
      }, 0);
    }

    ScrollTrigger.create({
      trigger: scene3,
      start: 'bottom bottom',
      onEnter: () => name.classList.add('is-stuck'),
      onLeaveBack: () => name.classList.remove('is-stuck'),
    });
  }

  if (name && layer2) {
    const naturalLeft = () => {
      const currentX = parseFloat(gsap.getProperty(name, 'x')) || 0;
      return name.getBoundingClientRect().left - currentX;
    };

    gsap.fromTo(name,
      { x: 0 },
      {
        x: () => window.innerWidth - 2 * naturalLeft() - name.offsetWidth,
        ease: 'none',
        scrollTrigger: {
          trigger: layer2,
          start: 'top 58%',
          end: 'top top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  }

  const remPx = () => parseFloat(getComputedStyle(document.documentElement).fontSize);
  const colPx = (n) => {
    const r = remPx();
    const margin = 2 * r;
    const gutter = 2 * r;
    const total = 12;
    const single = (window.innerWidth - 2 * margin - (total - 1) * gutter) / total;
    return single * n + gutter * (n - 1);
  };
  const gutterPx = () => 2 * remPx();

  if (role && titleName && layer2) {
    gsap.fromTo([role, titleName],
      { x: 0 },
      {
        x: () => colPx(3) + gutterPx(),
        ease: 'none',
        scrollTrigger: {
          trigger: layer2,
          start: 'top 58%',
          end: 'top top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  }

  if (titleEm && layer2) {
    gsap.fromTo(titleEm,
      { x: 0 },
      {
        x: () => -colPx(2),
        ease: 'none',
        scrollTrigger: {
          trigger: layer2,
          start: 'top 58%',
          end: 'top top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  }

  if (nameItems.length) {
    gsap.set(nameItems, { transformOrigin: 'center center', force3D: true });

    const proxy = { skew: 0 };
    const setSkew = gsap.quickSetter(nameItems, 'skewX', 'deg');
    const clampSkew = gsap.utils.clamp(-22, 22);

    ScrollTrigger.create({
      onUpdate: (self) => {
        const skew = clampSkew(self.getVelocity() / -180);
        if (Math.abs(skew) > Math.abs(proxy.skew)) {
          proxy.skew = skew;
          gsap.to(proxy, {
            skew: 0,
            duration: 1,
            ease: 'power3',
            overwrite: true,
            onUpdate: () => setSkew(proxy.skew),
          });
        }
      },
    });
  }
}

function initVideoExpand() {
  if (typeof gsap === 'undefined') return;

  const items = document.querySelectorAll('.about-item--video[data-video]');
  if (!items.length) return;

  let activeItem = null;
  let placeholder = null;
  let overlay = null;
  let isAnimating = false;
  let isPendingOpen = false;

  const computeTarget = () => {
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const lineLeft = document.querySelector('.line--2');
    const lineRight = document.querySelector('.line--3');

    let left, width, top, height;

    if (lineLeft && lineRight && isDesktop()) {
      const l = lineLeft.getBoundingClientRect();
      const r = lineRight.getBoundingClientRect();
      left = l.right + rem;
      width = r.left - l.right - 2 * rem;
      height = Math.min(width * 585 / 930, window.innerHeight * 0.85);

      const photo = document.querySelector('.about__items .about-item--photo');
      top = photo
        ? photo.getBoundingClientRect().bottom - height
        : (window.innerHeight - height) / 2;
    } else {
      width = window.innerWidth - 2 * rem;
      height = Math.min(width * 585 / 930, window.innerHeight * 0.85);
      left = (window.innerWidth - width) / 2;
      top = (window.innerHeight - height) / 2;
    }

    return { top, left, width, height };
  };

  const ensureOverlay = () => {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'about-overlay';
    overlay.addEventListener('click', () => close());
    document.body.appendChild(overlay);
    return overlay;
  };

  const snapToNearestSlot = (item, callback) => {
    if (!isDesktop()) { callback(); return; }
    const aboutIn = document.querySelector('.about__in');
    const itemsEl = item.parentElement;
    if (!aboutIn || !itemsEl) { callback(); return; }

    const aboutInRect = aboutIn.getBoundingClientRect();
    const innerPaddingLeft = parseFloat(getComputedStyle(aboutIn).paddingLeft) || 0;
    const innerLeft = aboutInRect.left + innerPaddingLeft;

    const itemRect = item.getBoundingClientRect();
    const gap = parseFloat(getComputedStyle(itemsEl).gap) || 0;
    const slotWidth = itemRect.width + gap;

    const slot2Left = innerLeft + slotWidth;
    const slot3Left = innerLeft + 2 * slotWidth;

    const targetLeft = Math.abs(itemRect.left - slot2Left) <= Math.abs(itemRect.left - slot3Left)
      ? slot2Left
      : slot3Left;
    const deltaX = itemRect.left - targetLeft;

    if (Math.abs(deltaX) < 1) { callback(); return; }

    const targetScrollY = pageScrollY() + deltaX;
    scrollPageTo(targetScrollY, {
      duration: 0.6,
      ease: 'power1.inOut',
      onComplete: () => setTimeout(callback, 150),
    });
  };

  const open = (item) => {
    if (isAnimating || activeItem) return;
    const src = item.dataset.video;
    if (!src) return;

    activeItem = item;
    isAnimating = true;

    const rect = item.getBoundingClientRect();
    const target = computeTarget();

    placeholder = document.createElement('div');
    placeholder.className = 'about-item about-item--placeholder';
    placeholder.style.width = rect.width + 'px';
    placeholder.style.height = rect.height + 'px';
    placeholder.style.flexShrink = '0';
    placeholder.style.visibility = 'hidden';
    item.parentNode.insertBefore(placeholder, item);

    document.body.appendChild(item);

    item.classList.add('is-expanded');
    lockPageScroll(true);

    gsap.set(item, {
      position: 'fixed',
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
      margin: 0,
      zIndex: 1000,
    });

    const video = item.querySelector('.about-item__video');
    if (video) {
      if (video.getAttribute('src') !== src) video.setAttribute('src', src);
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => { });
    }

    const ov = ensureOverlay();
    gsap.set(ov, { opacity: 0, pointerEvents: 'auto' });
    gsap.to(ov, { opacity: 1, duration: 0.4, ease: 'power2.out' });

    const centerTop = (window.innerHeight - rect.height) / 2;
    const centerLeft = (window.innerWidth - rect.width) / 2;

    const tl = gsap.timeline({
      onComplete: () => { isAnimating = false; },
    });

    tl.to(item, {
      top: centerTop,
      left: centerLeft,
      duration: 0.4,
      ease: 'power2.inOut',
    });

    tl.to(item, {
      top: target.top,
      left: target.left,
      width: target.width,
      height: target.height,
      duration: 0.5,
      ease: 'power2.inOut',
    });
  };

  const close = () => {
    if (isAnimating || !activeItem || !placeholder) return;
    isAnimating = true;

    const item = activeItem;
    const rect = placeholder.getBoundingClientRect();

    const video = item.querySelector('.about-item__video');
    if (video) video.pause();

    item.classList.remove('is-expanded');

    const centerTop = (window.innerHeight - rect.height) / 2;
    const centerLeft = (window.innerWidth - rect.width) / 2;

    const tl = gsap.timeline({
      onComplete: () => {
        if (placeholder && placeholder.parentNode) {
          placeholder.parentNode.insertBefore(item, placeholder);
          placeholder.parentNode.removeChild(placeholder);
        }
        gsap.set(item, { clearProps: 'all' });
        if (video) {
          video.currentTime = 0;
          video.removeAttribute('src');
          video.load();
        }
        lockPageScroll(false);
        placeholder = null;
        activeItem = null;
        isAnimating = false;
      },
    });

    tl.to(item, {
      top: centerTop,
      left: centerLeft,
      width: rect.width,
      height: rect.height,
      duration: 0.4,
      ease: 'power2.inOut',
    });

    tl.to(item, {
      top: rect.top,
      left: rect.left,
      duration: 0.4,
      ease: 'power2.inOut',
    });

    if (overlay) {
      gsap.to(overlay, {
        opacity: 0,
        duration: 0.4,
        ease: 'power2.in',
        onComplete: () => {
          if (overlay) gsap.set(overlay, { pointerEvents: 'none' });
        },
      });
    }
  };

  items.forEach((item) => {
    item.addEventListener('click', (e) => {
      if (e.target.closest('.about-item__close')) return;
      if (item.classList.contains('is-expanded')) return;
      if (isAnimating || activeItem || isPendingOpen) return;
      e.preventDefault();
      isPendingOpen = true;
      snapToNearestSlot(item, () => {
        isPendingOpen = false;
        open(item);
      });
    });

    const closeBtn = item.querySelector('.about-item__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        close();
      });
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && activeItem) close();
  });
}

function initLogoScale() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const logo = document.querySelector('.header-logo');
  if (!logo) return;

  const beBest = document.querySelector('.be-best');
  const malika = document.querySelector('.malika');
  const layer1 = malika && malika.querySelector('.malika__layer--1');
  const layer2 = malika && malika.querySelector('.malika__layer--2');
  const whereWeWas = document.querySelector('.where-we-was');
  const reviews = document.querySelector('.reviews');

  const SCALE_BIG = 1;
  const SCALE_SMALL = 64 / 110;
  const Y_BIG_REM = 19;

  let pBeBest = 0;
  let pLayer1 = 0;
  let pLayer2 = 0;
  let pWhereWeWas = 0;
  let isReviewsActive = false;

  const remPx = () => parseFloat(getComputedStyle(document.documentElement).fontSize);

  const apply = () => {
    let scale;
    let yRem;

    if (isReviewsActive) {
      scale = SCALE_SMALL;
      yRem = 0;
    } else if (pWhereWeWas > 0) {
      scale = SCALE_BIG + (SCALE_SMALL - SCALE_BIG) * pWhereWeWas;
      yRem = Y_BIG_REM * (1 - pWhereWeWas);
    } else if (pLayer2 > 0) {
      scale = SCALE_BIG + (SCALE_SMALL - SCALE_BIG) * pLayer2;
      yRem = Y_BIG_REM * (1 - pLayer2);
    } else if (pLayer1 > 0) {
      scale = SCALE_SMALL + (SCALE_BIG - SCALE_SMALL) * pLayer1;
      yRem = Y_BIG_REM * pLayer1;
    } else {
      scale = SCALE_BIG + (SCALE_SMALL - SCALE_BIG) * pBeBest;
      yRem = 0;
    }

    gsap.set(logo, { y: yRem * remPx(), scale });
  };

  apply();

  if (beBest) {
    ScrollTrigger.create({
      trigger: beBest,
      start: 'top bottom',
      end: 'top top',
      onUpdate: (self) => { pBeBest = self.progress; apply(); },
      onRefresh: (self) => { pBeBest = self.progress; apply(); },
      invalidateOnRefresh: true,
    });
  }

  if (layer1) {
    ScrollTrigger.create({
      trigger: layer1,
      start: 'top bottom',
      end: 'top top',
      onUpdate: (self) => { pLayer1 = self.progress; apply(); },
      onRefresh: (self) => { pLayer1 = self.progress; apply(); },
      invalidateOnRefresh: true,
    });
  }

  if (layer2) {
    ScrollTrigger.create({
      trigger: layer2,
      start: 'top bottom',
      end: 'top top',
      onUpdate: (self) => { pLayer2 = self.progress; apply(); },
      onRefresh: (self) => { pLayer2 = self.progress; apply(); },
      invalidateOnRefresh: true,
    });
  }

  if (whereWeWas) {
    ScrollTrigger.create({
      trigger: whereWeWas,
      // `.where-we-was` sits INSIDE `.scene-6`, which initWhereWeWas pins for
      // the whole horizontal ride. Without this, any ScrollTrigger.refresh()
      // that lands while the scene is pinned (lazy images below it finishing,
      // the layout observer) measures the section at its pinned spot and
      // moves this range thousands of px down into the ride — after which
      // scrolling back through the strip grew the logo to full size over the
      // headline. pinnedContainer makes refresh un-pin the scene first.
      pinnedContainer: whereWeWas.closest('.scene-6') || undefined,
      start: 'top bottom',
      // Finish a touch BEFORE the section pins ('top top'): the horizontal
      // scene's snap keeps nudging the scroll back and forth around its pin
      // start, and a logo range ending exactly there rides every nudge — the
      // header logo visibly twitched. Ending at 15% parks the logo on its
      // progress=1 plateau before the jitter zone begins.
      end: 'top 15%',
      onUpdate: (self) => { pWhereWeWas = self.progress; apply(); },
      onRefresh: (self) => { pWhereWeWas = self.progress; apply(); },
      invalidateOnRefresh: true,
    });
  }

  if (reviews) {
    ScrollTrigger.create({
      trigger: reviews,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => { isReviewsActive = true; apply(); },
      onEnterBack: () => { isReviewsActive = true; apply(); },
      onLeave: () => { isReviewsActive = false; apply(); },
      onLeaveBack: () => { isReviewsActive = false; apply(); },
      onRefresh: (self) => { isReviewsActive = self.isActive; apply(); },
      invalidateOnRefresh: true,
    });
  }
}

function initParallax() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const introHero = document.querySelector('.intro__visual--1');
  const introScene = document.querySelector('.scene-1');
  if (introHero && introScene) {
    const getIntroHeroHeight = () => introHero.getBoundingClientRect().width * 452 / 1880;

    gsap.fromTo(introHero,
      {
        height: () => getIntroHeroHeight(),
        yPercent: 0,
      },
      {
        height: () => Math.max(getIntroHeroHeight() * 0.1, 24),
        yPercent: -14,
        ease: 'none',
        scrollTrigger: {
          trigger: introScene,
          start: 'top top',
          end: () => '+=' + window.innerHeight * 0.9,
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  }

  const config = [
    { selector: '.intro__visual--2', yPercent: -168, trigger: '.scene-1', start: 'top top', end: () => '+=' + window.innerHeight },
    { selector: '.intro__visual--3', yPercent: -258, trigger: '.scene-1', start: 'top top', end: () => '+=' + window.innerHeight },
    { selector: '.be-best__photo--1', yPercent: -14 },
    { selector: '.be-best__photo--2', yPercent: -10 },
  ];

  config.forEach(({ selector, yPercent, trigger, start = 'top bottom', end = 'bottom top' }) => {
    const el = document.querySelector(selector);
    if (!el) return;
    const triggerEl = trigger ? document.querySelector(trigger) : el;
    if (!triggerEl) return;

    gsap.fromTo(el,
      { yPercent: 0 },
      {
        yPercent,
        ease: 'none',
        scrollTrigger: {
          trigger: triggerEl,
          start,
          end,
          scrub: true,
          invalidateOnRefresh: true,
        },
      },
    );
  });
}

function initReveal() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const reveal = (elements, trigger, { start = 'top 90%', end = 'top 30%', stagger = 0.15 } = {}) => {
    if (!elements.length || !trigger) return;
    gsap.set(elements, {
      clipPath: 'inset(100% 0% 0% 0%)',
      scale: 1.08,
      transformOrigin: 'center center',
    });
    gsap.to(elements, {
      clipPath: 'inset(0% 0% 0% 0%)',
      scale: 1,
      ease: 'none',
      stagger,
      scrollTrigger: {
        trigger,
        start,
        end,
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  };

  const beBest = document.querySelector('.be-best');
  const beBestPhoto1 = document.querySelector('.be-best__photo--1');
  const beBestPhoto2 = document.querySelector('.be-best__photo--2');
  if (beBestPhoto1) reveal([beBestPhoto1], beBest, { start: 'top 48%', end: 'top 10%' });
  // photo--2 sits high in the section (margin-top 9vh), so tying its reveal to
  // the whole .be-best top finished the draw-in while the photo was still only
  // mid-screen. Anchor it to its OWN container and stretch the range, so it
  // draws gradually as the photo rides up the viewport and finishes LATE — when
  // the photo is already high up — instead of completing before you notice it.
  const beBestItem2 = document.querySelector('.be-best__item--2');
  if (beBestPhoto2) reveal([beBestPhoto2], beBestItem2 || beBest, { start: 'top 90%', end: 'top 15%' });
}

function initHeadlineScale() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const headline = document.querySelector('.headline-1');
  const trigger = document.querySelector('.be-best');
  if (!headline || !trigger) return;

  const smallScale = 3.2 / 6.6;

  // Under ScrollSmoother the headline can't be position:fixed (a transformed
  // ancestor un-fixes it) — html.has-smoother makes .headline-pin an absolute
  // overlay at the document top, and this pin holds it on screen over the same
  // range the fixed phase used to cover. Past the end the pin keeps its final
  // offset, so the headline parks and scrolls away with the content — the
  // fixed→absolute hand-off in onLeave below becomes unnecessary.
  const pinWrap = document.querySelector('.headline-pin');
  if (smoother && pinWrap) {
    // Explicit width: the pin-spacer GSAP wraps around the absolute wrapper is
    // a zero-width absolute box, so the wrapper's own left:0/right:0 (and the
    // headline's inside it) would resolve against 0px and collapse the text.
    const sizeWrap = () => {
      pinWrap.style.width = document.documentElement.clientWidth + 'px';
    };
    sizeWrap();
    ScrollTrigger.addEventListener('refreshInit', sizeWrap);

    ScrollTrigger.create({
      trigger: pinWrap,
      start: 'top top',
      endTrigger: trigger,
      end: 'top top',
      pin: true,
      pinSpacing: false,
    });
  }

  // The (fixed) headline rises to centre + scales up as .be-best scrolls in, then
  // pins to the document so it scrolls away with the content — same behaviour as
  // before. Two things make the pin smooth instead of a hit:
  //   • the rise EASES OUT (expo.out — a long, soft glide), so it decelerates
  //     and "flies in" to the pin point over a long tail instead of arriving at a
  //     constant clip and snapping;
  //   • onLeave reads the headline's LIVE rect, so the fixed→absolute hand-off
  //     happens exactly where it already is — no positional jump.
  gsap.fromTo(headline,
    {
      y: () => window.innerHeight * 0.88,
      yPercent: -50,
      scale: smallScale,
    },
    {
      y: () => window.innerHeight / 2,
      scale: 1,
      ease: 'expo.out',
      scrollTrigger: {
        trigger,
        start: 'top bottom',
        end: 'top top',
        scrub: true,
        invalidateOnRefresh: true,
        onLeave: () => {
          if (smoother) return; // the .headline-pin pin parks it instead
          const rect = headline.getBoundingClientRect();
          gsap.set(headline, {
            position: 'absolute',
            top: rect.top + rect.height / 2 + window.scrollY,
            y: 0,
          });
        },
        onEnterBack: () => {
          if (smoother) return;
          gsap.set(headline, { clearProps: 'position,top' });
        },
      },
    }
  );
}

function initDecSigns() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const signs = gsap.utils.toArray('.dec-sign');
  const anchor = document.querySelector('.intro__visual--1');
  const trigger = document.querySelector('.be-best');
  const scene2 = document.querySelector('.scene-2');
  if (!signs.length || !anchor || !trigger) return;

  const rem = () => parseFloat(getComputedStyle(document.documentElement).fontSize);
  const clamp = gsap.utils.clamp(0, 1);
  const lerp = (from, to, progress) => from + (to - from) * progress;
  // pageScrollY (the SMOOTHED position under ScrollSmoother), not
  // window.scrollY: rects reflect the smoothed transform, so mixing them with
  // the native (target) scroll would drift by the catch-up lag mid-glide.
  const docTop = (el) => el.getBoundingClientRect().top + pageScrollY();
  const docBottom = (el) => docTop(el) + el.offsetHeight;
  const bottomY = () => window.innerHeight - 4 * rem();
  const middleY = () => window.innerHeight / 2;
  const startY = () => docBottom(anchor) + 2 * rem();
  const smoothY = gsap.quickTo(signs, 'y', { duration: 0.45, ease: 'power3.out' });
  const smoothOpacity = gsap.quickTo(signs, 'opacity', { duration: 0.35, ease: 'power2.out' });

  const malikaLayer2 = document.querySelector('.scene-3 .malika__layer--2');
  const youCan = document.querySelector('.you-can');
  const reviews = document.querySelector('.reviews');
  const footer = document.querySelector('.footer');

  const getTransitions = () => [
    { el: trigger, to: middleY, start: (el) => docTop(el) - window.innerHeight, end: docTop },
    { el: scene2, to: bottomY, start: (el) => docTop(el) - window.innerHeight, end: docTop },
    { el: malikaLayer2, to: middleY, start: (el) => docTop(el) - window.innerHeight, end: docTop },
    { el: youCan, to: bottomY, start: (el) => docTop(el) - window.innerHeight, end: docTop },
    { el: reviews, to: bottomY, start: (el) => docTop(el) - window.innerHeight, end: docTop },
    // Parks the signs at a fixed on-screen spot (same resting position as the
    // sections before it) once the footer is about to enter — `to` must stay a
    // viewport-size-only constant like the others, not the footer's own live
    // getBoundingClientRect().top, or the "frozen" value keeps drifting with
    // scroll instead of actually stopping.
    { el: footer, to: bottomY, start: (el) => docTop(el) - window.innerHeight, end: (el) => docTop(el) - window.innerHeight * 0.65 },
    // `.reviews` is currently `display:none` (see _default.sass), which makes
    // its getBoundingClientRect() collapse to all-zeros — its start/end above
    // would then track the CURRENT scroll position instead of a fixed point,
    // permanently satisfying its own range and making every later entry
    // (the footer stop included) unreachable. Drop any collapsed element so
    // this keeps working if another section gets hidden the same way.
  ].filter(({ el }) => el && el.getBoundingClientRect().height > 0);

  const targetY = () => {
    const scrollY = pageScrollY();
    let current = startY();

    getTransitions()
      .sort((a, b) => a.start(a.el) - b.start(b.el))
      .some(({ el, to, start, end }) => {
        const transitionStart = start(el);
        const transitionEnd = end(el);
        const next = typeof to === 'function' ? to() : to;

        if (scrollY < transitionStart) return true;
        if (scrollY <= transitionEnd) {
          current = lerp(current, next, clamp((scrollY - transitionStart) / (transitionEnd - transitionStart || 1)));
          return true;
        }

        current = next;
        return false;
      });

    return current;
  };

  const targetOpacity = () => {
    const start = docTop(trigger) - window.innerHeight;
    const end = docTop(trigger);
    let op = lerp(0.6, 1, clamp((pageScrollY() - start) / (end - start || 1)));

    // Fade the signs out on approach to the footer instead of leaving them
    // pinned on screen over its content once they've stopped moving.
    if (footer) {
      // Completes while the footer is still entering from the bottom (well
      // short of its top reaching the viewport) — a short final section may
      // not leave enough scroll room past that point to ever finish a fade
      // anchored later.
      const fadeStart = docTop(footer) - window.innerHeight * 0.95;
      const fadeEnd = docTop(footer) - window.innerHeight * 0.7;
      const fadeOut = lerp(1, 0, clamp((pageScrollY() - fadeStart) / (fadeEnd - fadeStart || 1)));
      op = Math.min(op, fadeOut);
    }

    return op;
  };

  const apply = (immediate) => {
    const y = targetY();
    const opacity = targetOpacity();

    if (immediate) {
      gsap.set(signs, { y, opacity });
      return;
    }

    smoothY(y);
    smoothOpacity(opacity);
  };

  apply(true);

  ScrollTrigger.create({
    start: 0,
    end: () => ScrollTrigger.maxScroll(window),
    onUpdate: () => apply(false),
    onRefresh: () => apply(true),
    invalidateOnRefresh: true,
  });
}

// Mobile-only: turn the about items into a native horizontal swipe slider (CSS
// overflow-x + scroll-snap, see _about.sass) — no pin, no 100vh, the page
// scrolls past normally and the user drags the slider to browse it. We only
// build the pagination dots here and keep them in sync with the scroll.
// Pagination dots for a native swipe slider (mobile about/support): clicking a
// dot scrolls the track, dragging the track re-syncs the active dot. The track
// itself is pure CSS (overflow-x + scroll-snap).
//
// Dots map to REACHABLE scroll stops, not raw items: the track can't scroll
// past scrollWidth - clientWidth, so a trailing item's start position clamps
// to that end stop (the item is fully visible there anyway). Without the
// clamp its dot could never activate — a dot you can't select reads as
// broken. Stops that collide after clamping are merged into one dot.
function bindSliderDots(track, items, pagination, dotClass, labelFor) {
  if (!track || !pagination || items.length < 2) return null;

  let dots = [];
  let stops = [];

  const computeStops = () => {
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const next = [];
    items.forEach((item) => {
      const target = Math.min(item.offsetLeft, maxScroll);
      if (!next.length || target - next[next.length - 1] > 2) next.push(target);
    });
    return next;
  };

  // Index of the stop nearest to the track's current scroll position.
  const nearestIdx = (list) => {
    const sl = track.scrollLeft;
    let idx = 0;
    let min = Infinity;
    list.forEach((left, i) => {
      const d = Math.abs(left - sl);
      if (d < min) { min = d; idx = i; }
    });
    return idx;
  };

  const buildDots = () => {
    stops = computeStops();
    // The dot for the CURRENT slide is created already active: a dot that is
    // inserted inactive and switched on a moment later plays its 0.3s
    // transition — with the rebuild running on every mobile resize (the URL
    // bar collapsing on each vertical scroll) that read as the pagination
    // twitching whenever the visitor had swiped past the first slide.
    const active = nearestIdx(stops);
    pagination.innerHTML = '';
    dots = stops.map((left, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = dotClass;
      dot.setAttribute('aria-label', labelFor(i));
      dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      if (i === active) dot.classList.add('is-active');
      dot.addEventListener('click', () => {
        track.scrollTo({ left: stops[i], behavior: 'smooth' });
      });
      pagination.appendChild(dot);
      return dot;
    });
  };

  let raf = 0;
  const syncDots = () => {
    raf = 0;
    const idx = nearestIdx(stops);
    dots.forEach((dot, i) => {
      const isActive = i === idx;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  buildDots();

  const onScroll = () => {
    if (!raf) raf = requestAnimationFrame(syncDots);
  };
  track.addEventListener('scroll', onScroll, { passive: true });

  // Slide widths are vw-based, so a resize/rotation can change which stops
  // exist (and how many dots there should be). Most mobile resizes are the
  // URL bar (height only) — the stops come out identical, so nothing is
  // rebuilt and the dots stay put.
  let resizeTimer = null;
  const onResize = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      const next = computeStops();
      const same = next.length === stops.length && next.every((left, i) => Math.abs(left - stops[i]) <= 1);
      if (!same) buildDots();
      syncDots();
    }, 150);
  };
  window.addEventListener('resize', onResize);

  // For callers that rebuild their slider (the event detail swaps its content
  // per event): drop the window listener so the old dots can be collected.
  return {
    destroy() {
      window.removeEventListener('resize', onResize);
      track.removeEventListener('scroll', onScroll);
      window.clearTimeout(resizeTimer);
    },
  };
}

function initAboutSliderMobile() {
  const track = document.querySelector('.about__items');
  if (!track) return;
  bindSliderDots(
    track,
    Array.from(track.querySelectorAll('.about-item')),
    document.querySelector('.about__pagination'),
    'about__pagination-dot',
    (i) => `Показати слайд про нас ${i + 1}`
  );
}

function initSupportSliderMobile() {
  const track = document.querySelector('.support__list');
  if (!track) return;
  bindSliderDots(
    track,
    Array.from(track.querySelectorAll('.support__item')),
    document.querySelector('.support__pagination'),
    'support__pagination-dot',
    (i) => `Показати слайд підтримки ${i + 1}`
  );
}

function initAboutHorizontal() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.about');
  const track = document.querySelector('.about__items');
  const pagination = document.querySelector('.about__pagination');
  if (!section || !track) return;

  const items = Array.from(track.querySelectorAll('.about-item'));

  const distance = () => Math.max(0, track.scrollWidth - track.clientWidth);
  if (distance() === 0) return;

  // Scroll progress (0..1) that aligns a given slide to the left edge — derived
  // from its real offset, so it's accurate even with unequal slide widths.
  const slideProgress = (item) => {
    const d = distance();
    if (d <= 0) return 0;
    const base = items[0].offsetLeft;
    return Math.min(1, Math.max(0, (item.offsetLeft - base) / d));
  };

  // One dot per slide.
  const dots = [];
  if (pagination && items.length > 1) {
    pagination.innerHTML = '';
    items.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'about__pagination-dot';
      dot.setAttribute('aria-label', `Показати слайд про нас ${i + 1}`);
      dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      if (i === 0) dot.classList.add('is-active');
      pagination.appendChild(dot);
      dots.push(dot);
    });
  }

  const setActiveDot = (progress) => {
    if (!dots.length) return;
    let idx = 0;
    let min = Infinity;
    items.forEach((item, i) => {
      const diff = Math.abs(slideProgress(item) - progress);
      if (diff < min) { min = diff; idx = i; }
    });
    dots.forEach((d, i) => {
      const isActive = i === idx;
      d.classList.toggle('is-active', isActive);
      d.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const tween = gsap.to(track, {
    x: () => -distance(),
    ease: 'none',
    scrollTrigger: {
      trigger: section,
      start: 'top top',
      end: () => `+=${distance()}`,
      pin: true,
      // Earliest pin on the page → highest refresh priority, so its spacer is laid
      // out before the where-we-was pin (1) and the join triggers (0) measure.
      refreshPriority: 2,
      scrub: 1,
      invalidateOnRefresh: true,
      onUpdate: (self) => setActiveDot(self.progress),
      onLeave: () => {
        if (pagination) gsap.to(pagination, { opacity: 0, duration: 0.3, ease: 'power2.out' });
      },
      onEnterBack: () => {
        if (pagination) gsap.to(pagination, { opacity: 1, duration: 0.3, ease: 'power2.out' });
      },
    },
  });

  const st = tween.scrollTrigger;

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      const target = st.start + (st.end - st.start) * slideProgress(items[i]);
      scrollPageTo(target, { duration: 0.8, ease: 'power1.inOut' });
    });
  });
}

function initLoader() {
  const introVisuals = [
    document.querySelector('.intro__visual--1'),
    document.querySelector('.intro__visual--2'),
    document.querySelector('.intro__visual--3'),
  ].filter(Boolean);

  const revealIntro = () => {
    if (!introVisuals.length || typeof gsap === 'undefined') return;
    gsap.to(introVisuals, {
      clipPath: 'inset(0% 0% 0% 0%)',
      duration: 1.2,
      ease: 'power3.out',
      stagger: 0.18,
      delay: 0,
    });
  };

  const $loader = $('.loader');
  if (!$loader.length || typeof gsap === 'undefined') {
    window.bfLoaderDone = true;
    lockPageScroll(false);
    revealIntro();
    return;
  }
  if (!$loader.is(':visible')) {
    window.bfLoaderDone = true;
    $loader.remove();
    lockPageScroll(false);
    revealIntro();
    return;
  }
  // Pages that wait for the curtain (the events headline pour) read this flag
  // and subscribe to bf:loader-done below.
  window.bfLoaderDone = false;

  const $photos = $loader.find('.loader__photo');
  const $progressValue = $loader.find('.loader-progress__value');
  const $progressLine = $loader.find('.loader-progress__bar-line');
  const $lastPhoto = $photos.last();
  const totalPhotos = $photos.length;
  let currentIndex = 0;

  const setActivePhoto = (index) => {
    if (index === currentIndex) return;
    $photos.eq(currentIndex).removeClass('is-active');
    $photos.eq(index).addClass('is-active');
    currentIndex = index;
  };

  const display = { value: 0 };
  const updateUI = () => {
    const v = display.value;
    $progressValue.text(Math.round(v) + '%');
    $progressLine.css('width', v + '%');
    const index = Math.min(totalPhotos - 1, Math.floor((v / 100) * totalPhotos));
    setActivePhoto(index);
  };

  const firstScreen = document.querySelector('.intro');
  const targetImages = firstScreen
    ? Array.from(firstScreen.querySelectorAll('img')).filter((img) => img.loading !== 'lazy')
    : [];
  const targetVideos = firstScreen
    ? Array.from(firstScreen.querySelectorAll('video')).filter((video) => video.preload !== 'none')
    : [];
  const totalAssets = targetImages.length + targetVideos.length;
  let loadedCount = 0;

  const COUNT_DURATION = 2.6;   // seconds — the 0 → 99 eased count-up
  const MAX_DURATION = 12000;   // hard cap: force-finish if assets stall
  let finished = false;
  let assetsReady = totalAssets === 0;
  let counterDone = false;

  // easeInOutQuart — slow start, quick through the middle, gentle settle near
  // the end. This is the awwwards-style count-up curve; the % number and the
  // bar both read from `display.value`, so easing the value eases both. Raise
  // the exponent (5 = quint, etc.) for even softer ends, lower it for snappier.
  const progressEase = (p) =>
    p < 0.5 ? 8 * p * p * p * p : 1 - Math.pow(-2 * p + 2, 4) / 2;

  const maybeFinish = () => {
    if (finished || !assetsReady || !counterDone) return;
    finishLoader();
  };

  // One continuous tween from 0 → 99 along the eased curve, decoupled from the
  // raw asset-load events that used to make the bar jump. We stop at 99 and let
  // finishLoader tick the last 1% + raise the curtain — and we only finish once
  // assets are actually ready, so the bar never claims 100% before it's loaded.
  const startCounter = () => {
    gsap.to(display, {
      value: 99,
      duration: COUNT_DURATION,
      ease: progressEase,
      onUpdate: updateUI,
      onComplete: () => { counterDone = true; maybeFinish(); },
    });
  };

  const flyLogoToIntro = () => {
    const logoEl = $loader.find('.loader__logo')[0];
    // Pages without the intro (events.html) land the logo on the fixed
    // header wordmark instead.
    const targetEl = document.querySelector('.intro__logo') || document.querySelector('.header-logo');
    if (!logoEl || !targetEl) return;

    // Runs on mobile too now — the target (.intro__logo) sits under the video,
    // a slightly different spot than desktop (its calc uses 100vw/rem).

    const sourceRect = logoEl.getBoundingClientRect();
    const targetRect = targetEl.getBoundingClientRect();
    if (!sourceRect.width || !targetRect.width) return;

    document.body.appendChild(logoEl);
    logoEl.classList.remove('loader__logo');

    gsap.set(logoEl, {
      position: 'fixed',
      top: sourceRect.top,
      left: sourceRect.left,
      width: sourceRect.width,
      height: sourceRect.height,
      margin: 0,
      zIndex: 10002,
      x: 0,
      y: 0,
      scale: 1,
      transformOrigin: '50% 50%',
      force3D: true,
      willChange: 'transform, filter',
    });

    const dx = (targetRect.left + targetRect.width / 2) - (sourceRect.left + sourceRect.width / 2);
    const dy = (targetRect.top + targetRect.height / 2) - (sourceRect.top + sourceRect.height / 2);
    const scale = targetRect.width / sourceRect.width;

    // ONE logo in the air: the landing copy stays blank until the flight
    // docks (the intro's is already 0 by CSS; the header wordmark is not).
    gsap.set(targetEl, { opacity: 0 });

    const tl = gsap.timeline({
      onComplete: () => {
        gsap.set(targetEl, { opacity: 1 });
        logoEl.remove();
      },
    });

    tl.to(logoEl, {
      x: dx,
      y: dy,
      scale: scale,
      duration: 2,
      ease: 'power3.inOut',
    }, 0);

    tl.to(logoEl, {
      filter: 'brightness(0)',
      duration: 0.7,
      ease: 'power2.out',
    }, 0.8);
  };

  const finishLoader = () => {
    if (finished) return;
    finished = true;
    gsap.killTweensOf(display);
    // Soft settle from 99 → 100 as the curtain begins to rise.
    gsap.to(display, { value: 100, duration: 0.35, ease: 'power2.out', onUpdate: updateUI });

    flyLogoToIntro();

    const tl = gsap.timeline();
    tl.to($lastPhoto, {
      y: '-100vh',
      opacity: 0,
      duration: 1,
      ease: 'power3.inOut',
    });
    tl.to($loader, {
      y: '-100%',
      duration: 1.1,
      ease: 'power3.inOut',
      onComplete: () => {
        $loader.remove();
        lockPageScroll(false);
        if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
        revealIntro();
        window.bfLoaderDone = true;
        document.dispatchEvent(new CustomEvent('bf:loader-done'));
      },
    }, '-=0.7');
  };

  const onAssetDone = () => {
    loadedCount = Math.min(loadedCount + 1, totalAssets);
    if (loadedCount >= totalAssets) {
      assetsReady = true;
      maybeFinish();
    }
  };

  // Force-finish if assets stall past the hard cap (kills the counter, ticks to
  // 100, raises the curtain).
  setTimeout(() => {
    if (finished) return;
    assetsReady = true;
    counterDone = true;
    finishLoader();
  }, MAX_DURATION);

  startCounter();

  targetImages.forEach((img) => {
    if (img.complete) {
      onAssetDone();
    } else {
      const handler = () => {
        img.removeEventListener('load', handler);
        img.removeEventListener('error', handler);
        onAssetDone();
      };
      img.addEventListener('load', handler);
      img.addEventListener('error', handler);
    }
  });

  targetVideos.forEach((video) => {
    if (video.readyState >= 2) {
      onAssetDone();
    } else {
      const handler = () => {
        video.removeEventListener('loadeddata', handler);
        video.removeEventListener('error', handler);
        onAssetDone();
      };
      video.addEventListener('loadeddata', handler);
      video.addEventListener('error', handler);
      try { video.load(); } catch (e) {}
    }
  });
}
